import type { Translations } from './en';

// Validated against the English source-of-truth shape (`Translations = typeof en`).
export const de: Translations = {
  back: 'Zurück',
  save: 'Änderungen speichern',
  saveShort: 'Speichern',
  createShort: 'Erstellen',
  saving: 'Wird gespeichert…',
  loading: 'Lädt…',
  cancel: 'Abbrechen',
  ok: 'OK',
  confirm: 'Bestätigen',
  close: 'Schließen',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  no: 'Nein',
  error: 'Etwas ist schiefgelaufen',
  saved: 'Gespeichert',
  prevMonth: 'Vorheriger Monat',
  nextMonth: 'Nächster Monat',
  pickDate: 'Datum auswählen',

  signOut: 'Abmelden',
  signOutConfirm: 'Möchten Sie sich wirklich abmelden?',
  versionCopied: 'Version kopiert',
  versionCopyHint: 'Tippen, um Version zu kopieren',
  companyCredit:
    'Software und Urheberrecht im Besitz von Ninety Six Digital. Für weitere Informationen zu Werbung, Business-Management-Software und KI-Lösungen kontaktieren Sie uns über',
  companyCreditAnd: 'und',

  unsavedChangesTitle: 'Änderungen verwerfen?',
  unsavedChangesText: 'Sie haben nicht gespeicherte Änderungen. Möchten Sie diese verwerfen?',
  discardChanges: 'Verwerfen',

  payments: {
    title: 'Zahlungen',
    onlineTitle: 'Online-Zahlungsanbieter',
    intro:
      'Fertige Anbieter (PayPal, Menucat). Verbinde so viele du willst - jeder aktivierte Anbieter erscheint als eigene Auswahl an der Kasse, die Zahlung wird automatisch eingezogen und geht auf dein eigenes Konto.',
    paymentWindowTitle: 'Zahlungsfenster',
    paymentWindowFooter:
      'Wie lange eine unbezahlte Bestellung offen bleibt, damit der Kunde überweisen und den Beleg hochladen kann. Danach wird sie automatisch storniert und es kann kein Beleg mehr hochgeladen werden. Pro Bestellart einstellbar.',
    paymentWindowDialogTitle: 'Minuten zum Bezahlen (1–1440)',
    paymentWindowPrompt: (label: string) =>
      `Wie viele Minuten soll eine ${label}-Bestellung auf die Zahlung warten, bevor sie storniert wird?`,
    paymentWindowValue: (mins: number) => `Storno ${mins} Min. nach Bestellung`,
    paymentWindowSet: (label: string, mins: number) =>
      `${label}: unbezahlte Bestellungen werden nach ${mins} Min. storniert`,
    paymentWindowInvalid: 'Ganze Minutenzahl zwischen 1 und 1440 eingeben.',
    manualTitle: 'Selbst hinzugefügte Zahlungsmethoden',
    manualIntro:
      'Überweisung, VietQR oder E-Wallet, die du selbst einrichtest - du gibst Kontodaten und QR ein, der Kunde zahlt offline und lädt einen Beleg hoch. Anders als die Anbieter oben werden diese nicht automatisch eingezogen.',
    none: 'Noch kein Zahlungsanbieter verbunden.',
    connect: '+ Anbieter verbinden',
    update: 'Bearbeiten',
    live: 'Live',
    testMode: 'Testmodus',
    providerPaypal: 'PayPal Business',
    providerPaycat: 'Menucat (Kartenzahlung)',
    activatedToast: 'Jetzt für Online-Kasse aktiv',
    deactivatedToast: 'Online-Kasse deaktiviert',
    connectTitle: 'Anbieter verbinden',
    updateTitle: 'Verbindung bearbeiten',
    providerLabel: 'Anbieter',
    paypalChoice: 'PayPal Business',
    paycatChoice: 'Menucat',
    paypalCredsTitle: 'PayPal-API-Zugangsdaten',
    clientId: 'Client-ID',
    clientIdPlaceholder: 'Aus deiner PayPal-Business-App',
    secret: 'Secret',
    secretPlaceholder: 'App-Secret einfügen',
    webhookId: 'Webhook-ID (optional)',
    webhookIdPlaceholder: 'Aktiviert sofortige Zahlungsbestätigung',
    paypalFooter:
      'Erstelle eine REST-App in deinem PayPal-Business-Konto (Developer Dashboard) und füge hier ihre Client-ID und ihr Secret ein. Zahlungen gehen direkt auf dein PayPal-Konto.',
    webhookFooter:
      'Beim Verbinden wird der Webhook automatisch bei PayPal registriert, damit bezahlte Bestellungen sofort bestätigt werden – kein manueller Schritt nötig. Falls das nicht möglich ist, werden Bestellungen trotzdem bestätigt, nur etwas langsamer (Prüfung jede Minute).',
    paycatCredsTitle: 'Paycat-Zugangsdaten',
    serviceUrl: 'Service-URL',
    tenantId: 'Tenant-ID',
    tenantSecret: 'Tenant-Secret',
    settingsTitle: 'Einstellungen',
    useForCheckout: 'Für Online-Kasse verwenden',
    useForCheckoutHelp:
      'Bietet diesen Anbieter an der Kasse an. Anbieter laufen parallel - dies einzuschalten lässt die anderen an, und der Kunde wählt. Nur Test- und Live-Schlüssel DIESES Anbieters schließen sich gegenseitig aus.',
    settingsFooter:
      '„Für Online-Kasse verwenden“ bietet diesen Anbieter - im oben gewählten Modus - zusätzlich zu allen anderen an, die bereits laufen. Gib deine Live-Schlüssel mit aktivierter Option ein, um diesen Anbieter in einem Schritt live zu schalten.',
    errNoWhitespace: 'Entferne die Leerzeichen — API-Schlüssel enthalten keine.',
    errClientIdEmail:
      'Das sieht nach deiner PayPal-Login-E-Mail aus, nicht nach der Client-ID der REST-App.',
    errInvalidUrl: 'Gib eine gültige https://-Adresse ein.',
    errCheck: 'Bitte prüfen.',
    connectFailed: 'Der Zahlungsanbieter konnte nicht verbunden werden. Bitte versuche es erneut.',
    connectedToast: 'Zahlungsanbieter verbunden',
    unsavedTitle: 'Nicht gespeichert',
    unsavedText: (name) =>
      `Du hast Daten für ${name} eingegeben. Speichern oder verwerfen und wechseln?`,
    save: 'Speichern',
    discardSwitch: 'Verwerfen & wechseln',
    cancel: 'Abbrechen',
    disconnect: 'Trennen',
    disconnectConfirm:
      'Diesen Anbieter trennen? Die gespeicherten Zugangsdaten werden entfernt – zum erneuten Verbinden musst du sie neu eingeben.',
    disconnectedToast: 'Anbieter getrennt',
    notConnected: 'Nicht verbunden',
    connectShort: 'Verbinden',
    overwriteNote:
      'Dieser Anbieter ist bereits verbunden. Speichern überschreibt die gespeicherte Verbindung – pro Anbieter gibt es nur eine.',
    modeTest: 'Sandbox',
    modeLive: 'Live',
    stateConnected: 'Verbunden',
    stateActive: 'Aktiv - Kunden zahlen hier',
    sandboxBannerTitle: 'Sandbox-Modus ist aktiv',
    sandboxBannerBody:
      'Dein Shop läuft im SANDBOX-MODUS - Kunden wird KEIN echtes Geld belastet. Stelle den aktiven Anbieter auf Live, um echte Zahlungen anzunehmen.',
    modeSectionTitle: 'Sandbox- oder Live-Schlüssel',
    modeSectionFooter:
      'Wähle, welchen Schlüsselsatz du eingibst. Sandbox nutzt die Testumgebung des Anbieters und belastet nie echtes Geld; Live nimmt echte Zahlungen an. Du kannst beide speichern und jederzeit wechseln.',
    modeHasCreds:
      'Für diesen Modus sind bereits Schlüssel gespeichert - Speichern überschreibt sie.',
    modeNoCreds: 'Für diesen Modus sind noch keine Schlüssel gespeichert.',
    downgradeTitle: 'Zu Sandbox wechseln?',
    downgradeText:
      'Dein Shop nimmt dann KEIN echtes Geld mehr an und wechselt in den SANDBOX-Modus (Test). Fortfahren?',
    // ── Checkout badges: an owner-written pill beside ONE payment method ──
    badgesTitle: 'Hinweise an der Kasse',
    badgesFooter:
      'Ein kurzer Hinweis neben einer Zahlungsart an der Kasse, z. B. „Empfohlen“. Gäste sehen ihn genau so, wie Sie ihn eintippen.',
    badgeDialogTitle: 'Hinweis an der Kasse',
    badgePrompt: (method: string) =>
      `Text neben ${method} an der Kasse. Leer lassen, um den Hinweis zu entfernen.`,
    badgeNone: 'Kein Hinweis',
    badgeTooLong: (max: number) => `Höchstens ${max} Zeichen.`,
    badgeSetToast: (method: string) => `Hinweis bei ${method} gesetzt`,
    badgeClearedToast: (method: string) => `Hinweis bei ${method} entfernt`,
    badgeMethodCash: 'Bar',
    badgeMethodCardOnHandoff: 'Karte bei Abholung / Lieferung',
  },

  nav: {
    operations: 'Betrieb',
    functionality: 'Funktionen',
    reservations: 'Reservierungen',
    orders: 'Bestellungen',
    tables: 'Tische',
    customers: 'Kunde',
    menu: 'Menü',
    discount: 'Rabatt',
    reports: 'Berichte',
    customerService: 'Kundenservice',
    settings: 'Einstellungen',
    actionCenter: 'Aktionszentrum',
    pendingQueue: 'Warteschlange',
    aiAssistant: 'KI-Assistent',
    inbox: 'Posteingang',
    collapse: 'Einklappen',
    expand: 'Ausklappen',
  },

  views: {
    list: 'Liste',
    timeline: 'Zeitleiste',
    week: 'Woche',
    plan: 'Plan',
  },

  settings: {
    title: 'Einstellungen',
    searchSettings: 'Einstellungen suchen',
    dashboard: 'Dashboard',
    account: 'Konto',
    email: 'E-Mail',
    restaurant: 'Restaurant',
    reservations: 'Reservierungen',
    capacity: 'Kapazität',
    tables: 'Tische',
    tablePlan: 'Tischplan',
    menu: 'Speisekarte',
    menus: 'Speisekarten, Kategorien & Gerichte',
    myRestaurant: 'Mein Restaurant',
    storefront: 'Storefront',
    notifications: 'Benachrichtigungen',
    pushNotifications: 'Push-Benachrichtigungen',
    restaurantSetup: 'Unternehmensprofil',
    switchRestaurant: 'Restaurant wechseln',
    searchRestaurants: 'Restaurants suchen',
    noRestaurantsMatch: 'Keine Restaurants gefunden',
    switchRestaurantConfirm: 'Zu einem anderen Restaurant wechseln?',
    language: 'Sprache',
    mail: {
      title: 'Benachrichtigungen',
      reservationTitle: 'Reservierungen',
      reservationCustomer: 'Gäste über ihre Buchung per E-Mail benachrichtigen',
      reservationOwner: 'App-Benachrichtigung an Sie & Ihr Team bei neuen Buchungen',
      reservationOwnerEmail: 'E-Mail an Sie & Ihr Team bei neuen Buchungen',
      reservationReminder: 'Gästen eine Buchungserinnerung per E-Mail senden',
      customerPickupTitle: 'E-Mail an Kunden zu Abholbestellungen',
      customerDeliveryTitle: 'E-Mail an Kunden zu Lieferbestellungen',
      ownerPickupTitle: 'E-Mail an Sie & Ihr Team zu Abholbestellungen',
      ownerDeliveryTitle: 'E-Mail an Sie & Ihr Team zu Lieferbestellungen',
      pushPickupTitle: 'App-Benachrichtigung zu Abholbestellungen',
      pushDeliveryTitle: 'App-Benachrichtigung zu Lieferbestellungen',
      customerGroup: 'E-Mails an Kunden',
      ownerGroup: 'App-Benachrichtigung an Sie & Ihr Team',
      byOrderType: 'nach Bestellart',
      byPayment: 'nach Zahlungsart',
      ownerEmailGroup: 'E-Mail an Sie & Ihr Team',
      allMaster: 'Alle Zahlungsarten',
      cash: 'Bar',
      manual: 'Überweisung',
      online: 'Karte / PayPal',
      customerNote:
        'Aus = der Gast erhält für diese Zahlungsart keine E-Mail. Der Bestellstatus in der App wird weiterhin aktualisiert.',
      ownerNote:
        'Aus = keine Push- oder Postfach-Benachrichtigung an Sie und Ihr Team für neue so bezahlte Bestellungen.',
    },
  },

  notifications: {
    title: 'Push-Benachrichtigungen',
    statusTitle: 'Benachrichtigungsstatus',
    deviceIphone: 'Dieses iPhone oder iPad',
    deviceAndroid: 'Dieses Android-Gerät',
    deviceBrowser: 'Dieser Browser',
    statusOn: 'An',
    statusOnDetail: 'Sie erhalten Benachrichtigungen auf diesem Gerät in Echtzeit.',
    statusOff: 'Aus',
    statusOffDetail:
      'Benachrichtigungen sind noch nicht aktiviert. Aktivieren Sie sie, um in Echtzeit informiert zu werden.',
    statusBlocked: 'Blockiert',
    statusBlockedNative:
      'Benachrichtigungen sind blockiert. Aktivieren Sie sie für diese App in den Geräteeinstellungen.',
    statusBlockedWeb:
      'Benachrichtigungen sind blockiert. Aktivieren Sie sie in den Website-Einstellungen Ihres Browsers und laden Sie die Seite neu.',
    statusBrowserBlocked: 'Vom Browser blockiert',
    statusBrowserBlockedDetail:
      'Dieser Browser blockiert Push-Benachrichtigungen. Öffnen Sie in Brave Einstellungen → Datenschutz und Sicherheit und aktivieren Sie „Use Google services for push messaging“. Starten Sie Brave danach neu. Oder nutzen Sie Chrome oder die Handy-App.',
    statusUnsupported: 'Nicht unterstützt',
    statusUnsupportedDetail: 'Dieser Browser kann keine Push-Benachrichtigungen empfangen.',
    statusUnconfigured: 'Nicht verfügbar',
    statusUnconfiguredDetail: 'Push-Benachrichtigungen sind in diesem Build nicht eingerichtet.',
    statusChecking: 'Wird geprüft…',
    statusCheckingDetail: 'Benachrichtigungsberechtigung wird geprüft…',
    enableButton: 'Benachrichtigungen aktivieren',
    reservationSection: 'Reservierungen',
    newBooking: 'Neue Buchung',
    cancellation: 'Stornierung durch Gast',
    noShow: 'Nicht-Erscheinen-Alarm',
    orderSection: 'Online-Bestellungen',
    prepSection: 'Küchen-Timing',
    prepReminder: 'Erinnerung Zubereitungsstart',
    prepReminderHint:
      'Benachrichtigt Ihr Team, wenn eine vorbestellte Bestellung zubereitet werden muss - zurückgerechnet von der Abholzeit.',
    hint: 'Wählen Sie die Ereignisse, über die Sie in Echtzeit informiert werden möchten. Benachrichtigungen kommen nur an, solange der Status oben „An“ zeigt.',
    testSection: 'Testbenachrichtigung',
    testDelayTitle: 'Senden nach',
    testDelaySeconds: (n) => `${n} Sekunden`,
    testButton: 'Testbenachrichtigung senden',
    testHint:
      'Auf die Schaltfläche tippen und die App verlassen - die Testmeldung kommt nach der gewählten Verzögerung auf diesem Gerät an.',
    testPushTitle: 'Testbenachrichtigung',
    testPushBody: 'Push-Benachrichtigungen funktionieren auf diesem Gerät.',
    testScheduled: (n) => `Testmeldung unterwegs - kommt in ${n} Sekunden an.`,
    testNoDevice: 'Noch kein Gerät registriert. Schalte Benachrichtigungen zuerst ein.',
  },

  reservations: {
    pause: {
      cellLabel: 'Reservierungen',
      open: 'Geöffnet',
      off: 'Aus',
      pausedUntilClose: 'Pausiert · Schluss',
      pausedUntilTime: (time) => `Pausiert · ${time}`,
      action: {
        heading: 'Reservierungen',
        pause30: '30 Minuten pausieren',
        pause1hour: '1 Stunde pausieren',
        pauseHours: (n) => `${n} Stunden pausieren`,
        pauseUntilClose: 'Bis Geschäftsschluss pausieren',
        resumeNow: 'Jetzt fortsetzen',
        cancel: 'Abbrechen',
      },
      toast: {
        pausedFor: (minutes) => `Reservierungen für ${minutes} Min pausiert`,
        pausedUntilClose: 'Reservierungen bis Geschäftsschluss pausiert',
        resumed: 'Reservierungen fortgesetzt',
      },
    },
    title: 'Reservierungen',
    pending: 'Ausstehend',
    upcoming: 'Bevorstehend',
    today: 'Heute',
    newReservation: 'Neue Reservierung',
    detailTitle: 'Reservierung',
    guest: 'Gast',
    guests: 'Gäste',
    partyOf: 'Gruppe von',
    notes: 'Anmerkungen',
    all: 'Alle',
    filterAria: 'Filter',
    status: {
      PENDING: 'Ausstehend',
      CONFIRMED: 'Bestätigt',
      CANCELLED: 'Storniert',
      REJECTED: 'Abgelehnt',
      NO_SHOW: 'Nicht erschienen',
      ARRIVED: 'Angekommen',
      COMPLETED: 'Abgeschlossen',
    },
    actions: {
      confirm: 'Bestätigen',
      reject: 'Ablehnen',
      cancel: 'Stornieren',
      noShow: 'Nicht erschienen',
      arrived: 'Als angekommen markieren',
    },
    count: (n) => `${n} Reservierung${n !== 1 ? 'en' : ''}`,
    covers: (bookings, guests) =>
      `${bookings} Reservierung${bookings !== 1 ? 'en' : ''} · ${guests} Gäste`,
    peak: (time, guests) => `Stoßzeit ${time} · ${guests} Gäste`,
    nextWindow: (guests) => `Nächste 2 Std.: ${guests} Gäste`,
    guestsCount: (guests) => `${guests} Gäste`,
    guestsByHour: 'Gäste pro Stunde',
    nowLabel: 'Jetzt',
    slotCap: (n) => `max. ${n}/Slot`,
    advCap: (pacing, concurrent) => `${pacing}/15' · ${concurrent} gleichzeitig`,
    defaultShift: 'Standard',
    displayStatus: {
      pending: 'Ausstehend',
      confirmed: 'Bestätigt',
      rejected: 'Abgelehnt',
      cancelled: 'Storniert',
      rescheduled: 'Verschoben',
      waiting: 'Wartet',
      arrived: 'Angekommen',
      seated: 'Platziert',
      'in-progress': 'Läuft',
      completed: 'Abgeschlossen',
      'no-show': 'Nicht erschienen',
    },
    occasion: {
      BIRTHDAY: '🎂 Geburtstag',
      ANNIVERSARY: '💛 Jahrestag',
      DATE: '🌹 Date-Abend',
      BUSINESS: '💼 Geschäftlich',
    },
    seating: {
      WINDOW: 'Fensterplatz',
      OUTDOOR: 'Draußen',
      QUIET: 'Ruhige Ecke',
      BOOTH: 'Nische',
      BABY_CHAIR: 'Babystuhl',
      HIGH_CHAIR: 'Hochstuhl',
      WHEELCHAIR_ACCESS: 'Rollstuhlgerecht',
      GROUND_FLOOR: 'Erdgeschoss',
      NO_PREFERENCE: 'Keine Präferenz',
    },
    swipe: { accept: 'Annehmen', decline: 'Ablehnen' },
    toast: {
      confirmed: 'Reservierung bestätigt',
      rejected: 'Reservierung abgelehnt',
      cancelled: 'Reservierung storniert',
      arrived: 'Als angekommen markiert',
      seated: 'Als platziert markiert',
      inProgress: 'Als laufend markiert',
      completed: 'Als abgeschlossen markiert',
      noShow: 'Als nicht erschienen markiert',
    },
    errors: {
      confirm: 'Reservierung konnte nicht bestätigt werden.',
      reject: 'Reservierung konnte nicht abgelehnt werden.',
      cancel: 'Reservierung konnte nicht storniert werden.',
    },
    prompts: {
      rejectReason: 'Grund für die Ablehnung:',
      rejectTitle: 'Reservierung ablehnen',
      cancelConfirm: 'Diese Reservierung stornieren?',
      cancelTitle: 'Reservierung stornieren',
    },
    empty: {
      errorTitle: 'Fehler beim Laden der Reservierungen',
      errorDesc: 'Bitte versuchen Sie es erneut.',
      noneTitle: 'Keine Reservierungen',
      noneDesc: 'Keine Reservierungen für dieses Datum.',
      timelineTitle: 'Noch nichts zu zeigen',
      timelineDesc:
        'Fügen Sie Tische in der Kapazitätseinrichtung hinzu, dann erscheinen Buchungen hier als Balken.',
      planTitle: 'Noch keine Tische',
      planDesc:
        'Fügen Sie Tische unter Einstellungen → Reservierungseinrichtung hinzu, um den Grundriss zu sehen.',
    },
    pendingQueue: {
      title: (n) => `Ausstehend (${n})`,
      emptyTitle: 'Alles erledigt!',
      emptyDesc: 'Keine ausstehenden Reservierungen zu prüfen.',
      filterByDate: 'Nach Datum filtern',
      showAll: 'Alle anzeigen',
      emptyDateTitle: 'Keine an diesem Datum',
      emptyDateDesc: 'Keine ausstehenden Reservierungen für das gewählte Datum.',
    },
    source: {
      ONLINE: 'Online',
      PHONE: 'Telefon',
      WALK_IN: 'Laufkundschaft',
      THIRD_PARTY: 'Drittanbieter',
    },
    plan: {
      noZone: 'Keine Zone',
      seatCount: (seats) => `${seats} ${seats === 1 ? 'Sitzplatz' : 'Sitzplätze'}`,
      tableAria: (name, seats) => `Tisch ${name}, ${seats} Sitzplätze`,
    },
    timeline: {
      unzoned: 'Ohne Zone',
      unassignedCount: (n) => `Nicht zugewiesen · ${n}`,
    },
    week: {
      summary: (count, covers) => `${count} · ${covers}P`,
      none: 'Keine Buchungen',
    },
    detail: {
      labels: 'Labels',
      none: 'Keine Reservierung ausgewählt',
      noneDesc: 'Wählen Sie eine Reservierung aus der Liste, um die Details hier zu sehen.',
      notFound: 'Reservierung nicht gefunden',
      minutesShort: 'Min.',
      conflict: (n) =>
        n === 1
          ? '1 weitere Reservierung in diesem Zeitfenster'
          : `${n} weitere Reservierungen in diesem Zeitfenster`,
      call: 'Anrufen',
      message: 'Nachricht',
      phoneCopied: 'Telefonnummer kopiert',
      status: 'Status',
      specialRequests: 'Sonderwünsche',
      occasion: 'Anlass',
      seating: 'Sitzplatz & Zugang',
      guestInfo: 'Gastinformationen',
      phone: 'Telefon',
      email: 'E-Mail',
      source: 'Quelle',
      internalNote: 'Interne Notiz',
      cancellationReason: 'Stornierungsgrund',
      timeline: 'Verlauf',
      events: {
        created: 'Erstellt',
        confirmed: 'Bestätigt',
        arrived: 'Angekommen',
        completed: 'Abgeschlossen',
        cancelled: 'Storniert',
        noShow: 'Nicht erschienen',
      },
      aria: {
        close: 'Schließen',
        call: 'Gast anrufen',
        message: 'Gast benachrichtigen',
        edit: 'Buchung bearbeiten',
      },
    },
    menu: {
      confirm: 'Reservierung bestätigen',
      decline: 'Reservierung ablehnen',
      cancel: 'Reservierung stornieren',
      reactivate: 'Reservierung reaktivieren',
      markArrived: 'Als angekommen markieren',
      markSeated: 'Als platziert markieren',
      markNoShow: 'Als nicht erschienen markieren',
      markCompleted: 'Als abgeschlossen markieren',
      markNotStarted: 'Nicht begonnen',
      markInProgress: 'Läuft',
      markRescheduled: 'Verschieben',
    },
  },

  audit: {
    orderKind: {
      CREATED: 'Aufgegeben',
      CONFIRMED: 'Bestätigt',
      COMPLETED: 'Abgeschlossen',
      CANCELLED: 'Storniert',
      PROOF_UPLOADED: 'Zahlungsnachweis hochgeladen',
      PROOF_ACCEPTED: 'Zahlungsnachweis akzeptiert',
      PROOF_REJECTED: 'Zahlungsnachweis abgelehnt',
      PAYMENT_COLLECTED: 'Zahlung erhalten',
      PAYMENT_VOIDED: 'Zahlung storniert',
      REFUND_ISSUED: 'Rückerstattung veranlasst',
      PREP_REMINDER_SENT: 'Zubereitungserinnerung gesendet',
      PREP_ADVANCED: 'Zubereitung gestartet',
      PREP_RECALLED: 'Zubereitung zurückgesetzt',
    },
    reservationEvent: {
      CREATED: 'Erstellt',
      CONFIRMED: 'Bestätigt',
      REJECTED: 'Abgelehnt',
      CANCELLED_BY_GUEST: 'Vom Gast storniert',
      CANCELLED_BY_STAFF: 'Vom Personal storniert',
      MODIFIED: 'Geändert',
      REACTIVATED: 'Reaktiviert',
      AUTO_ARRIVED: 'Automatisch angekommen',
      AUTO_COMPLETED: 'Automatisch abgeschlossen',
      NO_SHOW_ALERTED: 'Nichterscheinen gemeldet',
      ARRIVAL_MARKED: 'Ankunft aktualisiert',
      STATUS_CHANGED: 'Status geändert',
    },
    actor: {
      OWNER: 'Inhaber',
      STAFF: 'Personal',
      CUSTOMER: 'Kunde',
      SYSTEM: 'System',
      GUEST: 'Gast',
    },
  },

  restaurantSetup: {
    title: 'Restaurant einrichten',
    basicInfo: 'Grundinformationen',
    hours: 'Öffnungszeiten',
    basicInfoSection: 'Grundinformationen',
    venueLanguageSection: 'Sprache',
    venueLanguage: 'Sprache des Lokals',
    venueLanguageFooter:
      'Die Sprache für gedruckte Bons und als Standard im Dashboard und im Online-Shop.',
    name: 'Restaurantname',
    namePlaceholder: 'Mein Restaurant',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Eine kurze Beschreibung für Kunden',
    address: 'Straße und Hausnummer',
    addressPlaceholder: 'Hauptstraße 1',
    postalCode: 'Postleitzahl',
    postalCodePlaceholder: '10115',
    city: 'Stadt',
    cityPlaceholder: 'Berlin',
    country: 'Land',
    contactEmail: 'Kontakt-E-Mail',
    contactEmailPlaceholder: 'hallo@restaurant.de',
    contactPhone: 'Kontakttelefon',
    contactPhonePlaceholder: '+49 30 1234567',
    contactPhoneInvalid: 'Gültige Telefonnummer wie +49 30 1234567 eingeben.',
    socialSection: 'Social Media & Website',
    facebookUrl: 'Facebook',
    facebookUrlPlaceholder: '@meinrestaurant',
    instagramUrl: 'Instagram',
    instagramUrlPlaceholder: '@meinrestaurant',
    tiktokUrl: 'TikTok',
    tiktokUrlPlaceholder: '@meinrestaurant',
    websiteUrl: 'Website',
    websiteUrlPlaceholder: 'meinrestaurant.de',
    socialFooter:
      'Wird Gästen in Ihrem Online-Shop angezeigt. Sie können den vollständigen Link oder nur Ihren Namen einfügen. Feld leer lassen, um ihn zu entfernen.',
    openingHours: 'Öffnungszeiten',
    closed: 'Geschlossen',
    openingHoursNote: 'Um die Öffnungszeiten zu bearbeiten, wenden Sie sich bitte an den Support.',
    saveFailed: 'Speichern fehlgeschlagen',
  },

  editReservation: {
    title: 'Reservierung bearbeiten',
    date: 'Datum',
    time: 'Uhrzeit',
    partySize: 'Personenzahl',
    duration: 'Dauer (Min.)',
    guestName: 'Name des Gastes',
    guestEmail: 'E-Mail des Gastes',
    guestPhone: 'Telefon des Gastes',
    internalNote: 'Interne Notiz',
    save: 'Speichern',
    sectionWhen: 'Zeit & Personen',
    sectionGuest: 'Gast',
    sectionOccasion: 'Anlass',
    sectionSeating: 'Sitzplatz & Zugang',
    sectionInternal: 'Intern',
    guestNamePlaceholder: 'Gastname',
    notePlaceholder: 'Notizen des Personals…',
    updated: 'Reservierung aktualisiert',
    updateFailed: 'Reservierung konnte nicht aktualisiert werden.',
  },

  createReservation: {
    fullName: 'Vollständiger Name',
    namePlaceholder: 'z. B. Max Mustermann',
    existingGuests: 'Vorhandene Gäste - zum Übernehmen tippen',
    searchExistingPlaceholder: 'Nach Name oder Telefon suchen…',
    change: 'Ändern',
    sectionBooking: 'Buchung',
    submit: 'Erstellen',
    created: 'Reservierung erstellt',
    createFailed: 'Reservierung konnte nicht erstellt werden. Bitte erneut versuchen.',
    nameRequired: 'Gastname ist erforderlich.',
    nameInvalid: 'Der Gastname darf keine Zahlen oder Sonderzeichen enthalten.',
    emailInvalid:
      'Gültige E-Mail wie name@example.com eingeben – keine Leerzeichen oder doppelten Punkte (..). Oder leer lassen.',
    phoneInvalid: 'Gültige Telefonnummer eingeben – 7 bis 14 Ziffern, ohne Landesvorwahl.',
    phoneRequired: 'Für telefonische Buchungen ist eine Telefonnummer erforderlich.',
    timeInPast:
      'Die Reservierungszeit liegt in der Vergangenheit. Bitte ein späteres Datum oder eine spätere Uhrzeit wählen.',
    timeRequired: 'Bitte eine Uhrzeit für die Reservierung eingeben.',
    optional: '(optional)',
    noRestaurant: 'Kein Restaurant ausgewählt.',
    returningGuest: (n: number) => `${n} frühere${n === 1 ? 'r' : ''} Besuch${n === 1 ? '' : 'e'}`,
    partySizeOverLimit: (max: number) => `Über dem Limit von ${max} Gästen`,
    partySizeOverLimitTitle: 'Große Gruppe',
    partySizeOverLimitConfirm: (max: number) =>
      `Diese Buchung liegt über dem Limit von ${max} Gästen. Trotzdem erstellen?`,
    slotFullWarning: 'Dieses Zeitfenster hat seine Kapazitätsgrenze erreicht.',
    slotFullTitle: 'Zeitfenster voll',
    slotFullConfirm:
      'Dieses Zeitfenster hat bereits seine Kapazitätsgrenze erreicht. Buchung trotzdem erstellen?',
  },

  aiAssistant: {
    title: 'Assistent',
    conversations: 'Unterhaltungen',
    archived: 'Archiviert',
    noConversations: 'Noch keine Unterhaltungen.',
    untitled: 'Neue Unterhaltung',
    newChat: 'Neuer Chat',
    threadActions: 'Aktionen für die Unterhaltung',
    loadingConversation: 'Unterhaltung wird geladen…',
    loadHistoryError: 'Diese Unterhaltung konnte nicht geladen werden.',
    loadThreadsError: 'Ihre Unterhaltungen konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    greetingTitle: 'Hallo',
    greetingBody: 'Wie kann ich Ihnen heute helfen?',
    attachImage: 'Bild anhängen',
    removeAttachment: 'Anhang entfernen',
    attachment: 'Bild',
    uploading: 'Wird hochgeladen…',
    uploadFailed: 'Upload fehlgeschlagen',
    inputPlaceholder: 'Nachricht an den Assistenten…',
    send: 'Senden',
    stop: 'Stoppen',
    sendFailed: 'Der Assistent konnte nicht antworten. Bitte erneut versuchen.',
    rename: 'Umbenennen',
    archive: 'Archivieren',
    unarchive: 'Wiederherstellen',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    deleteTitle: 'Diese Unterhaltung löschen?',
    threadActionFailed: 'Die Unterhaltung konnte nicht geändert werden.',
    approve: 'Genehmigen',
    deny: 'Ablehnen',
    approvalPending: 'Wartet auf Ihre Genehmigung',
    approvalDenied: 'Abgelehnt',
    approvalRunning: 'Wird angewendet…',
    approvalDone: 'Angewendet',
    approvalFailed: 'Änderung konnte nicht angewendet werden',
    toolWorking: 'Wird bearbeitet…',
    toolFailed: 'Fehlgeschlagen',
    tools: {
      get_menu: 'Speisekarte',
      get_item_availability: 'Verfügbarkeit',
      set_prices: 'Preise ändern',
      set_item_availability: 'Verfügbarkeit ändern',
      manage_products: 'Produkte bearbeiten',
      manage_categories: 'Kategorien bearbeiten',
      list_reservations: 'Reservierungen',
      get_reservation: 'Reservierungsdetails',
      check_availability: 'Verfügbarkeitsprüfung',
      create_reservation: 'Neue Reservierung',
      cancel_reservation: 'Reservierung stornieren',
      assign_tables: 'Tische zuweisen',
      search_customers: 'Kundensuche',
      get_customer: 'Kundendetails',
      create_customer: 'Neuer Kunde',
      get_opening_hours: 'Öffnungszeiten',
      get_profile: 'Restaurantprofil',
      update_opening_hours: 'Öffnungszeiten ändern',
      update_profile: 'Profil aktualisieren',
      toggle_online_ordering: 'Online-Bestellung',
      toggle_table_ordering: 'Tischbestellung',
      get_table_state: 'Tischstatus',
      list_open_tabs: 'Offene Rechnungen',
      get_session: 'Rechnungsdetails',
      fire_round: 'Gang abrufen',
      void_item: 'Artikel stornieren',
      take_payment: 'Zahlung erfassen',
      close_tab: 'Rechnung schließen',
      move_session: 'Rechnung verschieben',
      get_revenue: 'Umsatz',
      get_covers: 'Gäste',
      get_top_dishes: 'Top-Gerichte',
      get_peak_hours: 'Stoßzeiten',
    },
    summary: {
      price: (name, price) => `${name}: ${price}`,
      inStock: (name) => `${name}: verfügbar`,
      soldOut: (name) => `${name}: ausverkauft`,
      create: (name) => `„${name}“ anlegen`,
      update: (name) => `„${name}“ bearbeiten`,
      rename: (from, to) => `„${from}“ in „${to}“ umbenennen`,
      remove: (name) => `„${name}“ löschen`,
      reservation: (name, date, time, party) => `${name} · ${date} ${time} · ${party} Gäste`,
      tables: (name, tables) => `${name}: ${tables}`,
      hoursDay: (day, hours) => `${day}: ${hours}`,
      closed: 'geschlossen',
      on: 'An',
      off: 'Aus',
      pickup: 'Abholung',
      delivery: 'Lieferung',
      table: (label) => `Tisch ${label}`,
      move: (from, to) => `Tisch ${from} → Tisch ${to}`,
      cash: 'Bar',
      bankTransfer: 'Überweisung',
      tip: (amount) => `Trinkgeld: ${amount}`,
      profileFields: {
        name: 'Name',
        address: 'Adresse',
        phone: 'Telefon',
        email: 'E-Mail',
        description: 'Beschreibung',
      },
    },
    widgets: {
      reservationsTitle: (date) => `Reservierungen · ${date}`,
      reservationsSummary: (count, guests) => `${count} Buchungen · ${guests} Gäste`,
      noReservations: 'Keine Reservierungen.',
      partySize: (count) => `${count} Gäste`,
      status: {
        PENDING: 'Offen',
        CONFIRMED: 'Bestätigt',
        REJECTED: 'Abgelehnt',
        CANCELLED: 'Storniert',
      },
      revenueTitle: 'Umsatz',
      netSales: 'Nettoumsatz',
      grossSales: 'Bruttoumsatz',
      orders: 'Bestellungen',
      online: 'Online',
      dineIn: 'Vor Ort',
      covers: 'Gäste',
      tips: 'Trinkgeld',
      availabilityTitle: 'Verfügbarkeit',
      availabilitySummary: (total, soldOut) => `${total} Gerichte · ${soldOut} ausverkauft`,
      soldOut: 'Ausverkauft',
      inactive: 'Ausgeblendet',
    },
  },

  auth: {
    title: 'Restaurant-Dashboard',
    subtitle: 'Melden Sie sich an, um Ihr Restaurant zu verwalten',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'sie@restaurant.com',
    passwordLabel: 'Passwort',
    passwordPlaceholder: '••••••••',
    signInButton: 'Anmelden',
    validation: {
      emailPasswordRequired: 'Geben Sie Ihre E-Mail und Ihr Passwort ein.',
      invalidCredentials:
        'Diese E-Mail oder dieses Passwort funktioniert nicht. Bitte versuchen Sie es erneut.',
    },
    selectRestaurant: {
      title: 'Restaurant auswählen',
      loading: 'Ihre Restaurants werden geladen...',
      empty: 'Keine Restaurants gefunden',
      noAccess: 'Ihr Konto hat keinen Zugriff auf Restaurants.',
      loadError: 'Fehler beim Laden des Benutzerkontexts.',
    },
  },

  customers: {
    title: 'Kunden',
    searchPlaceholder: 'Nach Name, E-Mail oder Telefon suchen',
    loadingError: 'Kunden konnten nicht geladen werden',
    loadingErrorDescription: 'Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    noMatches: 'Keine Treffer',
    noMatchesDescription: 'Kein Kunde stimmt mit dieser Suche überein.',
    empty: 'Noch keine Kunden',
    emptyDescription: 'Kunden werden hier angezeigt, sobald sie buchen oder bestellen.',
    visitCount: (count) => `${count} Besuch${count === 1 ? '' : 'e'}`,
    create: {
      title: 'Neuer Kunde',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      email: 'E-Mail',
      dateOfBirth: 'Geburtsdatum',
      notes: 'Notizen',
      required: 'Erforderlich',
      optional: 'Optional',
      notesPlaceholder: 'Interne Notiz zu diesem Kunden',
      submit: 'Kunde hinzufügen',
      submitting: 'Wird hinzugefügt…',
      fixErrors: 'Bitte füllen Sie die Pflichtfelder aus.',
      requiredError: 'Dieses Feld ist erforderlich.',
      invalidEmail:
        'Geben Sie eine gültige E-Mail wie name@example.com ein (vollständige Adresse).',
      created: 'Kunde erstellt',
      createdPhoneError: 'Kunde erstellt - Telefonnummer konnte nicht gespeichert werden',
      createFailed: 'Kunde konnte nicht erstellt werden. Bitte erneut versuchen.',
    },
    detail: {
      title: 'Kunde',
      done: 'Fertig',
      loadingError: 'Kunde konnte nicht geladen werden',
      profile: 'Profil',
      firstName: 'Vorname',
      lastName: 'Nachname',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'Optional',
      dateOfBirth: 'Geburtsdatum',
      phoneNumbers: 'Telefonnummern',
      primary: 'Hauptnummer',
      noPhoneNumbers: 'Keine Telefonnummern',
      addPhoneButton: 'Telefonnummer hinzufügen',
      addPhoneDialog: 'Telefonnummer',
      phoneAdded: 'Telefonnummer hinzugefügt',
      removePhoneConfirm: (phone) => `Telefonnummer ${phone} löschen?`,
      removePhoneDialog: 'Telefonnummer löschen',
      phoneRemoved: 'Telefonnummer gelöscht',
      primarySet: 'Als Hauptnummer festgelegt',
      removeAction: 'Löschen',
      notes: 'Notizen',
      notesPlaceholder: 'Interne Notiz über diesen Kunden',
      activity: 'Aktivität',
      totalVisits: 'Gesamtbesuche',
      lastVisit: 'Letzter Besuch',
      status: 'Status',
      active: 'Aktiv',
      activeYes: 'Ja',
      activeNo: 'Nein',
      customerActivated: 'Kunde aktiviert',
      customerDeactivated: 'Kunde deaktiviert',
      name: 'Name',
      invalidValue: 'Ungültiger Wert',
      deleteCustomer: 'Kunde löschen',
      deleteCustomerFallback: 'diesen Kunden',
      deleteCustomerConfirm: (who) => `${who} löschen? Dadurch wird er aus Ihren Kunden entfernt.`,
      deleteCustomerTitle: 'Kunde löschen',
      customerDeleted: 'Kunde gelöscht',
    },
  },

  emailFeature: {
    validation: {
      recipientRequired: 'Bitte geben Sie eine Empfänger-E-Mail-Adresse ein.',
    },
  },

  giftCards: {
    title: 'Geschenkgutscheine',
    issueSection: 'Geschenkgutschein ausstellen',
    startingBalance: (currency) => `Anfangsguthaben (${currency})`,
    recipientName: 'Name des Empfängers (optional)',
    recipientNamePlaceholder: 'Max Mustermann',
    issuing: 'Wird ausgestellt…',
    issueCard: 'Gutschein ausstellen',
    couldntLoadCards: 'Geschenkgutscheine konnten nicht geladen werden',
    noCardsYet: 'Noch keine Geschenkgutscheine',
    noCardsDescription:
      'Stellen Sie einen vorausbezahlten Geschenkgutschein aus, den ein Gast gegen eine Restaurantrechnung einlösen kann. Tippen Sie +.',
    detailTitle: 'Geschenkgutschein',
    voidCardConfirm: (code) =>
      `${code} ungültig machen? Das verbleibende Guthaben verfällt und die Karte kann nicht mehr verwendet werden.`,
    voidCardTitle: 'Geschenkgutschein ungültig machen',
    enterNonZeroAmount: 'Geben Sie einen Betrag ungleich Null ein (prefix − zum Abziehen).',
    reasonRequired: 'Ein Grund ist erforderlich.',
    balanceAdjusted: 'Guthaben angepasst',
    code: 'Code',
    balance: 'Guthaben',
    initial: 'Ursprünglicher Betrag',
    status: 'Status',
    recipient: 'Empfänger',
    adjustBalance: 'Guthaben anpassen',
    voidCard: 'Gutschein ungültig machen',
    adjustment: (currency) => `Anpassung (${currency}, prefix − zum Abziehen)`,
    adjustmentPlaceholder: '10.00 oder -5.00',
    reason: 'Grund',
    reasonPlaceholder: 'Kulanzmaßnahme / Korrektur',
    applying: 'Wird angewendet…',
    apply: 'Anwenden',
    history: 'Verlauf',
    enterStartingBalance: 'Geben Sie ein Anfangsguthaben ein.',
    cardIssued: (code) => `Geschenkgutschein ${code} wurde ausgestellt`,
    couldntLoadCard: 'Karte konnte nicht geladen werden',
  },

  kitchen: {
    title: 'Küche',
    sourceOnline: 'Online-Bestellung',
    sourceDineIn: 'Vor Ort',
    bumpServed: 'Serviert',
    bumpStart: 'Starten',
    bumpReady: 'Bereit',
    recallAction: 'Zurückrufen',
    errorTitle: 'Board konnte nicht geladen werden',
    emptyTitle: 'Alles fertig',
    emptyDescription: 'Keine Tickets in der Warteschlange.',
    laneCooking: 'Zubereitung',
    laneReadyToServe: 'Bereit zum Servieren',
  },

  loyalty: {
    title: 'Treueprogramm',
    pointsBalance: 'Punktestand',
    entryType: {
      earned: 'Verdient',
      redeemed: 'Eingelöst',
      adjusted: 'Angepasst',
    },
    validation: {
      nonZeroAmount: 'Bitte geben Sie einen Betrag ungleich Null ein.',
      reasonRequired: 'Ein Grund ist erforderlich.',
    },
    pointsAdjusted: 'Punkte angepasst',
    adjustment: {
      label: 'Anpassung (Punkte, + oder −)',
      placeholder: 'z.B. 50 oder -20',
    },
    reason: {
      label: 'Grund',
      placeholder: 'Kulanz / Korrektur',
    },
    applyAdjustment: 'Anpassung anwenden',
    adjustPoints: 'Punkte anpassen',
    couldNotLoad: 'Treueeinstellungen konnten nicht geladen werden',
    program: 'Treueprogramm',
    earning: {
      title: 'Verdienen',
      label: (currency) => `${currency} ausgegeben - verdiente Punkte`,
      info: (currency) => `z.B. 1 Punkt pro ${currency} auf der Artikelzwischensumme`,
    },
    redemption: {
      title: 'Einlösung',
      label: (currency) => `1 Punkt wert (${currency} Rabatt)`,
      placeholder: '0.10',
      info: 'Gäste lösen Punkte gegen Rabatt an der Kasse ein',
    },
    settingsSaved: 'Treueeinstellungen gespeichert',
    info: {
      note: 'Punkte werden auf die Artikelzwischensumme eines abgeschlossenen Auftrags oder Restaurantbesuchs verdient (ohne Lieferung, Steuern und Trinkgeld). Die Einlösung wird als Rabatt auf die nächste Bestellung angewendet.',
    },
  },

  menu: {
    title: 'Menü',
    noMenusYet: 'Noch keine Menüs',
    createMenuDescription: 'Erstellen Sie ein Menü, um Abschnitte und Gerichte hinzuzufügen.',
    createMenu: 'Menü erstellen',
    menuNamePrompt: 'Menüname (Englisch)',
    newMenu: 'Neues Menü',
    menuCreated: 'Menü erstellt',
    renameMenu: 'Menü umbenennen',
    editMenuNameAvailability: 'Name & Verfügbarkeit bearbeiten',
    renamed: 'Umbenannt',
    cantDeleteActiveMenu: 'Das aktive Menü kann nicht gelöscht werden',
    deleteMenuConfirm: (menuName) =>
      `"${menuName}" und alle seine Abschnitte und Gerichte löschen?`,
    deleteMenu: 'Menü löschen',
    setAsActiveMenu: 'Als aktives Menü festlegen',
    isNowActive: (menuName) => `"${menuName}" ist jetzt aktiv`,
    activeMenuInfo:
      'Nur das aktive Menü wird den Kunden angezeigt. Tippen Sie auf ein Menü, um seine Abschnitte und Gerichte zu bearbeiten.',
    active: 'Aktiv',
    rename: 'Umbenennen',
    newCategory: 'Neue Kategorie',
    editCategory: 'Kategorie bearbeiten',
    categoryName: 'Name',
    categoryDescription: 'Beschreibung',
    channelVisibility: 'In Bestellkanälen anzeigen',
    channelVisibilityHelp:
      'Ausschalten, um diesen Abschnitt (und seine Artikel) für diese Bestellart auszublenden.',
    showOnPickup: 'Bei Abholung anzeigen',
    showOnDelivery: 'Bei Lieferung anzeigen',
    nameRequired: 'Name erforderlich',
    availabilitySchedule: 'Verfügbarkeitsplan',
    restrictToCertainTimes: 'Auf bestimmte Zeiten beschränken',
    window: (index) => `Fenster ${index}`,
    from: 'Von',
    to: 'Bis',
    addWindow: '+ Fenster hinzufügen',
    scheduleNote:
      'Zeitpläne verwenden die Zeitzone des Restaurants und sind unabhängig von den Öffnungszeiten.',
    emptyMenu: 'Leeres Menü',
    addCategoryDescription:
      'Fügen Sie eine Kategorie wie Getränke, Hauptgänge oder Desserts hinzu.',
    addCategory: 'Kategorie hinzufügen',
    dragToReorder: 'Ziehen Sie, um Kategorien neu zu ordnen',
    renameMenuTooltip: 'Menü umbenennen',
    doneReordering: 'Neu ordnen abgeschlossen',
    reorderSections: 'Kategorien neu ordnen',
    archivedItems: 'Archivierte Artikel',
    archivedItemsTitle: 'Archivierte Artikel',
    archivedItemsEmpty: 'Keine archivierten Artikel',
    archivedItemsHint:
      'Gelöschte Artikel werden hier aufbewahrt. Stelle einen wieder her, um ihn zurück auf die Speisekarte zu bringen.',
    restore: 'Wiederherstellen',
    itemRestored: 'Artikel wiederhergestellt',
    reorderOptions: 'Optionen neu ordnen',
    dragToReorderOptions: 'Ziehen Sie, um Optionen neu zu ordnen',
    deleteMenuConfirmText: (menuName) => `"${menuName}" und alles darin löschen?`,
    inactiveMenuNote:
      'Dieses Menü ist nicht aktiv - Kunden sehen es noch nicht. Verwenden Sie ⋯, um es zu aktivieren.',
    menuActivated: 'Menü aktiviert',
    addItem: 'Element hinzufügen',
    searchItems: 'Gerichte suchen',
    jumpToSection: 'Zum Bereich springen',
    noItemsMatch: 'Keine Treffer',
    addMultiple: 'Mehrere Artikel hinzufügen',
    newProducts: 'Neue Produkte',
    allergenLabeling: {
      title: 'Allergene & Zusatzstoffe',
      sectionTitle: 'Allergen-Kennzeichnung',
      sectionHelp:
        'Richten Sie die Allergene und Zusatzstoffe ein, die bei Ihren Gerichten angezeigt werden.',
      sectionSubtitle: 'Ihre Allergenübersicht und Code-Liste',
      modeHeading: 'Wie Sie Allergene kennzeichnen',
      modeNote: 'Wählen Sie, wie dieses Restaurant Allergene angibt. Jederzeit umschaltbar.',
      aboutMode: (title: string) => `Über ${title}`,
      simpleTitle: 'Freie Übersicht',
      simpleFeatures: [
        'Text einfügen oder ein Foto hochladen',
        'Gäste sehen es genau wie geschrieben',
        'Am einfachsten — nichts einzurichten',
      ],
      simpleDetails:
        'Ihre gedruckte Allergen-/Zusatzstoffliste — Text oder Foto — wird den Gästen als Quelle der Wahrheit gezeigt. Nichts wird ausgewertet.',
      advancedTitle: 'Code-Liste',
      advancedFeatures: [
        'Eine Liste Ihrer Codes und Bedeutungen',
        'Gerichte verweisen auf Ihre Codes',
        'Sauberere Kennzeichnung pro Gericht',
      ],
      advancedDetails:
        'Führen Sie eine strukturierte Liste Ihrer Codes (z. B. a = Gluten). Kennzeichnen Sie jedes Gericht mit seinen Codes; Gäste sehen den Code und seine Bedeutung.',
      originTextLabel: 'Text oder Hinweise',
      originTextPlaceholder: 'Legende als Text einfügen oder Hinweise zum Foto ergänzen…',
      originImageTitle: 'Foto der Übersicht',
      notesHint:
        'Optional. Zusammen mit dem Foto — z. B. „Die Symbole S und R bedeuten Schwein und Rind“.',
      uploadImage: 'Foto hochladen',
      replaceImage: 'Foto ersetzen',
      removeImage: 'Entfernen',
      imageFailed: 'Bild-Upload fehlgeschlagen',
      tableTitle: 'Code-Liste',
      previewTitle: 'Code-Vorschau',
      previewHint: 'Aus Ihrer Übersicht. Wechseln Sie zu „Code-Liste“, um zu bearbeiten.',
      previewEmptyText:
        'Codes erscheinen hier, sobald sie in der Code-Liste hinzugefügt (oder im Chat aus Ihrer Übersicht gelesen) wurden.',
      emptyTitle: 'Noch keine Codes',
      keyPlaceholder: 'Code',
      descPlaceholder: 'Beschreibung',
      addRow: 'Code hinzufügen',
      removeRow: 'Code entfernen',
      saved: 'Gespeichert',
      saveFailed: 'Speichern fehlgeschlagen',
      parseFailed:
        'Gespeichert, aber die Codes konnten nicht gelesen werden. Erneut speichern oder in der Code-Liste hinzufügen.',
      duplicateKey: (key: string) => `Doppelter Code: ${key}`,
      kindLabel: (k: 'ALLERGEN' | 'ADDITIVE' | 'DIETARY'): string =>
        ({ ALLERGEN: 'Allergen', ADDITIVE: 'Zusatzstoff', DIETARY: 'Ernährung' })[k],
    },
    productForm: {
      noAllergenTable: 'Noch keine Allergen-Tabelle.',
      setUpAllergenTable: 'Einrichten',
      searchAllergenCodes: 'Codes suchen…',
      editAllergenCodes: 'Codes bearbeiten',
      general: 'Allgemein',
      name: 'Name',
      code: 'Artikelnummer',
      editCode: 'Artikelnummer bearbeiten',
      noCode: 'Keine',
      codePlaceholder: 'z. B. A12',
      codeTakenBy: (dish: string) => `Nummer bereits vergeben an „${dish}“`,
      description: 'Beschreibung',
      basePrice: 'Grundpreis',
      newProduct: 'Neues Produkt',
      editName: 'Name bearbeiten',
      editDescription: 'Beschreibung bearbeiten',
      options: 'Optionen',
      optionName: 'Optionsname',
      optionNamePlaceholder: 'z. B. Größe, Beläge',
      required: 'Erforderlich',
      allowMultiple: 'Mehrfachauswahl erlauben',
      selectionLimits: 'Auswahlgrenzen',
      minToPick: 'Minimum wählen',
      maxToPick: 'Maximum wählen (leer = kein Limit)',
      choiceName: 'Auswahlname',
      choiceNamePlaceholder: 'z. B. Groß, Extra Käse',
      extraPrice: 'Aufpreis',
      defaultSelection: 'Standardauswahl',
      addChoice: 'Auswahl hinzufügen',
      deleteChoice: 'Auswahl löschen',
      noChoices: 'Noch keine Auswahl',
      availability: 'Verfügbarkeit',
      visibleToCustomers: 'Für Kunden sichtbar',
      hiddenChoicesFooter: 'Ausgeblendete Auswahlen werden Kunden nicht angezeigt',
      hiddenProductsFooter: 'Ausgeblendete Produkte erscheinen gar nicht auf der Karte',
      inStock: 'Auf Lager',
      outOfStockChoicesFooter:
        'Nicht vorrätige Auswahlen werden angezeigt, sind aber nicht bestellbar',
      outOfStockProductsFooter:
        'Nicht vorrätige Produkte werden angezeigt, sind aber nicht bestellbar',
      allergens: 'Allergene',
      labels: 'Labels',
      pricing: 'Preise',
      channelPrice: 'Kanalpreis',
      channelPrices: 'Kanalpreise',
      dineIn: 'Vor Ort',
      pickup: 'Abholung',
      delivery: 'Lieferung',
      photo: 'Foto',
      addPhoto: 'Foto hinzufügen',
      replacePhoto: 'Foto ersetzen',
      removePhoto: 'Foto entfernen',
      photoTooLarge: 'Dieses Bild ist zu groß. Bitte verwenden Sie eines unter 10 MB.',
      photoWrongType: 'Nicht unterstütztes Bildformat. Verwenden Sie JPEG, PNG, WebP oder HEIC.',
      photoUploadFailed: 'Das Foto konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    },
    hideCategory: 'Kategorie ausblenden',
    showCategory: 'Kategorie anzeigen',
    deleteCategory: 'Kategorie löschen',
    deleteCategoryConfirm: (categoryName) => `"${categoryName}" und ihre Gerichte löschen?`,
    hidden: 'verborgen',
    outOfStock: 'Ausverkauft',
    plusAddItem: '+ Element hinzufügen',
    newProduct: 'Neues Produkt',
    optionName: 'Name der Option',
    optionNamePlaceholder: 'z.B. Größe, Toppings',
    required: 'Erforderlich',
    allowMultipleSelections: 'Mehrfachauswahl zulassen',
    minimumToPick: 'Mindestanzahl zum Auswählen',
    maximumToPick: 'Maximale Auswahl (leer = unbegrenzt)',
    guestsPickRange: 'Gäste wählen innerhalb des Min./Max.-Bereichs.',
    guestsPickOne: (required) => `Gäste wählen genau eine${required ? '.' : ' (oder keine).'}`,
    selectionMode: 'Auswahlart',
    pickOneMode: 'Einzelauswahl',
    pickManyMode: 'Mehrfachauswahl',
    guestsPickAny: 'Gäste wählen beliebig viele (oder keine).',
    newChoice: 'Neue Wahl',
    editChoice: 'Wahl bearbeiten',
    choiceName: 'Name der Wahl',
    choiceNamePlaceholder: 'z.B. Groß, Extra Käse',
    extraPrice: 'Zusatzpreis',
    defaultSelection: 'Standardauswahl',
    visibleToCustomers: 'Für Kunden sichtbar',
    inStock: 'Im Bestand',
    allergens: 'Allergene',
    deleteChoice: 'Wahl löschen',
    deleteChoiceConfirm: (choiceName) => `Wahl "${choiceName}" löschen?`,
    noChoicesYet: 'Noch keine Wahlen',
    addChoice: 'Wahl hinzufügen',
    default: 'Standard',
    outOfStockChip: 'Ausverkauft',
    hiddenChip: 'Verborgen',
    editOption: 'Option bearbeiten',
    deleteOption: 'Option löschen',
    deleteOptionConfirm: (optionName) => `Option "${optionName}" und ihre Wahlen löschen?`,
    pricing: 'Preisgestaltung',
    basePrice: 'Basispreis',
    basePriceFooter:
      'Der Standard-Listenpreis. Kanalspezifische Preislisten (Lieferung/Abholung) setzen ihn außer Kraft, wo festgelegt.',
    noOverridesYet:
      'Preislisten pro Kanal (Lieferung, Abholung...) werden separat konfiguriert; dieses Produkt hat noch keine Überschreibungen.',
    noDescription: 'Keine Beschreibung',
    general: 'Allgemein',
    options: 'Optionen',
    noOptionsYet: 'Noch keine Optionen - dieses Produkt wird wie folgt bestellt.',
    addOption: '+ Option hinzufügen',
    newOptions: 'Neue Optionen',
    newChoices: 'Neue Auswahlmöglichkeiten',
    saveAllOptions: 'Alle speichern',
    optionsSaved: 'Optionen gespeichert',
    optional: 'Optional',
    optionNeedsChoice: 'Füge mindestens eine Auswahl hinzu, bevor du diese Option speicherst.',
    optionEditHint: 'Eine Auswahl ohne Preis verursacht keinen Aufpreis.',
    optionLimits: {
      pickSeveral: 'Mehrere wählbar',
      limitHowMany: 'Anzahl begrenzen',
      minimum: 'Minimum',
      maximum: 'Maximum',
      minPrompt: (lo: number, hi: number) =>
        `Wie viele müssen Gäste mindestens wählen? (${lo} bis ${hi})`,
      maxPrompt: (lo: number, hi: number) =>
        `Wie viele können Gäste höchstens wählen? (${lo} bis ${hi})`,
      notSaved: 'Nicht gespeichert',
      notInteger: 'Nicht gespeichert. Bitte eine ganze Zahl eingeben.',
      outOfRange: (field: string, lo: number, hi: number) =>
        `Nicht gespeichert. ${field} muss ${lo} bis ${hi} sein.`,
      minAboveMax: (max: number) =>
        `Nicht gespeichert. Das Minimum darf nicht größer als das Maximum (${max}) sein.`,
      maxBelowMin: (min: number) =>
        `Nicht gespeichert. Das Maximum darf nicht kleiner als das Minimum (${min}) sein.`,
      summary: {
        exactly: (n: number) => `Gäste müssen genau ${n} wählen`,
        upTo: (n: number) => `Gäste wählen bis zu ${n}`,
        range: (min: number, max: number) => `Gäste wählen ${min} bis ${max}`,
        atLeast: (n: number) => `Gäste wählen mindestens ${n}`,
        any: 'Gäste können beliebig viele oder keine wählen',
      },
      phrase: {
        exactly: (n: number) => `${n} wählen`,
        upTo: (n: number) => `bis zu ${n}`,
        range: (min: number, max: number) => `${min}-${max} wählen`,
        atLeast: (n: number) => `mindestens ${n} wählen`,
        any: 'beliebig wählen',
      },
      stockWarning: (inStock: number, total: number) =>
        `Nur ${inStock} von ${total} vorrätig - Gäste können dies erst nach dem Auffüllen bestellen.`,
      legacy: {
        minAboveN: (min: number, n: number) =>
          `Das Minimum (${min}) ist größer als die ${n} Auswahlmöglichkeiten dieser Gruppe.`,
        maxAboveN: (max: number, n: number) =>
          `Das Maximum (${max}) ist größer als die ${n} Auswahlmöglichkeiten dieser Gruppe.`,
        minAboveMax: (min: number, max: number) =>
          `Das Minimum (${min}) ist größer als das Maximum (${max}).`,
      },
      fixRule: 'Regel korrigieren',
      clampTitle: 'Limit senken?',
      clampBody: (option: string, choice: string, n: number, rule: string) =>
        `${option}: ${rule}. Ohne ${choice} bleiben nur ${n} Auswahlmöglichkeiten, daher:`,
      clampChange: {
        min: (n: number) => `Das Minimum wird auf ${n} gesetzt.`,
        max: (n: number) => `Das Maximum wird auf ${n} gesetzt.`,
        both: (n: number) => `Minimum und Maximum werden auf ${n} gesetzt.`,
      },
      lowerAndDelete: (n: number) => `Auf ${n} senken und löschen`,
    },
    optionNameRequiredAll: 'Bitte für jede Option einen Namen eingeben, bevor du speicherst.',
    optionNameDuplicate: (name: string) =>
      `Die Option „${name}“ hat einen doppelten Namen. Jede Option muss einen anderen Namen haben.`,
    choiceNameRequiredAll: 'Bitte für jede Auswahl einen Namen eingeben, bevor du speicherst.',
    choiceNameDuplicate: (name: string) =>
      `Die Auswahl „${name}“ hat einen doppelten Namen. Jede Auswahl muss einen anderen Namen haben.`,
    addOptionHint:
      'Jede Option ist eine Gruppe von Auswahlmöglichkeiten (z. B. Größe, Topping). Füge mehrere Gruppen hinzu und tippe auf „Alle speichern“; die Werte darin fügst du nach dem Speichern hinzu.',
    availability: 'Verfügbarkeit',
    visibleToCustomersFooter: 'Versteckte Produkte erscheinen überhaupt nicht im Menü',
    inStockFooter: 'Nicht verfügbare Produkte werden angezeigt, können aber nicht bestellt werden',
    labels: 'Etiketten',
    editName: 'Namen bearbeiten',
    editDescription: 'Beschreibung bearbeiten',
    createProduct: 'Produkt erstellen',
    productCreated: 'Produkt erstellt',
    missingCategory: 'Fehlender Abschnitt - öffnen Sie dies aus einem Menüabschnitt.',
    createProductNoteFooter:
      'Sie können nach der Erstellung eine Beschreibung, Allergene, Etiketten und Optionen hinzufügen.',
    deleteProduct: 'Produkt löschen',
    deleteProductConfirm: (productName) => `"${productName}" und alles darin löschen?`,
    product: 'Produkt',
    productNotFound: 'Produkt nicht gefunden.',
    englishNameRequired: 'Name erforderlich.',
    englishValueRequired: 'English Value erforderlich',
    fieldRequired: 'Dieses Feld ist erforderlich',
    newOption: 'Neue Option',
    channelPriceEditTitle: (channel: string) => `${channel}-Preis`,
    channelPricesFooter:
      'Der Preis vor Ort ist der Standardpreis. Lassen Sie Abholung oder Lieferung leer, um ihn zu verwenden, oder geben Sie einen Betrag ein, um für diesen Kanal einen anderen Preis zu berechnen.',
    pricesSaved: 'Preise gespeichert',
    overridesBaseFooter: (base: string) =>
      `Überschreibt den Grundpreis (${base}) nur für diesen Kanal. Löschen Sie ihn, um auf den Grundpreis zurückzufallen.`,
    useBasePrice: 'Grundpreis verwenden',
    basePriceSectionFooter:
      'Der Standardpreis sowie optionale separate Preise für Abholung und Lieferung.',
    priceFree: 'Kostenlos',
    failedToLoad: 'Menü konnte nicht geladen werden',
    notLiveAnywhereNote:
      'Dieses Menü ist auf keinem Bestellkanal aktiv - Kunden sehen es noch nicht. Wählen Sie es für einen Kanal unter Menü → Aktive Menüs aus.',
    itemColumn: 'Artikel',
    priceColumn: 'Preis',
    priceFrom: 'ab',
    optionsCount: (n: number) => `${n} Option${n === 1 ? '' : 'en'}`,
    allMenus: 'Alle Menüs',
    allMenusHelp:
      'Das Panel oben legt fest, welches Menü jeder Kanal aktuell zeigt. Tippen Sie auf ein Menü, um seine Abschnitte & Gerichte zu bearbeiten.',
    editMenu: 'Menü bearbeiten',
    liveMenus: 'Aktive Menüs',
    liveMenu: 'Aktives Menü',
    differentMenuPerChannel: 'Unterschiedliches Menü pro Kanal',
    assignMenuPerChannelHelp: 'Legen Sie fest, welches Menü jeder Bestellkanal zeigt.',
    liveMenuHelp: 'Das Menü, das Kunden bei Vor-Ort, Abholung und Lieferung sehen.',
    menuFieldLabel: 'Menü',
    mixed: 'Gemischt',
    noneHidden: 'Keins - ausgeblendet',
    noSelection: 'Keine',
    selectedCount: (n: number) => `${n} ausgewählt`,
    category: 'Kategorie',
    items: 'Artikel',
    addCategoryFirst: 'Fügen Sie zuerst eine Kategorie hinzu.',
    addCategoryFirstThenItems: 'Fügen Sie zuerst eine Kategorie hinzu und dann Artikel dazu.',
    itemNameRequiredForPrice: 'Für jeden Artikel mit einem Preis ist ein Name erforderlich.',
    enterAtLeastOneItem: 'Geben Sie mindestens einen Artikelnamen ein.',
    itemsAddedToast: (n: number) => `${n} Artikel hinzugefügt`,
    itemNamePlaceholder: 'Artikelname *',
    basePriceAriaLabel: (currency: string) => `Grundpreis (${currency})`,
    removeItem: 'Entfernen',
    addRow: 'Zeile hinzufügen',
    addAnotherItem: 'Weiteren Artikel hinzufügen',
    simpleMode: 'Mehrere Artikel',
    advancedMode: 'Ein Artikel im Detail',
    groupName: 'Gruppenname',
    requiredGroupDefault: 'Erforderlich',
    requiredChoicesHint: 'Mindestens 1 wählen',
    optionalChoicesHint: 'Optional',
    optionalGroupDefault: 'Optional',
    dayLabelsShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  },

  menuQuickEdit: {
    placeholder: 'KI fragen, z. B. „Pizzen um 5 % erhöhen“',
    fullMenu: 'Ganzes Menü',
    productPlaceholder: 'KI fragen, z. B. „Extra Käse für 1,50 hinzufügen“',
    tagNew: 'Neu',
    tagRemoved: 'Entfernt',
    tagMoved: 'Verschoben',
    shown: 'Sichtbar',
    hidden: 'Ausgeblendet',
    inStock: 'Vorrätig',
    soldOut: 'Ausverkauft',
    isDefault: 'Standard',
    notDefault: 'Kein Standard',
    basePrice: 'Grundpreis',
    hours: 'Zeiten',
    always: 'Immer',
    allergens: 'Allergene',
    labels: 'Labels',
    order: 'Reihenfolge',
    pickup: 'Abholung',
    delivery: 'Lieferung',
    none: 'keine',
    rules: {
      required: 'Pflicht',
      optional: 'optional',
      pickOne: '1 wählen',
      pickAny: 'beliebig viele',
      pickUpTo: (n: number) => `bis zu ${n} wählen`,
      pickAtLeast: (n: number) => `mindestens ${n} wählen`,
      pickRange: (min: number, max: number) => `${min}–${max} wählen`,
    },
    summary: {
      items: (n: number) => `${n} Artikel`,
      sections: (n: number) => `${n} ${n === 1 ? 'Bereich' : 'Bereiche'}`,
      prices: (n: number) => `${n} ${n === 1 ? 'Preis' : 'Preise'}`,
      added: (n: number) => `${n} neu`,
      removed: (n: number) => `${n} entfernt`,
      renamed: (n: number) => `${n} umbenannt`,
      descriptions: (n: number) => `${n} ${n === 1 ? 'Beschreibung' : 'Beschreibungen'}`,
      moved: (n: number) => `${n} verschoben`,
      stock: (n: number) => `${n}× Verfügbarkeit`,
      visibility: (n: number) => `${n}× Sichtbarkeit`,
      allergens: (n: number) => `${n}× Allergene`,
      labels: (n: number) => `${n}× Labels`,
      hours: (n: number) => `${n}× Zeiten`,
      rules: (n: number) => `${n}× Gruppenregeln`,
      defaults: (n: number) => `${n}× Standardauswahl`,
    },
  },

  promotionsQuickEdit: {
    placeholder: 'KI fragen, z. B. „10 % Rabatt auf Abholung Di–Do ab 17:00“',
    restoredTag: 'Wiederhergestellt',
    summary: {
      created: (n: number) => `${n} neu`,
      updated: (n: number) => `${n} geändert`,
      archived: (n: number) => `${n} archiviert`,
      restored: (n: number) => `${n} wiederhergestellt`,
    },
    conflict: {
      replaces: (example: string, other: string) => `${example}: ersetzt „${other}“`,
      stacks: (example: string, other: string) => `${example}: addiert sich mit „${other}“`,
      loses: (example: string, other: string) =>
        `${example}: „${other}“ gibt mehr, daher greift diese nicht`,
    },
  },

  exceptionsQuickEdit: {
    placeholder: 'KI fragen, z. B. „an Weihnachten schließen“',
    summary: {
      created: (n: number) => `${n} neu`,
      updated: (n: number) => `${n} geändert`,
      removed: (n: number) => `${n} entfernt`,
    },
  },

  aiChangeset: {
    propose: 'Änderungen entwerfen',
    proposing: 'Änderungen werden entworfen…',
    previousChange: 'Vorherige Änderung',
    nextChange: 'Nächste Änderung',
    changesOnly: 'Nur Änderungen',
    apply: 'Übernehmen',
    discard: 'Verwerfen',
    staleNotice: (items: string) => `Inzwischen geändert, bitte erneut prüfen: ${items}`,
    appliedToast: (n: number) => `${n} ${n === 1 ? 'Änderung' : 'Änderungen'} übernommen`,
    appliedPartialToast: (applied: number, total: number) =>
      `Nur ${applied} von ${total} Änderungen übernommen, bitte den Rest prüfen`,
    undo: 'Rückgängig',
    undoneToast: 'Änderungen rückgängig gemacht',
    undoStale: 'Nichts rückgängig gemacht: Einige Artikel wurden inzwischen geändert.',
  },

  aiDock: {
    menuTitle: 'Speisekarten-KI',
    exceptionsTitle: 'Feiertags-KI',
    promotionsTitle: 'Rabatt-KI',
    productTitle: 'Gericht-KI',
    sharedWithTeam: 'Mit deinem Team geteilt',
    expand: 'KI-Unterhaltung anzeigen',
    collapse: 'KI-Unterhaltung ausblenden',
    attach: 'Foto oder PDF anhängen',
    send: 'Senden',
    removeAttachment: 'Anhang entfernen',
    uploading: 'Wird hochgeladen…',
    readingStart: 'Speisekarte wird gelesen…',
    readingPage: (page: number, total: number) => `Seite ${page} von ${total} wird gelesen…`,
    dishesSoFar: (n: number) =>
      `${n} ${n === 1 ? 'Gericht' : 'Gerichte'} bisher · du kannst die Seite verlassen`,
    importFailed: 'Die Speisekarte konnte nicht gelesen werden.',
    pagesNotRead: (pages: string) =>
      `Nicht lesbar: ${pages}. Hänge die Seite an und bitte die KI, ihre Gerichte hinzuzufügen.`,
    lockedByOther: 'Jemand anderes bearbeitet gerade mit KI. Versuche es gleich noch einmal.',
    loadOlder: 'Frühere Nachrichten anzeigen',
    emptyHistory:
      'Bitte die KI, Preise zu ändern, Gerichte hinzuzufügen oder Namen zu korrigieren. Dein Team sieht diese Unterhaltung.',
    teammate: 'Teammitglied',
    menuCreated: 'Speisekarte erstellt',
    deleteMenuConfirm: 'Diese Speisekarte löschen?',
    deleteMenu: 'Löschen',
    tryAgain: 'Erneut versuchen',
    undoCreated: 'Rückgängig (Speisekarte löschen)',
    changesApplied: (n: number) => `${n} ${n === 1 ? 'Änderung' : 'Änderungen'} übernommen`,
    changesPartlyApplied: (applied: number, missing: number) =>
      `${applied} übernommen, ${missing} nicht übernommen`,
    applyingChanges: (n: number) =>
      `${n} ${n === 1 ? 'Änderung wird' : 'Änderungen werden'} übernommen…`,
    reviewChanges: (n: number) => `${n} ${n === 1 ? 'Änderung' : 'Änderungen'} prüfen`,
    discarded: 'Verworfen',
    undone: 'Rückgängig gemacht',
    changesPosition: (position: string, total: number) =>
      `${position} / ${total} ${total === 1 ? 'Änderung' : 'Änderungen'}`,
  },

  menuCreate: {
    title: 'Mit KI erstellen',
    nameLabel: 'Name der Speisekarte',
    namePlaceholder: 'Leer lassen, die KI schlägt einen vor',
    sources: 'Deine Speisekarte',
    sourcesHelp: 'Fotos oder PDFs deiner Speisekarte oder ein Link dazu.',
    camera: 'Foto aufnehmen',
    addFiles: 'Fotos oder PDFs hinzufügen',
    removeSource: 'Entfernen',
    linkLabel: 'Link',
    linkPlaceholder: 'https://dein-restaurant.de/speisekarte',
    invalidLink: 'Gib einen vollständigen Link mit https:// ein',
    hintLabel: 'Was sollte die KI wissen?',
    hintPlaceholder: 'z. B. „Nur die Mittagskarte, die Getränkeseite überspringen“',
    keepItemNumbers: 'Artikelnummern beibehalten',
    offNote: 'Die Speisekarte bleibt aus, bis du sie veröffentlichst.',
    create: 'Speisekarte erstellen',
    unsupportedFiles: (names: string) =>
      `${names} kann nicht verwendet werden. Nutze PNG, JPEG, WebP oder PDF.`,
    tooManySources: (max: number) => `Bis zu ${max} Dateien`,
  },

  menuChecklist: {
    toCheck: (n: number) => `${n} zu prüfen`,
    noPriceCount: (n: number) => `${n} ohne Preis`,
    unknownAllergensCount: (n: number) =>
      `${n} ${n === 1 ? 'unbekanntes Allergen' : 'unbekannte Allergene'}`,
    noPrice: 'Kein Preis',
    addLegend: (n: number) =>
      `${n} ${n === 1 ? 'Kennzeichnung' : 'Kennzeichnungen'} aus der Legende hinzufügen`,
    legendIntro:
      'Diese Kennzeichnungen stehen auf deiner Speisekarte, fehlen aber in deiner Allergenliste.',
    addCodes: 'Zur Allergenliste hinzufügen',
    unknownCode: (code: string) => `„${code}“ nicht in der Allergenliste`,
  },

  menuImportReview: {
    title: 'Import prüfen',
    open: 'Mit dem Original vergleichen',
    openFlagged: (n: number) => `Mit dem Original vergleichen · ${n} markiert`,
    page: (n: number, total: number) => `Seite ${n} von ${total}`,
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    flaggedOnly: 'Nur markierte',
    allDishes: 'Alle Gerichte',
    showPage: 'Original',
    showDishes: 'Gerichte',
    flaggedCount: (n: number) => `${n} markiert`,
    noDishes: 'Auf dieser Seite wurden keine Gerichte gelesen.',
    noFlagged: 'Auf dieser Seite ist nichts markiert.',
    sourceMissing: 'Die Originaldatei ist nicht mehr verfügbar.',
    openOriginal: 'Original öffnen',
    unavailableTitle: 'Nichts zum Vergleichen',
    unavailableText:
      'Zu dieser Speisekarte sind keine Quellseiten gespeichert. Speisekarten, die vor dieser Prüfung importiert wurden, lassen sich hier nicht prüfen.',
    liveNote: 'Diese Speisekarte ist bereits live. Die Markierungen dienen nur als Hinweis.',
    noPrice: 'Kein Preis',
    priceOutlier: (typical: string) =>
      `Preis weicht stark vom Rest der Kategorie ab (üblich ${typical})`,
    unknownCodes: (codes: string) => `Nicht in deiner Allergenliste: ${codes}`,
    itemNumberDropped: (code: string) =>
      `Artikelnummer ${code} kam doppelt vor und wurde weggelassen`,
    pickLimit: (limits: string) => `Gäste müssen eine feste Anzahl wählen: ${limits}`,
  },

  notificationsFeature: {
    couldntLoadNotifications: 'Benachrichtigungen konnten nicht geladen werden',
    allCaughtUp: 'Alles erledigt',
    noNotifications: 'Keine Benachrichtigungen.',
    today: 'Heute',
    earlier: 'Früher',
    markAllRead: 'Alle als gelesen markieren',
    notificationsSheet: 'Benachrichtigungen',
  },

  openingHours: {
    editClosure: 'Schließung bearbeiten',
    addClosure: 'Schließung hinzufügen',
    reason: 'Grund',
    reasonPlaceholder: 'Z. B. Weihnachtstag, Mitarbeiterfest',
    appliesToLabel: 'Gilt für',
    allServices: 'Alle Dienste',
    servicesSelected: (n: number) => `${n} Dienste`,
    pickAtLeastOneService: 'Mindestens einen Dienst auswählen',
    dineIn: 'Im Restaurant',
    pickup: 'Abholung',
    delivery: 'Lieferung',
    reservation: 'Reservierung',
    whatHappens: 'Was passiert',
    whatHappensHint:
      'Feiertag schließt den ganzen Tag. Ausnahme hält an diesen Tagen geöffnet, aber mit anderen Zeiten – zum Beispiel später öffnen oder früher schließen.',
    holiday: 'Feiertag',
    exception: 'Ausnahme',
    closedAllDay: 'Den ganzen Tag geschlossen',
    specialHours: 'Spezielle Öffnungszeiten',
    dates: 'Daten',
    from: 'Von',
    to: 'Bis',
    startDateAriaLabel: 'Startdatum',
    endDateAriaLabel: 'Enddatum',
    singleDayHint: 'Ein einzelner Tag? Stellen Sie Von und Bis auf das gleiche Datum ein.',
    shiftLabel: (number) => `Schicht ${number}`,
    openLabel: 'Öffnen',
    removeHoursAriaLabel: 'Öffnungszeiten entfernen',
    addHours: 'Öffnungszeiten hinzufügen',
    hoursReplaceWeeklyNote:
      'Diese Zeiten ersetzen die normalen wöchentlichen Öffnungszeiten an den ausgewählten Daten.',
    pickStartEndDate: 'Wählen Sie ein Start- und Enddatum.',
    endDateBeforeStart: 'Das Enddatum kann nicht vor dem Startdatum liegen.',
    addSpecialHours: 'Fügen Sie mindestens einen Satz spezieller Öffnungszeiten hinzu.',
    checkSpecialHours:
      'Überprüfen Sie die speziellen Öffnungszeiten - Öffnung muss vor Schließung sein.',
    closureUpdated: 'Schließung aktualisiert',
    closureAdded: 'Schließung hinzugefügt',
    couldNotSave: 'Konnte nicht speichern - versuchen Sie es erneut.',
    holidaysClosures: 'Feiertage & Schließungen',
    removeClosureConfirm: 'Schließung entfernen',
    removeClosureQuestion: (label) => `Schließung für ${label} entfernen?`,
    closureRemoved: 'Schließung entfernt',
    couldNotRemove: 'Konnte nicht entfernen - versuchen Sie es erneut.',
    couldNotLoadClosures: 'Konnte Schließungen nicht laden',
    noClosuresYet: 'Noch keine Schließungen',
    noClosuresDescription:
      'Fügen Sie einen Feiertag oder einen Tag mit speziellen Öffnungszeiten hinzu, um den wöchentlichen Plan zu überschreiben. Tippen Sie auf +.',
    closedBadge: 'Geschlossen',
    specialBadge: 'Speziell',
    closuresOverrideNote:
      'Schließungen überschreiben die wöchentlichen Öffnungszeiten. Ein geschlossener Tag entfernt Online-Bestell- und Reservierungsplätze; spezielle Öffnungszeiten ersetzen sie für die ausgewählten Daten.',
    title: 'Öffnungszeiten',
    service: 'Dienst',
    hoursFor: 'Öffnungszeiten für',
    hoursServiceNote:
      'Jeder Dienst behält seine eigenen wöchentlichen Öffnungszeiten. Abholungs- und Lieferzeiten steuern die Online-Bestellseite; Reservierungszeiten steuern den Buchungskalender.',
    oneOffClosedDays: 'Einmalige geschlossene Tage und spezielle Öffnungszeiten',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    hoursLabel: 'Öffnungszeiten',
    hours: 'Öffnungszeiten',
    generalHoursNote:
      'Dies sind die allgemeinen Öffnungszeiten des Restaurants. Reservierung, Abholung und Lieferung übernehmen sie automatisch - geben Sie einem Kanal in seinen Einstellungen eigene Zeiten, wenn sie abweichen. Einmalige Feiertage und Tage mit speziellen Öffnungszeiten finden Sie unter Feiertage & Schließungen.',
    openTimeAria: (label) => `${label} Öffnen`,
    closeTimeAria: (label) => `${label} Schließen`,
    enabledWithoutHours: (label) =>
      `${label} ist an, hat aber keine Öffnungszeiten - fügen Sie eine Zeit hinzu oder schalten Sie ihn aus`,
    checkTimes: (label) => `Überprüfen Sie die Zeiten für ${label}`,
    noOvernightOrders: (label) =>
      `${label}: Schließzeit muss nach der Öffnungszeit liegen - Bestellzeiten dürfen nicht über Mitternacht gehen.`,
    openAfterClose: (label) => `${label}: Öffnungszeit darf nicht nach der Schließzeit liegen.`,
    shiftsOverlap: (label) =>
      `${label}: Zeiträume überschneiden sich - passe sie so an, dass sie sich nicht überlappen.`,
    invalidHoursTitle: 'Ungültige Zeiten',
    openingSaved: 'Öffnungszeiten gespeichert',
    saveFailed: 'Speichern fehlgeschlagen',
    couldNotLoadHours: 'Konnte Öffnungszeiten nicht laden',
    checkConnection: 'Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    saveButtonLabel: (service) => `Speichere ${service} Öffnungszeiten`,
    followingTheseHours: 'Folgt diesen Zeiten',
    setCustomHours: 'Eigene Öffnungszeiten festlegen',
    nowFollowingGeneral: 'Folgt jetzt den allgemeinen Öffnungszeiten',
    confirmFollowTitle: 'Zu allgemeinen Öffnungszeiten wechseln?',
    confirmFollowMessage:
      'Dadurch werden die eigenen Wochenzeiten dieses Kanals gelöscht. Er folgt stattdessen den allgemeinen Öffnungszeiten des Restaurants.',
    failedSetCustom: 'Eigene Öffnungszeiten konnten nicht festgelegt werden',
    failedUpdate: 'Aktualisierung fehlgeschlagen',
    orderHoursTitle: 'Bestellzeiten',
    pickupHoursTitle: 'Abholzeiten',
    deliveryHoursTitle: 'Lieferzeiten',
    reservationHoursTitle: 'Reservierungszeiten',
    pickupFollowNote:
      'Die Abholung folgt den allgemeinen Öffnungszeiten des Restaurants. Aktivieren Sie eigene Öffnungszeiten, um separat festzulegen, wann Abholbestellungen angenommen werden.',
    deliveryFollowNote:
      'Die Lieferung folgt den allgemeinen Öffnungszeiten des Restaurants. Aktivieren Sie eigene Öffnungszeiten, um separat festzulegen, wann geliefert wird.',
    reservationFollowNote:
      'Reservierungen folgen den allgemeinen Öffnungszeiten des Restaurants. Aktivieren Sie eigene Öffnungszeiten, um separat festzulegen, wann Tische gebucht werden können.',
    openingTime: 'Öffnungszeit',
    deleteThisClosure: 'Diese Schließung löschen',
    removeThisClosureQuestion: 'Diese Schließung entfernen?',
    statusOpenUntil: (time) => `Geöffnet · bis ${time}`,
    statusClosedOpensAt: (time) => `Geschlossen · öffnet ${time}`,
    statusClosedOpensDay: (day, time) => `Geschlossen · öffnet ${day} ${time}`,
  },

  orderSetup: {
    title: 'Bestelleinstellungen',
    orderTypes: {
      title: 'Bestellarten',
      noConfig: 'Keine Bestellarten konfiguriert.',
      footer:
        'Tippen Sie auf einen Kanal, um ihn ein-/auszuschalten oder Bargeld- und Kartenzahlungen umzuschalten. Das Ausschalten eines Kanals verbirgt ihn völlig vor Kunden - um ihn stattdessen kurzzeitig zu pausieren, verwenden Sie unten die Verfügbarkeit.',
      cashStatus: (status, cardStatus) => `Bargeld ${status} · Karte ${cardStatus}`,
      cashOnly: (status) => `Bargeld ${status}`,
      disabled: 'Kunden können auf diese Weise nicht bestellen',
      on: 'An',
      off: 'Aus',
      actionLabel: (label) => `${label} Einstellungen`,
      turnOff: (label) => `${label} ausschalten`,
      turnOn: (label) => `${label} einschalten`,
      stopCash: 'Keine Bargeldakzeptanz mehr',
      acceptCash: 'Bargeld akzeptieren',
      stopCard: 'Kartenzahlungen nicht mehr akzeptieren',
      acceptCard: 'Online-Kartenzahlungen akzeptieren',
      turnedOff: (label) => `${label} ausgeschaltet`,
      turnedOn: (label) => `${label} eingeschaltet`,
      cashOff: 'Bargeldverstarkung deaktiviert',
      cashOn: 'Bargeldverstarkung aktiviert',
      onlineCardOff: 'Online-Kartenzahlungen deaktiviert',
      onlineCardOn: 'Online-Kartenzahlungen aktiviert',
    },
    minimumOrder: {
      title: 'Mindestbestellung',
      noConfig: 'Keine Bestellarten konfiguriert.',
      smallestBasket: 'Kleinster Warenkorb zulässig',
      noMinimum: 'Kein Minimum',
      footer:
        'Der kleinste Warenkorbsumme, mit dem ein Kunde auschecken kann, pro Kanal. Auf 0 setzen, um kein Minimum zu haben.',
      prompt: (orderType) => `Mindestbestellsumme ${orderType} (0 = kein Minimum)`,
      set: (orderType, amount) => `Mindestbestellung ${orderType} auf ${amount} gesetzt`,
      removed: (orderType) => `Mindestbestellung ${orderType} entfernt`,
    },
    availability: {
      title: 'Verfügbarkeit',
      accepting: 'Bestellungen werden akzeptiert',
      pausedUntilClose: 'Pausiert bis Schließung',
      pausedResumes: (time) => `Pausiert · setzt sich fort um ${time}`,
      paused: 'Pausiert',
      live: 'Aktiv',
      footer:
        'Live-Status der Annahme neuer Bestellungen. Tippen Sie auf einen Kanal, um ihn bei Stoßverkehren oder Küchenproblemen zu pausieren (zeitgesteuert / bis Schließung) oder fortzusetzen. Dies ist unabhängig vom Aktivieren der Bestellart oben - vorhandene Bestellungen sind nicht betroffen.',
      orderingLabel: (label) => `${label} bestellen`,
      pause30: '30 Minuten pausieren',
      pause1Hour: '1 Stunde pausieren',
      pauseUntilClose: 'Bis Schließung pausieren',
      resumeNow: 'Jetzt fortsetzen',
      pausedFor: (label, minutes) => `${label} für ${minutes} Minuten pausiert`,
      pausedUntilCloseToast: (label) => `${label} bis zur Schließung pausiert`,
      resumed: (label) => `${label} fortgesetzt`,
    },
    deliveryZones: {
      title: 'Lieferzonen',
      noZones:
        'Keine Lieferzonen - Lieferung ist nicht verfügbar, bis mindestens eine Zone hinzugefügt wird.',
      mapArea: 'Kartenbereich',
      within: (km) => `Innerhalb ${km} km`,
      noRangeSet: 'Kein Bereich festgelegt',
      addZone: '+ Lieferzone hinzufügen',
      footer:
        'Jede Zone definiert ihre Reichweite und ihre eigene Liefergebühr und Mindestbestellung. Kunden sehen die kleinste passende Zone.',
      deleteConfirm: (label) => `Zone "${label}" löschen?`,
      deleteTitle: 'Zone löschen',
      deleted: 'Zone gelöscht',
    },
    deliveryZone: {
      newZone: 'Neue Lieferzone',
      editZone: 'Zone bearbeiten',
      nameLabel: 'Zonennamen',
      namePlaceholder: 'z.B. Stadtzentrum, bis zu 5 km',
      deliveryArea: 'Liefergebiet',
      mapDrawn: 'Kartengezeichnet',
      mapDrawnFooter:
        'Dieses Gebiet wurde auf einer Karte gezeichnet und kann hier nicht bearbeitet werden.',
      distanceLabel: 'Liefert innerhalb von (km)',
      distancePlaceholder: 'z.B. 5',
      feeLabel: (currency) => `Liefergebühr (${currency})`,
      minOrderLabel: (currency) => `Mindestbestellung (${currency})`,
      minOrderPlaceholder: '0 = kein Minimum',
      nameRequired: 'Geben Sie der Zone einen Namen.',
      distanceRequired: 'Geben Sie an, wie weit diese Zone liefert (km).',
      added: 'Zone hinzugefügt',
      updated: 'Zone aktualisiert',
      saveFailed: 'Fehler beim Speichern der Zone',
    },
    paymentMethods: {
      title: 'Manuelle Zahlungsmethoden',
      noMethods:
        'Keine manuellen Zahlungsmethoden - nur die Standardoptionen werden an der Kasse angeboten.',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      addMethod: '+ Zahlungsmethode hinzufügen',
      footer:
        'Optionen zur Bezahlung bei Ankunft oder Banküberweisung werden an der Kasse angezeigt. Kunden befolgen die Anweisungen und das Personal bestätigt den Beleg manuell.',
      deleteConfirm: (name) => `Methode "${name}" löschen?`,
      deleteTitle: 'Löschen',
      deleted: 'Methode gelöscht',
    },
    paymentMethod: {
      newMethod: 'Neue Zahlungsmethode',
      editMethod: 'Methode bearbeiten',
      nameLabel: 'Methodennamen',
      namePlaceholder: 'z.B. Banküberweisung, PayPal',
      instructionsLabel: 'Anweisungen',
      instructionsPlaceholder: 'Was der Kunde tun sollte, um zu zahlen',
      shownAtCheckout: 'An der Kasse angezeigt',
      detail: (number) => `Detail ${number}`,
      remove: 'Entfernen',
      detailLabel: 'Etikett',
      detailLabelPlaceholder: 'z.B. IBAN',
      detailValue: 'Wert',
      detailValuePlaceholder: 'z.B. DE89 3704 0044 0532 0130 00',
      addDetail: '+ Kontodetail hinzufügen',
      detailLabelInfo: 'Name des Felds, das der Kunde sieht (z. B. IBAN, Kontoinhaber, Bankname).',
      detailValueInfo:
        'Das tatsächliche Detail, das der Kunde zum Bezahlen kopiert (z. B. DE89 3704…, ACME Ltd).',
      detailsFooter:
        'Kontodetails werden als gekennzeichnete Zeilen unter den Anweisungen an der Kasse angezeigt - verwenden Sie sie für IBAN, Kontoinhaber, PayPal-Adresse usw.',
      nameRequired: 'Geben Sie der Methode einen Namen.',
      instructionsRequired: 'Fügen Sie die Anweisungen hinzu, die der Kunde befolgen sollte.',
      detailsInvalid: 'Jedes Kontodetail benötigt sowohl ein Etikett als auch einen Wert.',
      added: 'Methode hinzugefügt',
      updated: 'Methode aktualisiert',
      saveFailed: 'Fehler beim Speichern der Methode',
    },
    shifts: {
      title: 'Bestellstunden',
      pickup: 'Abholen',
      delivery: 'Lieferung',
      capacityMode: 'Kapazitätsmodus',
      simple: 'Einfach',
      simpleDescription: 'Eine Zahl: wie viele Bestellungen Sie pro Stunde annehmen können.',
      simpleConfirm: 'Kapazität in den einfachen Modus schalten?',
      simpleDetails:
        'Ein Slot ist ein 60-Minuten-Fenster - der 19:00-Slot zählt jede Bestellung, die zwischen 19:00 und 19:59 geplant ist.\n\nDie Standardobergrenze gilt, wenn kein Sonderstundenfenster die Zeit abdeckt. Lassen Sie es leer, wenn keine Obergrenze erforderlich ist.',
      advanced: 'Fortgeschritten',
      advancedDescription: 'Wählen Sie die Slotlänge und eine Bestellobergrenze pro Slot.',
      advancedConfirm: 'Kapazität in den erweiterten Modus schalten?',
      advancedDetails:
        'Legen Sie Ihre eigene Slotlänge fest (z. B. 30 Min) und eine Bestellobergrenze pro Slot - feiner strukturiert als das einfache Stundenmodell.\n\nDie Standardobergrenze gilt, wenn kein Sonderstundenfenster die Zeit abdeckt. Lassen Sie es leer, wenn keine Obergrenze erforderlich ist.',
      aboutMode: (mode) => `Über den ${mode}-Modus`,
      defaultCapacity: 'Standardkapazität',
      ordersPerSlot: 'Bestellungen pro Slot',
      maxOrdersPerHour: 'Max Bestellungen pro Stunde',
      noCap: 'keine Obergrenze',
      slotLength: 'Slotlänge (min)',
      slotLengthPlaceholder: '30',
      kitchenPrepTime: 'Zubereitungszeit in der Küche (min)',
      noPrepPlaceholder: 'keine Vorbereitung',
      minNoticeLabel: 'Mindestmitteilung für Vorbestellungen (min)',
      nonePlaceholder: 'keine',
      defaultFooter:
        'Online-Bestellungen folgen Ihren Öffnungszeiten. Fügen Sie unten Sonderzeiten für verschiedene Zeiten an bestimmten Tagen hinzu.',
      specialHours: 'Sonderzeiten',
      noSpecialHours: 'Keine - die Standardeinstellung gilt täglich.',
      setDefaultFirst: 'Stellen Sie zunächst die Standardkapazität ein',
      capacityModeSet: (mode) => `Kapazitätsmodus: ${mode}`,
      switchModeFailed: 'Fehler beim Wechsel des Kapazitätsmodus',
    },
    shiftForm: {
      newSpecialHours: 'Neue Sonderzeiten',
      editSpecialHours: 'Sonderzeiten bearbeiten',
      name: 'Name',
      namePlaceholder: 'z.B. Heiligabend, Sonntagsstunden',
      days: 'Tage',
      hours: 'Stunden',
      opens: 'Öffnet',
      closes: 'Schließt',
      capacity: 'Kapazität',
      preview: 'Vorschau',
      active: 'Aktiv',
      activeFooter: 'Deaktivieren Sie diese Regel, behalten Sie sie aber für jetzt bei.',
      daysFooter: (channel) =>
        `An diesen Tagen ersetzt diese Regel die normalen ${channel}-Stunden. Andere Tage bleiben unverändert.`,
      capacityFooter:
        'Grau ist Ihr Standard - lassen Sie es leer, um es zu behalten, oder geben Sie eine Zahl ein, um einen anderen Wert an den Tagen dieser Regel zu verwenden.',
      deleteRule: 'Diesen Regel löschen',
      nameRequired: 'Geben Sie dieser Regel einen Namen',
      dayRequired: 'Wählen Sie mindestens einen Tag',
      timeInvalid: 'Öffnen muss vor Schließung sein',
      capacityInvalid:
        'Die Kapazität muss eine positive ganze Zahl sein (oder leer für den Standard)',
      slotInvalid: 'Die Slotlänge muss eine positive ganze Zahl sein',
      leadInvalid:
        'Vorbereitung / Mitteilung müssen ganze Zahlen sein (oder leer, um den Standard zu verwenden)',
      saveFailed: 'Konnte nicht speichern',
      deleteConfirm: 'Diese Regel löschen?',
      deleted: 'Gelöscht',
      deleteFailed: 'Konnte nicht löschen',
    },
    holidayForm: {
      newTitle: 'Neue Feiertagszeiten',
      editTitle: 'Feiertagszeiten bearbeiten',
      namePlaceholder: 'z.B. Heiligabend, Neujahr',
      dates: 'Daten',
      datesFooter: (channel) =>
        `An diesen Daten ersetzt dieser Feiertag SOWOHL Sonderzeiten ALS AUCH die normalen ${channel}-Stunden.`,
      starts: 'Beginnt',
      startAria: 'Startdatum des Feiertags',
      ends: 'Endet',
      endAria: 'Enddatum des Feiertags',
      on: 'Ein',
      activeFooter:
        'Schalten Sie ihn aus, um diesen Feiertag zu behalten, aber vorübergehend nicht zu überschreiben.',
      deleteHoliday: 'Diesen Feiertag löschen',
      nameRequired: 'Geben Sie diesem Feiertag einen Namen',
      dateRangeInvalid: 'Das Enddatum muss am oder nach dem Startdatum liegen',
      hoursInvalid: 'Öffnen und Schließen müssen festgelegt sein und sich unterscheiden',
      capacityInvalid:
        'Bestellungen pro Slot müssen eine positive ganze Zahl sein (oder leer für kein Limit)',
      prepNoticeInvalid: 'Vorbereitung und Vorlauf müssen ganze Zahlen sein (0 oder mehr)',
      deleteConfirm: 'Diesen Feiertag löschen?',
    },
    leadTime: {
      orderNow: 'Jetzt bestellen (so schnell wie möglich)',
      orderLabel: 'Bestellung',
      readyLabel: 'Bereit',
      deliveredLabel: 'Geliefert',
      deliveryDescription: (mins: number) =>
        `Die Lieferung kommt mit ${mins} Min. zur Zubereitung hinzu — dann hat der Gast das Essen.`,
      deliveryRangeDescription: (min: number, max: number) =>
        `Die Lieferung kommt je nach Gebiet mit ${min}–${max} Min. zur Zubereitung hinzu — dann hat der Gast das Essen.`,
      deliveryLiveDescription:
        'Die Lieferzeit wird pro Adresse aus aktuellen Fahrdaten berechnet und ist daher bei jeder Bestellung anders.',
      readyDescription:
        'Bereit = Bestellzeit + Zubereitungszeit. Das ist die Wartezeit des Kunden - wo die Zubereitungszeit am wichtigsten ist. Mindestmitteilung gilt nicht.',
      noPrepBuffer: 'Kein Zubereitungspuffer - Bestellung ist sofort einsatzbereit.',
      orderLater: 'Später bestellen (Vorbestellung)',
      earliestSlot: 'Frühester Slot',
      minNoticeDescription: (time) =>
        `Mindestmitteilung - der früheste zukünftige Slot, den ein Kunde wählen kann, ist ${time}.`,
      noNotice: 'Keine Mitteilung - Kunden können den nächsten Slot wählen.',
      opensLabel: 'Öffnet',
      firstSlotLabel: 'Erster Slot',
      openingBufferDescription: (open: string, first: string) =>
        `Frühestens nach Öffnung - öffnet die Bestellung um ${open}, ist ${first} der früheste Slot, den Kunden wählen können.`,
      noOpeningBuffer: 'Kein Puffer nach Öffnung - Kunden können die Öffnungszeit selbst wählen.',
      kitchenStarts: 'Küche beginnt',
      readySlot: 'Bereit · Slot',
      driverLeaves: 'Fahrer fährt los',
      deliveredSlot: 'Geliefert',
      kitchenStartsDeliveryDescription: (slot: string, startTime: string) =>
        `Für eine Lieferung um ${slot} startet die Küche um ${startTime} — die Fahrt wird vom Termin abgezogen, nicht hinzugefügt, der Gast bekommt sie also weiterhin um ${slot}. Gezeigt für Ihr entferntestes Gebiet.`,
      kitchenStartsDeliveryLive:
        'Bei Fahrstrecke in Echtzeit wird die Fahrt pro Adresse abgezogen, der Küchenstart verschiebt sich also je Bestellung.',
      kitchenStartsDescription: (time, startTime) =>
        `Für einen ausgewählten ${time}-Slot beginnt die Küche um ${startTime} - der Kunde bekommt ihn trotzdem genau um ${time}.`,
    },
    page: {
      pickup: 'Abholung',
      delivery: 'Lieferung',
      noConfig: 'Keine Bestellarten konfiguriert.',
      orderTypesTitle: 'Bestellarten',
      canOrder: 'Kunden können auf diese Weise bestellen',
      cannotOrder: 'Kunden können nicht auf diese Weise bestellen',
      readOnlyNotice:
        'Sie können diese Einstellungen ansehen. Nur Inhaber oder Manager können sie ändern.',
      orderTypesFooter:
        'Einen Kanal ein- oder ausschalten. Aus blendet ihn vollständig für Kunden aus - um ihn kurz zu pausieren, nutzen Sie stattdessen die Verfügbarkeit unten.',
      toggledOn: (label) => `${label} eingeschaltet`,
      toggledOff: (label) => `${label} ausgeschaltet`,
      cardTitle: 'Kartenzahlung',
      acceptingCard: 'Karte online akzeptiert',
      cardOff: 'Karte aus',
      cardFooter: 'Kartenzahlung online akzeptieren, pro Kanal.',
      cardOnToast: (label) => `${label} Karte ein`,
      cardOffToast: (label) => `${label} Karte aus`,
      cardOnHandoffTitle: 'Karte bei Übergabe',
      acceptingCardOnHandoff: 'Karte bei Übergabe ein',
      cardOnHandoffOff: 'Karte bei Übergabe aus',
      cardOnHandoffHelp:
        'Der Kunde zahlt bei Abholung oder Lieferung mit Karte an Ihrem POS-Terminal. Kein Online-Anbieter nötig - Sie kassieren und begleichen es selbst, wie Bargeld.',
      autoConfirmTitle: 'Automatisch bestätigen',
      autoConfirmOn: 'Bar & Karte bei Übergabe automatisch bestätigt',
      autoConfirmOff: 'Manuell bestätigen',
      autoConfirmHelp:
        'Bestellungen mit Bar- oder Kartenzahlung bei Übergabe werden automatisch bestätigt und der Küchenbon druckt sofort - kein Annehmen nötig. Online-Bestellungen bestätigen sich bereits bei Zahlung; Überweisung braucht weiterhin Ihre Prüfung.',
      autoConfirmOnToast: (label) => `${label} automatische Bestätigung ein`,
      autoConfirmOffToast: (label) => `${label} automatische Bestätigung aus`,
      autoCompleteTitle: 'Bestellungen automatisch abschließen',
      autoCompleteOn: (minutes) => `Schließt ${minutes} Min. nach der zugesagten Zeit`,
      autoCompleteOff: 'Sie schließen jede Bestellung selbst ab',
      autoCompleteHelp:
        'Nicht abgeschlossene Bestellungen werden eine Weile nach der dem Gast zugesagten Zeit automatisch abgeschlossen. Schalten Sie das aus, wenn Sie selbst auf Abschließen tippen - dann bleiben Bestellungen offen, bis Sie es tun.',
      autoCompleteOnToast: (label) => `${label} wird automatisch abgeschlossen`,
      autoCompleteOffToast: (label) => `${label} bleibt offen, bis Sie abschließen`,
      autoCompleteSaveFailed: 'Wartezeit konnte nicht gespeichert werden. Bitte erneut versuchen.',
      autoCompleteDelayTitle: 'Wartezeit vor dem Abschluss',
      autoCompleteDelayFooter:
        'Wie viele Minuten nach der zugesagten Zeit eine Bestellung für Sie abgeschlossen wird.',
      cardOnHandoffOnToast: (label) => `${label} Karte bei Übergabe ein`,
      cardOnHandoffOffToast: (label) => `${label} Karte bei Übergabe aus`,
      availabilityTitle: 'Verfügbarkeit',
      accepting: 'Nimmt Bestellungen an',
      pausedUntilClose: 'Pausiert bis Geschäftsschluss',
      pausedResumes: (time) => `Pausiert · fortgesetzt ${time}`,
      paused: 'Pausiert',
      live: 'Live',
      disabled: 'Aus',
      availabilityFooter:
        'Live-Status der Annahme neuer Bestellungen. Tippen Sie auf einen Kanal, um ihn bei Andrang oder Küchenproblemen zu pausieren (zeitlich / bis Geschäftsschluss) oder fortzusetzen. Dies ist unabhängig vom Aktivieren der Bestellart oben - bestehende Bestellungen sind nie betroffen.',
      orderingLabel: (label) => `${label}-Bestellung`,
      pause30: '30 Minuten pausieren',
      pause1Hour: '1 Stunde pausieren',
      pauseHours: (n) => `${n} Stunden pausieren`,
      pauseUntilClose: 'Bis Geschäftsschluss pausieren',
      resumeNow: 'Jetzt fortsetzen',
      cancel: 'Abbrechen',
      pausedUntilCloseToast: (label) => `${label} bis Geschäftsschluss pausiert`,
      pausedForToast: (label, minutes) => `${label} für ${minutes} Min pausiert`,
      resumedToast: (label) => `${label} fortgesetzt`,
      minimumOrderTitle: 'Mindestbestellwert',
      smallestBasket: 'Kleinster zulässiger Warenkorb',
      noMinimum: 'Kein Minimum',
      minimumOrderFooter:
        'Der kleinste Warenkorbwert, mit dem ein Kunde auschecken kann, pro Kanal. Auf 0 setzen für kein Minimum.',
      minPrompt: (label) => `Mindestbestellwert ${label} (0 = kein Minimum)`,
      minDialogTitle: 'Mindestbestellwert',
      minSet: (label, amount) => `${label}-Minimum auf ${amount} gesetzt`,
      minRemoved: (label) => `${label}-Minimum entfernt`,
      deliveryPricingTitle: 'Lieferpreise',
      deliveryPricingFooter:
        'Wie Liefergebühren berechnet werden - nach Entfernung vom Restaurant oder nach gezeichneten Kartenzonen.',
      byDistance: 'Nach Entfernung',
      byDistanceFooter: 'Berechnen Sie eine gestaffelte Gebühr je nach Entfernung des Kunden.',
      byMapZones: 'Nach Kartenzonen',
      byMapZonesFooter: 'Zeichnen Sie Liefergebiete auf einer Karte, jedes mit eigener Gebühr.',
      straightLine: 'Luftlinien-Entfernung',
      straightLineFooter: 'Luftlinie. Kostenlos, sofort.',
      drivingDistance: 'Fahrstrecke (MapBox)',
      drivingDistanceFooter: 'Tatsächliche Straßenentfernung. Genauer; nutzt MapBox.',
      deliveryWarnings: {
        title: 'Lieferung ist für Kunden nicht bereit',
        subtitle: 'Gäste stoßen an der Kasse auf diese Probleme — ohne zu erfahren, warum.',
        locationNotPinned: 'Ihr Restaurant ist nicht auf der Karte gesetzt',
        locationNotPinnedEffect:
          'Entfernungen werden von Ihrem Restaurant aus gemessen — jede Adresse gilt als außerhalb des Liefergebiets.',
        noActiveZones: 'Keine Liefergebiete für die gewählte Preisberechnung',
        noActiveZonesEffect: 'Jeder Adresse wird angezeigt, dass dorthin nicht geliefert wird.',
        zoneMissingTime: (zone: string) => `„${zone}“ hat keine Lieferzeit`,
        zoneMissingTimeEffect:
          'Gäste erhalten eine Zeit ohne die Fahrt — die Bestellung kommt zu spät an.',
        noPaymentMethod: 'Keine Zahlungsart aktiviert',
        noPaymentMethodEffect: 'Gäste können bestellen, aber die Bestellung nicht abschließen.',
      },
      pinRequiredForRouteTitle: 'Zuerst Restaurant setzen',
      pinRequiredForRoute:
        'Die Fahrstrecke wird vom Standort Ihres Restaurants aus gemessen. Setzen Sie ihn in den Restaurant-Einstellungen auf der Karte und wechseln Sie dann zur Fahrstrecke.',
      dispatchBufferTitle: 'Puffer für die Auslieferung',
      dispatchBufferFooter:
        'Zusätzliche Minuten auf die Fahrzeit — für mehrere Lieferungen auf einer Tour, Parken und den Weg zur Tür. Bei 0 lassen, wenn die Fahrzeit schon realistisch ist.',
      dispatchBufferLabel: 'Zusätzliche Minuten',
      restaurantLocation: 'Restaurant-Standort',
      pinned: 'Festgelegt',
      notSet: 'Nicht festgelegt',
      locationFooter:
        'Der Punkt, von dem aus wir Lieferentfernung und Fahrzeit messen. Erforderlich für Entfernungspreise; bei Kartenzonen speist er die Live-Lieferzeit (bis zum Setzen wird die statische Schätzung verwendet).',
      deliveryPricingSaveFailed: 'Speichern der Lieferpreise fehlgeschlagen',
      switchModeConfirmTitle: 'Preismodus wechseln?',
      switchModeConfirm:
        'Beim Wechsel des Preismodus werden Ihre vorhandenen Zonen für die andere Methode nicht mehr verwendet. Fortfahren?',
      deliveryZonesTitle: 'Lieferzonen',
      distanceBandsTitle: 'Entfernungs-Preisstufen',
      bandForm: {
        newTitle: 'Neue Entfernungsstufe',
        editTitle: 'Entfernungsstufe bearbeiten',
        back: 'Zurück',
        nameLabel: 'Name der Stufe',
        namePlaceholder: 'z. B. Stadtzentrum, Bis 5 km',
        kmLabel: 'Liefert innerhalb von (km)',
        kmPlaceholder: 'z. B. 5',
        feeLabel: 'Liefergebühr',
        feePlaceholder: '0',
        minOrderLabel: 'Mindestbestellwert',
        minOrderPlaceholder: '0 = kein Minimum',
        areaLabel: 'Liefergebiet',
        areaAfter: 'Auf Karte gezeichnet',
        areaFooter:
          'Dieses Gebiet wurde auf einer Karte gezeichnet und kann hier nicht bearbeitet werden.',
        nameRequired: 'Gib der Stufe einen Namen.',
        kmRequired: 'Lege fest, wie weit diese Stufe liefert (km).',
        invalidInput: 'Werte dürfen nicht negativ sein - es wurde nichts gespeichert.',
        invalidNumber: 'Gib eine Zahl ein, z. B. 2,5.',
        wholeMinutes: 'Nur ganze Minuten, z. B. 30.',
        updated: 'Entfernungsstufe aktualisiert',
        added: 'Entfernungsstufe hinzugefügt',
        deliveryTimeLabel: 'Lieferzeit (Minuten)',
        deliveryTimePlaceholder: 'z. B. 45',
        deliveryTimeInfo: 'Nur die Fahrzeit — die Zubereitungszeit kommt hinzu.',
        deliveryTimeRequired: 'Geben Sie an, wie lange die Lieferung in dieses Gebiet dauert.',
        saveFailed: 'Stufe konnte nicht gespeichert werden',
      },
      addDistanceBand: '+ Stufe hinzufügen',
      noDistanceBands:
        'Noch keine Entfernungsstufen - Lieferung ist erst möglich, wenn mindestens eine Stufe angelegt ist.',
      distanceBandsFooter:
        'Pauschale je Luftlinien-Entfernungsstufe (z. B. bis 3 km → €2,50). Es gilt die nächste Stufe, die die Adresse abdeckt.',
      drivingBandsFooter:
        'Pauschale je Fahrstrecken-Entfernungsstufe (z. B. bis 3 km Fahrweg → €2,50). Die Entfernung wird per MapBox entlang der Straßen gemessen; es gilt die nächste Stufe, die die Adresse abdeckt.',
      noZones:
        'Keine Lieferzonen - Lieferung ist nicht verfügbar, bis mindestens eine Zone hinzugefügt wird.',
      mapArea: 'Kartenbereich',
      within: (km) => `Innerhalb von ${km} km`,
      noRangeSet: 'Keine Reichweite festgelegt',
      addZone: '+ Lieferzone hinzufügen',
      drawArea: '+ Liefergebiet zeichnen',
      zonesFooter:
        'Jede Zone legt ihre Reichweite und ihre eigene Liefergebühr und Mindestbestellung fest. Kunden sehen die kleinste passende Zone.',
      deleteZoneConfirm: (label) => `Zone "${label}" löschen?`,
      deleteZoneTitle: 'Zone löschen',
      zoneDeleted: 'Zone gelöscht',
      methodsTitle: 'Manuelle Zahlungsmethoden',
      noMethods:
        'Keine manuellen Zahlungsmethoden - nur die Standardoptionen werden beim Checkout angeboten.',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      addMethod: '+ Zahlungsmethode hinzufügen',
      methodsFooter:
        'Optionen zur Zahlung bei Ankunft oder per Banküberweisung werden beim Checkout angezeigt. Kunden folgen den Anweisungen und das Personal bestätigt den Zahlungseingang manuell.',
      deleteMethodConfirm: (name) => `Methode "${name}" löschen?`,
      deleteMethodTitle: 'Löschen',
      methodDeleted: 'Methode gelöscht',
      zoneMapForm: {
        newTitle: 'Neues Liefergebiet',
        editTitle: 'Gebiet bearbeiten',
        drawFooter:
          'Tippen Sie auf das Polygon-Werkzeug (oben links auf der Karte), um zu beginnen, dann tippen Sie auf jede Ecke Ihres Liefergebiets; Doppeltipp schließt die Form. Nutzen Sie das Papierkorb-Werkzeug zum Neuzeichnen. Legen Sie danach unten Gebühr und Minimum fest.',
        nameLabel: 'Gebietsname',
        namePlaceholder: 'z.B. Stadtzentrum',
        feeLabel: 'Liefergebühr',
        feePlaceholder: '0',
        minOrderLabel: 'Mindestbestellung',
        minOrderPlaceholder: '0 = kein Minimum',
        deliveryTimeLabel: 'Lieferzeit (Minuten)',
        deliveryTimePlaceholder: 'z. B. 45',
        deliveryTimeInfo: 'Nur die Fahrzeit — die Zubereitungszeit kommt hinzu.',
        nameRequired: 'Geben Sie dem Gebiet einen Namen.',
        drawRequired: 'Zeichnen Sie zuerst das Liefergebiet auf der Karte.',
        minOrderRequired: 'Legen Sie die Mindestbestellung fest (0 eingeben für kein Minimum).',
        deliveryTimeRequired: 'Geben Sie an, wie lange die Lieferung in dieses Gebiet dauert.',
        invalidNumber: 'Geben Sie eine Zahl ein, z. B. 2,5.',
        wholeMinutes: 'Nur ganze Minuten, z. B. 30.',
        updated: 'Gebiet aktualisiert',
        added: 'Gebiet hinzugefügt',
        saveFailed: 'Fehler beim Speichern des Gebiets',
      },
      locationForm: {
        tapPrompt: 'Tippen Sie auf die Karte, um Ihr Restaurant zu platzieren.',
        saved: 'Standort gespeichert',
        saveFailed: 'Fehler beim Speichern des Standorts',
        footer:
          'Ziehen Sie den Pin (oder tippen Sie auf die Karte) an die genaue Stelle Ihres Restaurants - von hier aus messen wir die Lieferentfernung.',
        currentCoords: (lat, lng) => ` Aktuell: ${lat}, ${lng}.`,
        clear: 'Standort entfernen',
        cleared: 'Standort entfernt',
        clearFailed: 'Standort konnte nicht entfernt werden',
      },
    },
    mapPicker: {
      searchPlaceholder: 'Adresse suchen…',
      search: 'Suchen',
      noResults:
        'Nichts gefunden - versuchen Sie einen genaueren Namen/Adresse, oder setzen Sie den Pin manuell.',
      pickHint:
        'Wählen Sie die passendste Übereinstimmung und ziehen Sie den Pin zur Feinabstimmung:',
      unavailable:
        'Karte nicht verfügbar - VITE_MAPBOX_TOKEN setzen, um das Platzieren zu aktivieren.',
    },
    polygonEditor: {
      unavailable:
        'Karte nicht verfügbar - VITE_MAPBOX_TOKEN setzen, um Liefergebiete zu zeichnen.',
      restaurant: 'Restaurant',
      editingArea: 'Dieses Gebiet (wird bearbeitet)',
      newArea: 'Dieses Gebiet (neu)',
    },
  },

  orderCapacity: {
    save: 'Speichern',
    saving: 'Speichern…',
    pickup: 'Abholung',
    delivery: 'Lieferung',
    unsavedConfirm: 'Sie haben ungespeicherte Änderungen auf diesem Kanal. Wechseln und verwerfen?',
    unsavedTitle: 'Ungespeicherte Änderungen',
    everyDay: 'Jeden Tag',
    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dayNamesLong: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    noCap: 'kein Limit',
    ordersPerHour: (n) => `${n} Bestellungen/Stunde`,
    ordersPerSlotMin: (n, slot) => `${n} Bestellungen / ${slot} Min`,
    holidayCapText: (max, slot) => `${max} Bestellungen/${slot}Min`,
    ordersWithUnit: (cap, unit) => `${cap} Bestellungen${unit}`,
    defaultCapacity: 'Standardkapazität',
    defaultCapacityFooter:
      'Slot-Länge, Bestellungen pro Slot, Vorbereitungszeit und Mindestvorlaufzeit für diesen Kanal. Obergrenze leer lassen für kein Limit.',
    slotIntervalLabel: 'Slot-Intervall (Min)',
    slotLengthLabel: 'Slotlänge (min)',
    ordersPerSlotLabel: 'Bestellungen pro Slot',
    maxOrdersPerHourLabel: 'Max Bestellungen pro Stunde',
    capacityWindowLabel: 'Kapazitätsfenster (Min.)',
    capacityWindowFooter:
      'Der Zeitraum, über den das Limit gezählt wird. Leer lassen, um pro Slot zu begrenzen. Breiter setzen (ein Vielfaches des Slot-Intervalls), um das Limit über einen längeren Zeitraum zu verteilen — z. B. Slot 15 + Fenster 60: Gäste buchen alle 15 Min., das Limit gilt aber pro Stunde.',
    capacityWindowAlert:
      'Das Kapazitätsfenster muss ein ganzzahliges Vielfaches des Slot-Intervalls sein (oder leer, um pro Slot zu begrenzen).',
    prepTimeLabel: 'Küchenvorbereitungszeit (Min)',
    minNoticeLabel: 'Mindestvorlauf für Vorbestellungen (Min)',
    openingBufferLabel: 'Frühestens nach Öffnung (Min)',
    nonePlaceholder: 'keine',
    preview: 'Vorschau',
    defaultFooter:
      'Online-Bestellungen folgen Ihren Öffnungszeiten. Fügen Sie unten Sonderzeiten für andere Zeiten an bestimmten Tagen hinzu.',
    capAlert: 'Das Limit muss eine positive ganze Zahl sein (oder leer für kein Limit)',
    slotAlert: 'Die Slot-Länge muss eine positive ganze Zahl sein',
    prepNoticeAlert: 'Vorbereitung / Vorlauf müssen ganze Zahlen sein (oder leer)',
    openingBufferAlert: (max: number) =>
      `Frühestens nach Öffnung muss eine ganze Zahl von 0 bis ${max} sein`,
    saveErrorGeneric:
      'Standardkapazität konnte nicht gespeichert werden - bitte laden Sie die Seite neu und versuchen Sie es erneut.',
    saveFailedTitle: 'Speichern fehlgeschlagen',
    setDefaultFirst: 'Legen Sie zuerst die Standardkapazität fest',
    specialHours: 'Sonderzeiten',
    noSpecialHours: 'Keine - die Standardeinstellung gilt jeden Tag.',
    pausedSuffix: (label) => `${label} · pausiert`,
    holidayHours: 'Feiertagszeiten',
    holidayFooter:
      'Datumsbereich-Überschreibungen, die SOWOHL Sonderzeiten ALS AUCH normale Zeiten (Öffnen/Schließen + Kapazität) ersetzen, solange aktiv.',
    noHolidays: 'Keine - normale und Sonderzeiten gelten.',
    offSuffix: (name) => `${name} · aus`,
  },

  orders: {
    acceptOrder: 'Bestellung annehmen',
    markCompleted: 'Als abgeschlossen markieren',
    cancelOrder: 'Bestellung stornieren',
    undoCompletion: 'Abschluss rückgängig machen',
    restoreOrder: 'Bestellung wiederherstellen',
    status: {
      PENDING: 'Ausstehend',
      CONFIRMED: 'Bestätigt',
      COMPLETED: 'Abgeschlossen',
      CANCELLED: 'Storniert',
    },
    type: {
      PICKUP: 'Abholung',
      DELIVERY: 'Lieferung',
    },
    itemCount: (count) => `${count} Artikel${count !== 1 ? '' : ''}`,
    emptyState: {
      noSelection: {
        title: 'Keine Bestellung ausgewählt',
        description:
          'Wählen Sie eine Bestellung aus der Liste aus, um ihre Details hier anzuzeigen.',
      },
      notFound: {
        title: 'Bestellung nicht gefunden',
      },
      loadError: {
        title: 'Fehler beim Laden von Bestellungen',
        description: 'Bitte versuchen Sie es erneut.',
      },
      noOrders: {
        title: 'Keine Bestellungen',
        filteredDescription: 'Keine Bestellungen entsprechen den ausgewählten Filtern.',
        defaultDescription: 'Bestellungen werden hier angezeigt, wenn Kunden diese aufgeben.',
      },
    },
    action: {
      acceptOrder: {
        success: 'Bestellung angenommen',
      },
      completeOrder: {
        confirm: 'Diese Bestellung als abgeschlossen markieren?',
        title: 'Bestellung abschließen',
        success: 'Bestellung abgeschlossen',
      },
      cancelOrder: {
        confirm: 'Diese Bestellung stornieren?',
        title: 'Bestellung stornieren',
        success: 'Bestellung storniert',
      },
      undoCompletion: {
        confirm:
          'Abschluss rückgängig machen? Die Bestellung wird storniert, das Bargeld gilt wieder als nicht kassiert und vergebene Punkte werden zurückgenommen. Der Gast wird nicht benachrichtigt.',
        title: 'Abschluss rückgängig machen',
        success: 'Abschluss rückgängig gemacht',
      },
      restoreOrder: {
        confirm:
          'Diese Bestellung wieder als abgeschlossen führen? Das Bargeld gilt wieder als kassiert und die Punkte werden erneut gutgeschrieben. Der Gast wird nicht benachrichtigt.',
        title: 'Bestellung wiederherstellen',
        success: 'Bestellung wiederhergestellt',
      },
    },
    acceptSheet: {
      title: 'Bestellung annehmen',
      confirm: 'Bestätigen & starten',
      failed: 'Bestellung konnte nicht angenommen werden.',
      prepLabel: 'Zubereitungszeit',
      deliveryLabel: 'Lieferzeit',
      minutes: (m) => `${m} Min.`,
      readyForPickup: 'Abholbereit',
      foodReady: 'Essen fertig',
      deliveredBy: 'Geliefert bis',
      scheduledFor: 'Geplant für',
      startPrepBy: 'Zubereitung starten',
      driverLeaves: 'Fahrer startet',
      now: 'Jetzt',
    },
    cancelSheet: {
      keep: 'Bestellung behalten',
      refundToggle: 'Kunden erstatten',
      refundLine: (amount: string, provider: string) =>
        `Beim Stornieren werden ${amount} über ${provider} an den Kunden erstattet.`,
      noRefundWarning: 'Ohne Erstattung stornieren — der Kunde erhält sein Geld nicht zurück.',
      failed: 'Bestellung konnte nicht storniert werden.',
    },
    payment: {
      acceptProof: {
        confirm: 'Diesen Zahlungsnachweis akzeptieren?',
        title: 'Nachweis akzeptieren',
        success: 'Nachweis akzeptiert',
      },
      rejectProof: {
        prompt: 'Grund für die Ablehnung',
        title: 'Nachweis ablehnen',
        success: 'Nachweis abgelehnt',
      },
    },
    paymentStatus: {
      PENDING_COLLECTION: 'Zahlung ausstehend',
      AWAITING_PROOF: 'Nachweis ausstehend',
      PROOF_SUBMITTED: 'Nachweis eingereicht',
      PROCESSING: 'Wird verarbeitet',
      PAID: 'Bezahlt',
      REJECTED: 'Abgelehnt',
      VOID: 'Ungültig',
      REFUNDED: 'Rückerstattung erfolgt',
      PARTIALLY_REFUNDED: 'Teilweise rückerstattet',
      AWAITING_CARD_PAYMENT: 'Kartenzahlung ausstehend',
    },
    paymentMethod: {
      CASH: 'Bargeld',
      MANUAL: 'Banküberweisung',
      ONLINE: 'Karte',
    },
    refund: {
      reasons: {
        CUSTOMER_REQUEST: 'Kundenwunsch',
        ITEM_UNAVAILABLE: 'Artikel nicht verfügbar',
        WRONG_ITEM: 'Falscher Artikel',
        LATE_DELIVERY: 'Verspätete Lieferung',
        CANCELLED_BY_OWNER: 'Vom Eigentümer storniert',
        OTHER: 'Sonstiges',
      },
      issued: 'Rückerstattung ausgegeben',
      now: 'Jetzt erstatten',
      confirmNow: (amount) => `${amount} jetzt an den Kunden erstatten?`,
      failed: 'Rückerstattung konnte nicht ausgeführt werden.',
      failedReason: (reason) => `Rückerstattung fehlgeschlagen: ${reason}`,
      recordedPending: 'Rückerstattung erfasst — Auszahlung ausstehend.',
      info: (amount) => `Bis zu ${amount} rückerstattbar.`,
      amountLabel: 'Betrag',
      reasonLabel: 'Grund',
      amountError:
        'Geben Sie einen Betrag zwischen 0 und dem verbleibenden rückerstattungsfähigen Betrag ein.',
      outOfBandNote:
        'Rückerstattungen für diese Kartenzahlung werden außerhalb der App über Ihren Zahlungsanbieter bearbeitet.',
      button: 'Rückerstattung ausstellen',
      submitButton: (amount) => `Rückerstattung ${amount}`,
    },
    section: {
      items: 'Artikel',
      deliveryAddress: 'Lieferadresse',
      payment: 'Zahlung',
      refund: 'Rückerstattung',
      customerNote: 'Kundennotiz',
      timeline: 'Zeitleiste',
      labels: 'Labels',
    },
    // Operator triage tags on an order (chip row on the detail, compact
    // pills on the list rows). Label NAMES are owner data — never translated.
    fields: {
      status: 'Status',
      kitchen: 'Küche',
      subtotal: 'Summe',
      deliveryFee: 'Liefergebühr',
      discount: 'Rabatt',
      promoCode: 'Rabattcode',
      total: 'Gesamtsumme',
      method: 'Methode',
      placed: 'Aufgegeben',
      scheduledFor: 'Geplant für',
      estimatedReady: 'Geschätzt bereit',
      prepStarted: 'Vorbereitung gestartet',
      refunded: 'Rückerstattung erfolgt',
      acceptProof: 'Nachweis akzeptieren',
      rejectProof: 'Nachweis ablehnen',
    },
    kitchen: {
      QUEUED: 'In der Warteschlange',
      PREPARING: 'Wird vorbereitet',
      READY: 'Bereit',
      SERVED: 'Serviert',
    },
    quickAction: {
      callCustomer: 'Kunde anrufen',
      messageCustomer: 'Kunde benachrichtigen',
      call: 'Anrufen',
      message: 'Nachricht',
      printTicket: 'Bon drucken',
      printTicketAria: 'Küchenbon für diese Bestellung drucken',
      printQueued: 'Küchenbon in der Warteschlange',
      printQueuedMany: (n: number) => `${n} Küchenbons in der Warteschlange`,
      printFailed: 'Küchenbon konnte nicht eingereiht werden',
    },
    pause: {
      live: 'Live',
      paused: 'Angehalten',
      pausedUntilClose: 'Angehalten · Schließung',
      pausedUntilTime: (time) => `Angehalten · ${time}`,
      action: {
        label: (label) => `${label} Bestellung`,
        pause30: '30 Minuten anhalten',
        pause1hour: '1 Stunde anhalten',
        pauseHours: (n) => `${n} Stunden pausieren`,
        pauseUntilClose: 'Bis zur Schließung anhalten',
        resumeNow: 'Jetzt fortsetzen',
      },
      toast: {
        paused: (label) => `${label} angehalten`,
        pausedFor: (label, minutes) => `${label} für ${minutes} Minuten angehalten`,
        pausedUntilClose: (label) => `${label} bis zur Schließung angehalten`,
        resumed: (label) => `${label} fortgesetzt`,
      },
    },
    summary: {
      total: 'Gesamtsumme',
      pending: 'Ausstehend',
      confirmed: 'Bestätigt',
    },
    page: {
      title: 'Bestellungen',
    },
    detail: {
      title: 'Bestellung',
    },
    list: {
      section: {
        pending: 'Ausstehend',
        confirmed: 'Bestätigt',
        completed: 'Abgeschlossen',
        cancelled: 'Storniert',
      },
    },
    stages: {
      NEEDS_REVIEW: 'Zahlung prüfen',
      NEEDS_ACCEPTANCE: 'Neue Bestellungen',
      IN_KITCHEN: 'In der Küche',
      READY: 'Bereit',
      AWAITING_PAYMENT: 'Warten auf Kundenzahlung',
      COMPLETED: 'Abgeschlossen',
      CANCELLED: 'Storniert',
    },
    summaryBar: {
      pending: 'Aktion nötig',
      active: 'Aktiv',
      overdue: 'Überfällig',
    },
    all: 'Alle',
    filter: 'Filter',
    now: 'Jetzt',
    copy: 'Kopieren',
    addressCopied: 'Adresse kopiert',
    phoneCopied: 'Telefonnummer kopiert',
    tel: 'Tel.:',
    openInMaps: 'In Google Maps öffnen',
    mapRoute: 'Route',
    mapDestination: 'Ziel',
    deliveryDistance: (distance: string) => `${distance} vom Restaurant entfernt`,
    expired: 'Abgelaufen',
    autoCancelsIn: 'Automatische Stornierung in',
    pickupLocation: 'Abholort',
    paymentProof: 'Zahlungsnachweis',
    zoneMethod: {
      STRAIGHT_LINE: 'Luftlinie',
      ROUTE_DISTANCE: 'Fahrstrecke (MapBox)',
      POLYGON: 'Kartenzone',
    },
    zoneLabel: (label, method) => `Zone: ${label} · ${method}`,
    ordersCount: (n) => `${n} Bestellung${n !== 1 ? 'en' : ''}`,
    ordersByHour: (n) => `${n} Bestellung${n !== 1 ? 'en' : ''} pro Stunde`,
    ordersByHourLabel: 'Bestellungen pro Stunde',
    chartBusiest: (label, count) => `. Stoßzeit ${label} · ${count}`,
    capacityPerHour: (cap, label) => `${cap}/Std ${label}`,
    nextTwoHours: (n) => `Nächste 2 Std · ${n} Bestellung${n !== 1 ? 'en' : ''}`,
    sectionCount: (label, count) => `${label} · ${count}`,
    proof: {
      openPdf: 'Hochgeladenen PDF-Nachweis öffnen',
      alt: 'Zahlungsnachweis des Kunden',
      openFullSize: 'In voller Größe öffnen',
      customerStated: (amount) => `Kunde gab an: ${amount}`,
      uploaded: (when) => `Hochgeladen ${when}`,
      rejectHint: 'Bestellung bleibt offen - der Kunde kann bis zum Zahlungsende erneut hochladen.',
      rejectSuccess: 'Nachweis abgelehnt - Bestellung bleibt für erneutes Hochladen offen',
    },
    paymentStatusLabels: {
      PENDING_COLLECTION: 'Einzug ausstehend',
      AWAITING_PROOF: 'Nachweis ausstehend',
      PROOF_SUBMITTED: 'Nachweis eingereicht',
      PROCESSING: 'Wird verarbeitet',
      ON_HOLD: 'In Prüfung',
      PAID: 'Bezahlt',
      REJECTED: 'Abgelehnt',
      VOID: 'Ungültig',
      REFUNDED: 'Rückerstattung erfolgt',
      PARTIALLY_REFUNDED: 'Teilweise rückerstattet',
      awaitingCardPayment: 'Kartenzahlung ausstehend',
      underReviewByProvider: 'In Prüfung durch Anbieter',
      awaitingCardCollection: 'Karteneinzug ausstehend',
    },
    methodKind: {
      CASH: 'Bargeld',
      CARD_ON_HANDOFF: 'Karte bei Übergabe',
      MANUAL: 'Banküberweisung',
      ONLINE: 'Karte',
      GIFT_CARD: 'Geschenkkarte',
    },
    pill: {
      paid: 'Bezahlt',
      refunded: 'Rückerstattet',
      awaiting: 'Zahlung ausstehend',
      failed: 'Zahlung fehlgeschlagen',
      refundNeeded: 'Rückerstattung nötig',
    },
    refundExtra: {
      max: (amount, currency) => `Max ${amount} (${currency})`,
      confirmSettled: 'Als beglichen bestätigen',
      settled: '✓ Beglichen',
      failed: 'Rückerstattung fehlgeschlagen',
      settlePrompt:
        'Bestätigen Sie, dass Sie diese Rückerstattung außerhalb der App an den Kunden gezahlt haben?',
      settleTitle: 'Rückerstattung als beglichen bestätigen',
      settledToast: 'Rückerstattung beglichen',
      pending: (amount) => `+${amount} ausstehend`,
      pendingShort: 'Rückerstattung ausstehend',
    },
    channelStatus: {
      open: 'Offen',
      closed: 'Geschlossen',
      paused: 'Angehalten',
      close: 'Schließung',
    },
    timing: {
      asap: 'Sofort',
      labelScheduled: 'Geplant',
      labelReadyBy: 'Fertig bis',
      labelDeliveredBy: 'Geliefert bis',
      labelPlaced: 'Aufgegeben',
      dueNow: 'jetzt fällig',
      inMin: (m) => `in ${m} Min`,
      inHrMin: (h, m) => (m ? `in ${h} Std ${m} Min` : `in ${h} Std`),
      minOverdue: (m) => `${m} Min überfällig`,
      hrMinOverdue: (h, m) => (m ? `${h} Std ${m} Min überfällig` : `${h} Std überfällig`),
      placedAgo: (ago) => `aufgegeben ${ago}`,
      justNow: 'gerade eben',
      minAgo: (m) => `vor ${m} Min`,
      hrMinAgo: (h, m) => (m ? `vor ${h} Std ${m} Min` : `vor ${h} Std`),
      chipScheduled: 'geplant',
      chipReady: 'fertig',
      chipOverdue: 'überfällig',
      shortNow: 'jetzt',
      shortMin: (m) => `${m}m`,
      shortHr: (h) => `${h}h`,
    },
    awaitingPayment: {
      title: 'Warten auf Zahlung des Gastes',
      tooltip: 'Warten auf Zahlung des Gastes',
      refresh: 'Aktualisieren',
      loadError: 'Bestellungen, die auf Zahlung warten, konnten nicht geladen werden.',
      empty: 'Keine Bestellungen warten auf Zahlung',
      emptyDescription:
        'Bestellungen, die auf einen Überweisungsnachweis oder eine Online-Zahlung warten, erscheinen hier.',
      footer:
        'Diese Bestellungen sind noch nicht in der Küchenwarteschlange. Sie wechseln zu Bestellungen, sobald die Zahlung bestätigt ist, und werden nach Ablauf der Frist automatisch storniert.',
      expiresIn: 'Zahlungsfrist:',
      noDeadline: 'keine Frist',
      call: (name: string) => `Anrufen ${name}`,
    },
    history: {
      title: 'Bestellverlauf',
      tooltip: 'Bestellverlauf',
      refresh: 'Aktualisieren',
      loading: 'Bestellungen werden geladen…',
      loadError: 'Verlauf konnte nicht geladen werden.',
      tryAgain: 'Erneut versuchen',
      empty: 'Keine Bestellungen in diesem Zeitraum.',
      today: 'Heute',
      yesterday: 'Gestern',
      filters: 'Filter',
      reset: 'Zurücksetzen',
      showOrders: 'Bestellungen anzeigen',
      prevMonth: 'Vorheriger Monat',
      nextMonth: 'Nächster Monat',
      weekdayInitials: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
      tabs: {
        all: 'Alle',
        pending: 'Ausstehend',
        active: 'Aktiv',
        done: 'Erledigt',
        void: 'Ungültig',
      },
      statusLabel: {
        PENDING: 'Ausstehend',
        CONFIRMED: 'In Bearbeitung',
        COMPLETED: 'Abgeschlossen',
        CANCELLED: 'Storniert',
      },
    },
  },

  print: {
    // Server Direct Print (shared: Printers list + Printer add/edit form)
    serverDirectTitle: 'Server Direct Print',
    serverDirectFooter:
      'Geben Sie diese beiden URLs in die Server-Direct-Print-Einrichtung jedes Epson-Druckers ein, zusammen mit der eigenen Drucker-ID dieses Druckers (wird angezeigt, wenn Sie den Drucker öffnen).',
    printUrlLabel: 'Druck-URL',
    notificationUrlLabel: 'Benachrichtigungs-URL',
    printerIdLabel: 'Drucker-ID',
    copyButton: 'Kopieren',
    copied: (label) => `${label} kopiert`,
    okButton: 'OK',

    // Printer status (shared: printer badges + status-history events)
    statusOnline: 'Online',
    statusOffline: 'Offline',
    statusError: 'Fehler',
    defaultBadge: 'Standard',

    // Printers list page
    couldntLoadPrinters: 'Drucker konnten nicht geladen werden',
    noPrintersTitle: 'Noch keine Drucker',
    noPrintersDesc:
      'Fügen Sie den Küchendrucker hinzu, damit ausgelöste Bestellungen gedruckt werden. Tippen Sie auf +, um zu beginnen.',
    printersTitle: 'Drucker',
    printersFooter:
      'Der Status wird aktualisiert, wenn sich jeder Drucker meldet. Ein Drucker, der sich kürzlich nicht gemeldet hat, zeigt Offline; wartende Tickets bleiben in der Warteschlange und drucken, sobald er wieder verfügbar ist.',
    queued: (n) => `${n} in Warteschlange`,
    noJobsQueued: 'Keine Aufträge in der Warteschlange',
    routingAndHistoryTitle: 'Weiterleitung & Verlauf',
    routingTitle: 'Ticketweiterleitung',
    historyTitle: 'Druckverlauf',
    behaviourTitle: 'Was gedruckt wird',

    // What-to-print settings page
    behaviourPageTitle: 'Was gedruckt wird',
    behaviourPageFooter:
      'Legen Sie fest, welche Bestätigungen automatisch ein Ticket drucken. Tickets gehen an den Standarddrucker.',
    printOnlineOrdersLabel: 'Online-Bestellungen',
    printOnlineOrdersFooter:
      'Druckt ein Küchenticket, sobald Sie eine Abhol- oder Lieferbestellung annehmen.',
    printReservationsLabel: 'Bestätigte Reservierungen',
    printReservationsFooter:
      'Druckt ein Service-Ticket, wenn Sie eine Reservierung bestätigen. Standardmäßig aus.',
    onlineOrdersUpdated: 'Druck für Online-Bestellungen aktualisiert',
    reservationsUpdated: 'Druck für Reservierungen aktualisiert',

    // Ticket text size
    textSizeTitle: 'Ticket-Text',
    textSizeLabel: 'Schriftgröße',
    textSizeMedium: 'Mittel',
    textSizeLarge: 'Groß',
    textSizeFooter:
      'Große Schrift ist quer durch die Küche besser lesbar, passt aber weniger in eine Zeile und braucht etwa doppelt so viel Papier. Mit dem Testdruck an einem Drucker ansehen.',
    textSizeUpdated: 'Schriftgröße für Tickets aktualisiert',
    itemCategoryLabel: 'Kategorie unter jedem Artikel anzeigen',
    itemCategoryFooter:
      'Druckt die Menükategorie in Klammern unter jeden Artikel, z. B. [Getränke]. Nützlich, wenn ein Drucker mehrere Stationen bedient; zum Kürzen des Bons ausschalten.',
    itemCategoryUpdated: 'Kategoriezeile aktualisiert',
    itemLabelTitle: 'Artikelbezeichnung',
    itemLabelName: 'Nur Name',
    itemLabelCodeAndName: 'Nummer und Name',
    itemLabelCodeOnly: 'Nur Nummer',
    itemLabelFooter:
      'Menünummern halten den Bon kurz – vor allem bei großer Schrift. Ein Gericht ohne Nummer druckt immer seinen Namen, egal welche Option Sie wählen.',
    itemLabelUpdated: 'Artikelbezeichnung aktualisiert',
    dateTimeFormatLabel: 'Datumsformat',
    dateTimeFormatFooter:
      'So steht das Datum auf jedem Ticket. Uhrzeiten werden immer im 24-Stunden-Format gedruckt, z. B. 19:30.',
    dateTimeFormatUpdated: 'Datumsformat aktualisiert',
    // Ticket-Vorschau
    previewTitle: 'Ticket-Vorschau',
    previewFooter:
      'Ein Beispiel-Ticket mit den Einstellungen oben – so druckt es Ihr Drucker. Schriftgröße, Kategorien und Artikelbezeichnung wirken sofort.',
    previewError: 'Vorschau konnte nicht erstellt werden.',

    // Printer add/edit form
    editPrinterTitle: 'Drucker bearbeiten',
    addPrinterTitle: 'Drucker hinzufügen',
    printerGone: 'Dieser Drucker existiert nicht mehr.',
    nameLabel: 'Name',
    namePlaceholder: 'z.B. Küche, Bar, Kassenzone',
    activeLabel: 'Aktiv',
    defaultPrinterLabel: 'Standarddrucker',
    defaultPrinterFooter:
      'Tickets für Menükategorien ohne eigenen Drucker - und jede Online-Bestellung - drucken auf dem Standarddrucker.',
    migratingTitle: 'Einen Drucker migrieren?',
    migratingFooter:
      'Bereits einen Epson-Drucker im alten System eingerichtet? Fügen Sie hier dessen Drucker-ID ein, damit er ohne erneute Kopplung weiter druckt. Leer lassen, und wir erzeugen eine neue.',
    existingIdLabel: 'Bestehende Drucker-ID',
    existingIdPlaceholder: 'Leer lassen, um eine neue zu erzeugen',
    printerSetupTitle: 'Druckereinrichtung',
    printerSetupFooter:
      'Öffnen Sie die Server-Direct-Print-Einrichtung des Druckers und geben Sie die Druck-URL, die Benachrichtigungs-URL und diese Drucker-ID ein, damit er mit In-House gekoppelt wird.',
    // Testdruck
    testPrintButton: 'Testbeleg drucken',
    testPrintSending: 'Wird gesendet…',
    testPrintFooter:
      'Sendet einen Testbeleg an diesen Drucker. Er druckt wenige Sekunden nach der nächsten Abfrage des Druckers.',
    testPrintQueued: 'Testbeleg gesendet — Drucker beobachten',
    testPrintFailed: 'Testbeleg konnte nicht gesendet werden.',

    statusHistoryTitle: 'Statusverlauf',
    eventConnected: 'Verbunden',
    noStatusEvents: 'Noch keine Statusänderungen erfasst',
    noStatusEventsFooter: 'Verbindungsstatus und Fehler erscheinen hier, sobald sie auftreten.',
    nameRequired: 'Geben Sie dem Drucker einen Namen.',
    saveFailed: 'Konnte nicht gespeichert werden.',
    idFormatInvalid: 'Die Drucker-ID muss 8–16 Buchstaben und Zahlen enthalten.',
    printerUpdated: 'Drucker aktualisiert',
    printerAdded: 'Drucker hinzugefügt',

    // Ticket routing page (stations / pages)
    routingNoPrintersDesc:
      'Fügen Sie zunächst einen Drucker hinzu und legen Sie dann fest, wo jede Bestellung druckt.',
    noneSet: 'Nicht festgelegt',
    noMenuCategories: 'Noch keine Menükategorien.',
    mainPrinterLabel: 'Hauptdrucker',
    mainPrinterFooter:
      'Die gesamte Bestellung druckt hier - und Artikel, die keiner Station unten zugewiesen sind, drucken ebenfalls hier.',
    splitTitle: 'Nach Station aufteilen',
    splitToggleLabel: 'Küchenbons aufteilen',
    splitFooter:
      'An: Jede Bestellung wird anhand der Stationen unten auf die Stationsdrucker aufgeteilt. Aus: Die gesamte Bestellung druckt als ein Bon auf dem Hauptdrucker.',
    splitUpdated: 'Bon-Aufteilung aktualisiert',
    stationsTitle: 'Stationen',
    stationsFooter:
      'Jede Station druckt die ihr zugewiesenen Menükategorien. Kategorien ohne Station drucken auf dem Hauptdrucker.',
    addStationLabel: 'Station hinzufügen',
    stationCategoriesCount: (n) => (n === 1 ? '1 Kategorie' : `${n} Kategorien`),
    stationSelectionSummary: (categories: number, products: number) => {
      const cat = categories === 1 ? '1 Kategorie' : `${categories} Kategorien`;
      if (products === 0) return cat;
      const prod = products === 1 ? '1 Produkt' : `${products} Produkte`;
      return `${cat} · ${prod}`;
    },
    expoTitle: 'Expo-Kopie',
    expoToggleLabel: 'Auch einen vollständigen Bon auf dem Hauptdrucker drucken',
    expoFooter:
      'Druckt einen Bon mit allen Artikeln auf dem Hauptdrucker - die Expo-/Pass-Kopie. Stationen erhalten weiterhin ihre eigenen Bons.',
    expoUpdated: 'Expo-Kopie aktualisiert',

    // Station (page) edit form
    editStationTitle: 'Station bearbeiten',
    addStationTitle: 'Station hinzufügen',
    stationNameLabel: 'Name',
    stationNamePlaceholder: 'z.B. Warme Küche, Bar, Grill',
    stationPrinterTitle: 'Drucker',
    noActivePrinters:
      'Keine aktiven Drucker. Fügen Sie zuerst einen hinzu oder aktivieren Sie einen.',
    stationCategoriesTitle: 'Menükategorien',
    stationCategoriesFooter: 'Wählen Sie die Kategorien, die diese Station druckt.',
    stationMenuTitle: 'Menü — Tippen Sie auf eine Kategorie zum Aufklappen',
    stationMenuFooter:
      'Kategorie anhaken, um sie ganz zu drucken. Aufklappen und einzelne Produkte anhaken, um sie stattdessen dieser Station zuzuweisen.',
    viaCategory: 'über Kategorie',
    legendAll: 'Ganze Kategorie druckt auf dieser Station',
    legendPartial: 'Teilweise – einzelne Produkte einer anderen Station zugewiesen',
    legendOther: 'Eine andere Station beansprucht diesen Eintrag',
    stationProductsTitle: 'Einzelne Produkte',
    stationProductsFooter:
      'Hier ausgewählte Produkte überschreiben ihre Kategorie – nutzen Sie das, wenn eine Kategorie mehrere Stationen mischt.',
    noMenuProducts: 'Noch keine Menüprodukte.',
    claimedByStation: (station: string) => `Auf ${station}`,
    stationDeleteButton: 'Station löschen',
    stationGone: 'Diese Station existiert nicht mehr.',
    stationSaved: 'Station gespeichert',
    stationDeleted: 'Station gelöscht',
    stationNameRequired: 'Geben Sie der Station einen Namen.',
    stationPrinterRequired: 'Wählen Sie einen Drucker.',

    // Print history (jobs) page
    jobStatusAll: 'Alle',
    jobStatusQueued: 'In der Warteschlange',
    jobStatusPrinting: 'Wird gedruckt',
    jobStatusPrinted: 'Gedruckt',
    jobStatusFailed: 'Fehlgeschlagen',
    couldntLoadJobs: 'Druckverlauf konnte nicht geladen werden',
    noJobsTitle: 'Keine Druckaufträge',
    noJobsDesc: 'Tickets werden hier angezeigt, sobald Bestellungen ausgelöst werden.',
    receiptLabel: 'Beleg',
    kitchenTicketLabel: 'Küchenticket',
    reprintButton: 'Erneut drucken',
    reprintQueued: 'Erneuter Druck in Warteschlange eingereiht',
    copyContent: 'Druckinhalt kopieren',
    contentCopied: 'Druckinhalt kopiert',
    reprintFooter:
      'Tippen Sie auf ein Ticket, um es erneut zu drucken - ein neuer Auftrag wird eingereiht; das Original bleibt im Verlauf.',
  },

  promotions: {
    title: 'Promotionen',
    newPromotion: 'Neue Promotion',
    editPromotion: 'Promotion bearbeiten',
    details: 'Details',
    name: 'Name',
    namePlaceholder: 'Wochenende 10% Rabatt',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Wird den Kunden im Schaufenster angezeigt',
    discount: 'Rabatt',
    discountType: {
      percentage: 'Prozentrabatt',
      fixedAmount: 'Festbetrag-Rabatt',
      freeDelivery: 'Kostenlose Lieferung',
    },
    percentOff: 'Prozentrabatt',
    percentOffHint: 'z.B. 10 für 10% Rabatt',
    maxDiscount: (currency) => `Maximaler Rabatt (${currency}, optional)`,
    maxDiscountPlaceholder: 'Keine Obergrenze',
    amountOff: (currency) => `Rabattbetrag (${currency})`,
    amountOffPlaceholder: '5.00',
    appliesto: 'Gilt für',
    scope: {
      wholeOrder: 'Gesamte Bestellung',
      selectedItems: 'Ausgewählte Artikel',
    },
    conditions: 'Bedingungen',
    orderType: {
      dineIn: 'Vor Ort essen',
      pickup: 'Abholung',
      delivery: 'Lieferung',
    },
    paymentMethodsTitle: 'Zahlungsmethoden',
    paymentMethodsFooter: 'Keine Auswahl = gilt für jede Zahlungsmethode',
    paymentMethod: {
      cash: 'Bar',
      cardOnHandoff: 'Karte bei Abholung/Lieferung',
      online: 'Online-Zahlung',
      manual: 'Überweisung',
    },
    minimumOrder: (currency) => `Mindestbestellung (${currency}, optional)`,
    minimumOrderPlaceholder: 'Kein Minimum',
    dateWindow: 'Zeitraum',
    starts: 'Anfang',
    startDate: 'Startdatum',
    ends: 'Ende',
    endDate: 'Enddatum',
    howUnlocked: 'Wie es entsperrt wird',
    trigger: {
      automatic: 'Automatisch (kein Code)',
      codeRequired: 'Erfordert einen Code',
    },
    codeType: {
      shared: 'Gemeinsamer Code (ein Code, alle)',
      personal: 'Persönliche Gutscheine (pro Kunde ausgestellt)',
    },
    code: 'Code',
    codePlaceholder: 'SAVE10',
    maxRedemptions: 'Maximale Einlösungen (optional)',
    maxRedemptionsPlaceholder: 'Unbegrenzt',
    oncePerCustomer: 'Einmal pro Kunde',
    visibilityStacking: 'Sichtbarkeit & Stapeln',
    showOnStorefront: 'Im Schaufenster anzeigen',
    showOnStorefrontFooter: 'Banner + Produktabzeichen für Gäste',
    stackable: 'Stapelbar',
    stackableFooter: 'Kann mit anderen stapelbaren Promotionen kombiniert werden',
    priority: 'Priorität',
    priorityHint: 'Niedrigere wird zuerst angewendet',
    savePromotion: 'Promotion speichern',
    giveNameError: 'Geben Sie der Promotion einen Namen.',
    pickOrderTypeError: 'Wählen Sie mindestens einen Bestelltyp aus.',
    chooseDiscountError: 'Wählen Sie, worauf der Rabatt angewendet wird.',
    saved: 'Promotion gespeichert',
    issuePersonalCoupon: 'Persönlichen Gutschein ausstellen',
    customer: 'Kunde',
    customerSearchPlaceholder: 'Nach Name oder Telefon suchen',
    change: 'Ändern',
    couponCode: 'Gutscheincode',
    couponCodePlaceholder: 'VIP-JANE',
    sharable: 'Teilbar',
    sharableFooter: 'Jeder mit dem Code kann ihn einlösen, nicht nur dieser Kunde',
    issuing: 'Wird ausgegeben…',
    issueCoupon: 'Gutschein ausstellen',
    pickCustomerError: 'Wählen Sie zunächst einen Kunden aus.',
    enterCouponError: 'Geben Sie einen Gutscheincode ein.',
    couponIssuedTo: (customerName) => `Gutschein ausgegeben für ${customerName}`,
    active: 'Aktiv',
    all: 'Alle',
    couldNotLoadError: 'Konnte Promotionen nicht laden',
    noneRunning: 'Derzeit läuft nichts',
    noneRunningDescription: 'Abgelaufene und geplante Angebote finden Sie unter Alle.',
    noneYet: 'Noch keine Promotionen',
    noneYetDescription:
      'Erstellen Sie einen Rabatt - ein Prozent- oder Festbetrag-Rabatt, automatisch oder durch einen Code entsperrt. Tippen Sie +.',
    codeDisplay: (code) => `Code: ${code}`,
    archivedBadge: 'Archiviert',
    scheduledBadge: 'Geplant',
    expiredBadge: 'Abgelaufen',
    codeBadge: 'Code',
    archive: 'Archivieren',
    archiveConfirm: (name) =>
      `"${name}" archivieren? Es wird sofort deaktiviert; der Einlösungsverlauf bleibt erhalten.`,
    archiveTitle: 'Promotion archivieren',
    archived: 'Promotion archiviert',
    howWorks: 'Wie Promotionen funktionieren',
    howWorksDescription:
      'Automatische Promotionen werden beim Checkout ohne Code angewendet. Code-Promotionen benötigen einen gemeinsamen Code (für alle) oder einen persönlichen Gutschein, den Sie für einen Kunden ausstellen. Rabatte werden im Schaufenster angezeigt und reduzieren die Bestellsumme.',
    // Kompakte Labels in der Promotionsliste.
    summaryPercent: (pct) => `${pct}% Rabatt`,
    summaryAmount: (amount) => `${amount} Rabatt`,
    summaryWholeOrder: 'ganze Bestellung',
    summaryCategories: (n) => `${n} Kategorie${n === 1 ? '' : 'n'}`,
    summaryProducts: (n) => `${n} Produkt${n === 1 ? '' : 'e'}`,
    summaryCashOnly: 'Nur Barzahlung',
    // Zustände & zusätzliche Validierung auf der Bearbeitungsseite.
    endBeforeStartError: 'Das Enddatum darf nicht vor dem Startdatum liegen.',
    scheduleWindowError:
      'Prüfen Sie die Tag- & Stundenfenster - jede Endzeit muss nach ihrer Startzeit liegen.',
    loadingMenu: 'Menü wird geladen…',
    menuLoadError: 'Menü konnte nicht geladen werden. Zum Wiederholen ziehen.',
    noCategoriesYet: 'Noch keine Kategorien - fügen Sie sie zuerst unter Menü hinzu.',
    noProductsYet: 'Noch keine Produkte - fügen Sie sie zuerst unter Menü hinzu.',
    // Wöchentlicher Tag-/Zeitplan.
    daysAndHours: 'Tage & Zeiten',
    limitToDays: 'Auf bestimmte Tage & Zeiten beschränken',
    limitToDaysFooter: 'Aus = gilt an jedem Tag im obigen Datumsfenster',
    windowLabel: (n) => `Fenster ${n}`,
    hours: 'Zeiten',
    addWindow: 'Fenster hinzufügen',
    startAria: (day) => `${day} Start`,
    endAria: (day) => `${day} Ende`,
    removeWindow: 'Fenster entfernen',
    customerFallback: 'Kunde',
    // Verlauf ausgegebener Coupons + persönliche Coupons eines Kunden.
    issuedCoupons: 'Ausgegebene Coupons',
    noCouponsIssued: 'Noch keine Coupons ausgegeben',
    customerCoupons: 'Persönliche Coupons',
    noCustomerCoupons: 'Noch keine persönlichen Coupons',
    couponUnused: 'Ungenutzt',
    couponRedeemed: 'Eingelöst',
    couponIssuedOn: (date) => `Ausgegeben ${date}`,
    couponRedeemedOn: (date) => `Verwendet ${date}`,
    loadingCoupons: 'Coupons werden geladen…',
    couldNotLoadCoupons: 'Coupons konnten nicht geladen werden',
    // Einfacher / Erweiterter Bearbeitungsmodus.
    simpleMode: 'Einfach',
    advancedMode: 'Erweitert',
    advancedValuesHint:
      'Dieser Rabatt nutzt erweiterte Optionen - wechseln Sie zu „Erweitert“, um sie zu sehen und zu bearbeiten.',
    // Beschriftungen der Auswahlfelder.
    discountTypeLabel: 'Typ',
    triggerLabel: 'Auslöser',
    codeTypeLabel: 'Code-Typ',
  },

  reports: {
    overview: {
      netSales: 'Nettoumsatz',
      onlineOrders: 'Online-Bestellungen',
      dineInTabs: 'Tische im Haus',
      tips: 'Trinkgeld',
      refunds: 'Erstattungen',
      discounts: 'Rabatte',
      vsPrevious: (baseline) => `ggü. ${baseline}`,
      couldntLoad: 'Berichte konnten nicht geladen werden',
      noSales: 'Kein Umsatz in diesem Zeitraum',
      noSalesHint:
        'Wähle einen anderen Zeitraum oder schau wieder rein, sobald Bestellungen eingehen.',
      seeAllItems: 'Alle ansehen',
      detailedReports: 'Detaillierte Berichte',
      tabSales: 'Umsatz',
      tabOperations: 'Betrieb',
      trendNeedsMoreDays: 'Wähle einen längeren Zeitraum, um einen Trend zu sehen.',
      byHour: 'Nach Stunde',
      tablesUsed: 'Genutzte Tische',
      turnsPerTable: (turns) => `${turns} Belegungen pro Tisch`,
      avgDwell: 'Ø Verweildauer',
      minutes: (count) => `${count} Min.`,
      busiestTables: 'Meistgenutzte Tische',
      turns: (count) => `${count} Belegungen`,
    },
    periodSelector: {
      current: 'Zeitraum',
      compare: 'Verglichen mit',
      basis: {
        previousPeriod: 'Vorheriger Zeitraum',
        samePeriodLastYear: 'Vorjahr',
      },
    },
    salesOverview: {
      title: 'Verkaufsübersicht',
      netSales: 'Nettoumsatz',
      gross: 'Bruttoumsatz',
      covers: 'Deckungen',
      avgTab: 'Durchschn. Rechnung',
      revenueTrend: 'Umsatztrend',
      byChannel: 'Nach Kanal',
      online: 'Online',
      dineIn: 'Vor Ort',
      byTimeOfDay: 'Nach Tageszeit',
    },
    dayParts: {
      breakfast: 'Frühstück',
      lunch: 'Mittagessen',
      afternoon: 'Nachmittag',
      dinner: 'Abendessen',
      late: 'Spät',
    },
    dayEnd: {
      title: 'Tagesabschluss',
      day: 'Tag',
      couldntLoad: 'Tagesabschluss konnte nicht geladen werden',
      netReceived: 'Netto erhalten',
      takings: 'Einnahmen',
      refunds: 'Rückerstattungen',
      serviceCharge: 'Servicegebühr',
      tipsPayout: 'Trinkgeld (Auszahlung)',
      vat: 'MwSt.',
      openTabsWarning: (count, plural) =>
        `${count} ${plural} noch offen - das sind Einnahmen bis jetzt, keine endgültige Zahl.`,
      tabPlural: 'Rechnung ist',
      tabsPluralForm: 'Rechnungen sind',
      reconciliation: 'Vom Nettoumsatz zu den Einnahmen',
      netSales: 'Nettoumsatz',
      deliveryFees: 'Liefergebühren',
      refundsAddedBack: 'Erstattungen (oben bereits abgezogen)',
      otherDifference: 'An einem anderen Tag bezahlt',
      byPaymentMethod: 'Nach Zahlungsart',
      cashUp: 'Bargeld auszählen',
      expectedInDrawer: 'Erwarteter Betrag in der Kasse',
      counted: 'Gezählt',
      countedPlaceholder: 'Geben Sie den gezählten Betrag ein',
      balanced: 'Ausgeglichen',
      over: 'Über',
      short: 'Unter',
    },
    paymentReconciliation: {
      title: 'Zahlungsabstimmung',
      couldntLoad: 'Bericht konnte nicht geladen werden',
      paymentCount: (count, plural) => `${count} ${plural}`,
      paymentSingular: 'Zahlung',
      paymentPlural: 'Zahlungen',
      grossTaken: 'Brutto erhalten',
      refunds: 'Rückerstattungen',
      net: 'Netto',
      tips: 'Trinkgelder',
    },
    topItems: {
      title: 'Bestseller',
      byQuantity: 'Nach Menge',
      byRevenue: 'Nach Umsatz',
      couldntLoad: 'Bericht konnte nicht geladen werden',
      noSalesYet: 'Noch keine Verkäufe',
      noItemsSoldInRange: 'Keine Artikel in diesem Zeitraum verkauft.',
      sold: (quantity) => `${quantity} verkauft`,
    },
    rangePresets: {
      today: 'Heute',
      yesterday: 'Gestern',
      thisWeek: 'Diese Woche',
      last7: 'Letzte 7',
      thisMonth: 'Diesen Monat',
    },
  },

  reservationSetup: {
    title: 'Reservierungseinrichtung',
    bookings: 'Buchungen',
    bookingsFooter:
      'Online-Buchung ein- oder ausschalten, Anfragen automatisch bestätigen oder für den Rest des heutigen Tages pausieren.',
    acceptingReservations: 'Reservierungen akzeptieren',
    on: 'An',
    off: 'Aus',
    stopAcceptingOnline:
      'Online-Reservierungen nicht mehr akzeptieren? Die Buchungsseite wird vor Gästen verborgen und neue Anfragen werden abgelehnt, bis Sie sie wieder aktivieren.',
    turnReservationsOff: 'Reservierungen ausschalten',
    startAcceptingOnline: 'Online-Reservierungen wieder akzeptieren?',
    turnReservationsOn: 'Reservierungen einschalten',
    reservationsTurnedOff: 'Reservierungen ausgeschaltet',
    reservationsTurnedOn: 'Reservierungen eingeschaltet',
    confirmation: 'Bestätigung',
    howBookingsConfirmed: 'Wie Buchungen bestätigt werden',
    automaticConfirm: 'Automatisch - sofort bestätigen',
    bookingsAutoConfirmed: 'Buchungen automatisch bestätigt',
    manualConfirm: 'Manuell - Mitarbeiter überprüfen jede Anfrage',
    bookingsManualReview: 'Buchungen benötigen manuelle Überprüfung',
    confirmationAutomatic: 'Automatisch',
    confirmationManual: 'Manuelle Überprüfung',
    confirmationFooter:
      'Wenn ausgeschaltet, ist die Buchungsseite vor Gästen verborgen und neue Online-Reservierungen werden abgelehnt. Bei automatischer Bestätigung wird eine Anfrage sofort gebucht; manuelle Überprüfung hält sie ausstehend, bis Mitarbeiter sie annehmen.',
    partySize: 'Gruppengröße',
    partySizeFooter:
      'Die größte Gruppe, die Gäste online buchen können, und die Nachricht, die angezeigt wird, wenn sie diese überschreiten.',
    largestParty: 'Größte Gruppe',
    maxGuestsPerBooking: 'Maximale Anzahl der Gäste pro Buchung',
    partySizeUpdated: 'Gruppengröße aktualisiert',
    guestsCount: (count) => `${count} Gäste`,
    largePartyMessage: 'Nachricht für große Gruppen',
    largePartyMessageHidden: 'Verborgen',
    shownToGuestsAboveMax:
      'Angezeigt für Gäste, deren Gruppe über dem Maximum liegt (leer lassen zum Ausblenden)',
    messageUpdated: 'Nachricht aktualisiert',
    partySizeRange:
      'Der Bereich der Gruppengröße, den Gäste bei der Online-Reservierung wählen können. Größere Gruppen sehen statt eines Reservierungsformulars eine Meldung für große Gruppen.',
    bookingWindow: 'Reservierungsfenster',
    bookingWindowFooter:
      'Wie weit im Voraus Gäste buchen können, die Last-Minute-Frist und der Abstand zwischen buchbaren Zeiten.',
    guestsCanBookUpTo: 'Gäste können buchen bis',
    bookingHorizon: 'Reservierungshorizont',
    daysAheadGuests: 'Wie viele Tage im Voraus Gäste buchen können',
    bookingWindowUpdated: 'Reservierungsfenster aktualisiert',
    daysAhead: (count) => `${count} Tage im Voraus`,
    lastMinuteCutoff: 'Last-Minute-Stornofrist',
    hoursBeforeSlot: 'Stunden vor dem Zeitfenster, um Buchungen zu stoppen (0 = bis zum Beginn)',
    cutoffUpdated: 'Stornofrist aktualisiert',
    untilStart: 'Bis zum Start',
    hoursBefore: (hours) => `${hours}h vor`,
    slotSpacing: 'Zeitfenster-Abstände',
    minutesBetweenBookableTimes: 'Minuten zwischen buchbaren Zeiten',
    slotSpacingUpdated: 'Zeitfenster-Abstände aktualisiert',
    lastBookingBeforeClose: 'Letzte Buchung vor Schließung',
    stopBookingsBeforeClose: 'Buchungen vor Schließung stoppen',
    upToClose: 'Bis zur Schließung',
    lastBookingBeforeCloseUpdated: 'Letzte Buchung vor Schließung aktualisiert',
    everyMinutes: (minutes) => `Alle ${minutes} Minuten`,
    bookingWindowControls:
      'Steuert, wie weit der Kalender aufgeht, wie nah am Service Gäste noch buchen können, und den Abstand der Zeiten, die sie wählen können.',
    tableTiming: 'Tischzeit',
    tableTimingFooter:
      'Wie lange ein Tisch pro Buchung gehalten wird, damit er für den nächsten Gast wieder frei wird.',
    defaultTableTime: 'Standard-Tischzeit',
    tableHeldPerBooking:
      'Wie lange ein Tisch pro Reservierung gehalten wird, in Minuten (mindestens 15)',
    tableTimeUpdated: 'Tischzeit aktualisiert',
    tableTimingHint:
      'Wie lange jede Reservierung einen Tisch standardmäßig hält. Eine Überschreibung pro Schicht befindet sich unter Kapazität; der Turnaround-Puffer zwischen Gruppen wird dort ebenfalls eingestellt (erweiterter Modus).',
    noShows: 'Keine Anzeige',
    noShowsFooter:
      'Wie lange nach der Buchungszeit ein nicht erschienener Gast als Nichterscheinen zählt.',
    noShowGracePeriod: 'Kulanzfrist für Nichterscheinen',
    minutesPastBooking:
      'Minuten nach der Reservierungszeit, bevor ein Gast als nicht angezeigt gilt',
    gracePeriodUpdated: 'Kulanzfrist aktualisiert',
    noShowsHint:
      'Die Kulanzfrist steuert die Nichterscheinen-Warnungen - der Mitarbeiter wird benachrichtigt, sobald eine Reservierung um diese Anzahl von Minuten überfällig ist.',
    enterWholeNumber: (min) => `Geben Sie eine ganze Zahl von ${min} oder mehr ein`,
    enterWholeNumberBetween: (min, max) => `Geben Sie eine ganze Zahl von ${min} bis ${max} ein`,
    saveFailed: 'Speichern fehlgeschlagen',
    invalidValue: 'Ungültiger Wert',
    couldntLoadSettings: 'Reservierungseinstellungen konnten nicht geladen werden',
    checkConnection: 'Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    capacity: 'Kapazität',
    capacityMode: 'Kapazitätsmodus',
    capacityModeFooter:
      'Wählen Sie, wie Tische und Plätze verwaltet werden - ein gemeinsames Limit oder Tische je Zone mit Pacing.',
    simpleMode: 'Einfach',
    simpleModeDesc: 'Pro-Slot-Obergrenzen für Reservierungen / Plätze. Keine Pro-Tisch-Zuweisung.',
    simpleModeConfirm: 'Kapazität zum einfachen Modus wechseln?',
    simpleModeDetails:
      'Ein Slot ist ein 60-Minuten-Reservierungsfenster - z.B. der 19:00-Slot zählt jede Reservierung ab 19:00 bis 19:59.\n\nDie Standardobergrenzen gelten, wann immer keine zeitspezifische Schicht eine Reservierung abdeckt. Ohne Standard werden Reservierungen nur innerhalb zeitspezifischer Schichten akzeptiert.',
    advancedMode: 'Erweitert',
    advancedModeDesc:
      'Pacing-Obergrenzen (Plätze / Gruppen pro 15 Minuten) und Pro-Tisch-Zuweisung.',
    advancedModeConfirm: 'Kapazität zum erweiterten Modus wechseln?',
    advancedModeDetails:
      'Pacing-Obergrenzen gelten pro rollendem 15-Minuten-Fenster - feiner strukturiert als das einfache Slot-Modell und besser für belebte Services geeignet.\n\nJede Reservierung wird auch einem bestimmten Tisch aus dem Grundriss zugewiesen, so dass die Kapazität durch Pacing-Limits und physische Plätze begrenzt ist.',
    capacityModeColon: (mode) => `Kapazitätsmodus: ${mode}`,
    failedSwitchMode: 'Fehler beim Wechsel des Kapazitätsmodus',
    // Kapazitätsseite - Funktionspunkte der Modus-Kacheln
    simpleFeature1: 'Pro-Slot-Obergrenzen für Reservierungen & Plätze',
    simpleFeature2: 'Ein 60-Min-Buchungsfenster pro Slot',
    simpleFeature3: 'Keine Pro-Tisch-Zuweisung',
    advancedFeature1: 'Pacing-Obergrenzen pro rollende 15 Min',
    advancedFeature2: 'Gleichzeitigkeits-Obergrenzen (gleichzeitig aktiv)',
    advancedFeature3: 'Pro-Tisch-Zuweisung aus dem Grundriss',
    // Kapazitätsseite - Ladefehler-Zustand
    couldntLoadCapacity: 'Kapazitätseinstellungen konnten nicht geladen werden',
    serverNoResponse: 'Der Server hat nicht geantwortet. Bitte versuchen Sie es erneut.',
    retrying: 'Erneuter Versuch…',
    tryAgain: 'Erneut versuchen',
    // Kapazitätsseite - Inline-Beschriftungen / Platzhalter / Fußzeilen (noLimitation unten wiederverwendet)
    capacityAndLimit: 'Kapazität & Limit',
    pacingTitle: 'Pacing',
    concurrentTitle: 'Gleichzeitig',
    concurrentFooter:
      'Leer lassen für keine Beschränkung. Üblicherweise unter Ihrer Tischanzahl ansetzen.',
    unassignedZone: 'Nicht zugewiesen',
    aboutSection: (title) => `Über ${title}`,
    topGroup: (count, seats) => `${count}× ${seats}-Sitzer`,
    tblShortSeats: (count, seats) => `${count} Tische · ${seats} Plätze`,
    noBookableTablesPrefix: 'Noch keine buchbaren Tische konfiguriert.',
    noBookableTablesSuffix: 'um die ERWEITERTE Kapazität zu planen.',
    // Kapazitätsseite - Formatierungen der Schichtliste
    everyDay: 'Jeden Tag',
    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dayNamesLong: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    coversPer15: (n) => `${n} Plätze/15Min`,
    partiesPer15: (n) => `${n} Gruppen/15Min`,
    windowSubtitle: (start, end, days) => `${start}–${end} · ${days}`,
    // Kapazitätsseite - Tooltips der Vorschau-Zeitleiste (resSlot/coversSlot/pacingCovers unten wiederverwendet)
    capResCoversPerSlot: (res, covers) => `${res} Reservierungen / ${covers} Plätze pro Slot`,
    tablesAvailable: 'Verfügbare Tische',
    manage: 'Verwalten',
    noBookableTables:
      'Noch keine buchbaren Tische konfiguriert. Tische hinzufügen, um die ERWEITERTE Kapazität zu planen.',
    addTables: 'Tische hinzufügen',
    tblSeats: (count, seats) => `${count} Tische · ${seats} Plätze`,
    // German plural of "Zone" is "Zonen" - the EN 's' marker maps to 'n' here.
    bookableTablesInfo: (tables, seats, zones, plural) =>
      `${tables} buchbare Tische · ${seats} Plätze über ${zones} Zone${plural ? 'n' : ''}. Die ERWEITERTE Kapazität weist jede Reservierung einem bestimmten Tisch zu, daher ist die Sitzplatzkapazität durch das begrenzt, was sich am Boden befindet.`,
    tableturnaround: 'Tischturnaround',
    tableturnaroundInfo:
      'Minuten bleibt ein Tisch nach Ende einer Reservierung blockiert, bevor die nächste Gruppe dort platziert werden kann - Reinigung, Zurücksetzen, Abrechnung.\n\nWird zusätzlich zur Dauer jeder Reservierung bei der Zuweisung von Tischen angewendet. Wird nur im erweiterten Modus verwendet (Der einfache Modus zählt Slots, nicht die Tischauslastung).',
    bufferMin: 'Puffer (Min)',
    bufferUpdated: 'Puffer aktualisiert',
    bufferMustBePositive: 'Der Puffer muss 0 oder mehr Minuten sein',
    bufferInfo:
      'Abstand zwischen zwei Gruppen am selben Tisch. 0 = ununterbrochen. Gilt für jede erweiterte Schicht.',
    defaultPacing: 'Standard-Pacing (pro 15 Minuten)',
    pacingInfo:
      'Pacing begrenzt die Ankunftsrate - wie viele neue Reservierungen können in einem beliebigen rollendem 15-Minuten-Fenster STARTEN.\n\n"Max Plätze" begrenzt Gesamtgäste; "Max Gruppen" begrenzt Gesamtreservierungen. Zwei Gruppen, die 20 Minuten auseinander liegen, treffen nie auf dasselbe Pacing-Fenster, auch wenn sie sich am Boden überlappen - verwenden Sie dafür die folgenden Gleichzeitigkeitsgrenzen.\n\nSchützt den Moment, in dem Gäste hereinkommen: Küchenanlauf, Begrüßungs-/Bestuhldurchsatz.',
    maxCovers: 'Max. Plätze',
    maxParties: 'Max. Gruppen',
    defaultConcurrent: 'Standard-Gleichzeitigkeit (gleichzeitig aktiv)',
    concurrentInfo:
      'Gleichzeitigkeitsgrenzen begrenzen, wie viele Reservierungen zu jedem Moment AKTIV sein können - solche, deren [Start, Start + Dauer)-Intervall die angeforderte Zeit abdeckt.\n\nNützlich als weiches Limit unter physischen Plätzen: z.B. Sie haben 12 Tische, aber nur genug Mitarbeiter, um bequem 8 Gruppen auf einmal zu verwalten.\n\nUnabhängig vom Pacing: zwei Gruppen, die eine Stunde auseinander liegen, teilen nie ein Pacing-Fenster, können aber trotzdem beide platziert werden.',
    leaveBlankNoLimitation: 'Leer lassen, um keine Beschränkung zu haben.',
    shiftOverrideWarning:
      'Zeitspezifische Schichten unten ÜBERSCHREIBEN diese Standardlimits während ihrer Zeiten - setze auch pro Schicht ein Limit, sonst gilt es nicht.',
    detailOverrideWarning:
      'Diese Schicht ÜBERSCHREIBT die Standardlimits während ihrer Zeiten. Lege hier eigene Limits fest.',
    preview: 'Vorschau',
    defaultCoverage: 'Standard · ganztägig',
    maxReservationsSlot: 'Max. Reservierungen / Slot',
    capsLimit:
      'Limit für die Anzahl der Reservierungen (Gruppen), die in denselben 60-Minuten-Slot starten - schützt die Betriebslast, unabhängig von der Größe jeder Gruppe. Leer lassen, um keine Beschränkung zu haben.',
    maxCoversSlot: 'Max. Plätze / Slot',
    coversCapLimit:
      'Limit für die Gesamtgäste, die in denselben Slot starten - die Summe aller Gruppengröße. Schützt die Sitzplatzkapazität. Leer lassen, um keine Beschränkung zu haben.',
    clearDefault: 'Standard löschen',
    removeDefaultCapacity:
      'Die Standardkapazität entfernen? Reservierungen außerhalb einer zeitspezifischen Schicht werden abgelehnt.',
    timeSpecificShifts: 'Zeitspezifische Schichten',
    noTimeSpecificShifts:
      'Keine zeitspezifischen Schichten. Fügen Sie eine hinzu, um die Kapazität zu straffen (oder Buchungsstunden für ein bestimmtes Fenster zu öffnen).',
    addAShift: 'Schicht hinzufügen',
    newTimeSpecificShift: 'Neue zeitspezifische Schicht',
    name: 'Name',
    lunchDinner: 'Mittag / Abend …',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    shiftFooter:
      'Aktiv an jedem Tag der Woche, mit Limits, die vom Standard geerbt werden. Tippen Sie auf die neue Schicht, um Tage zu verfeinern und ihre Grenzen zu straffen.',
    shift: 'Schicht',
    shiftNotFound: 'Schicht nicht gefunden.',
    baselineEditedInline:
      'Diese Schicht ist die Grundlinie. Bearbeiten Sie sie von der Kapazitätsseite.',
    timeSpecificShiftTitle: 'Zeitspezifische Schicht',
    daysActive: 'Aktive Tage',
    capsSimple: 'Limits (Einfach)',
    maxReservationsSlotLabel: 'Max. Reservierungen / Slot',
    maxReservationsInfo:
      'Limit für die Anzahl der Reservierungen (Gruppen), die in denselben 60-Minuten-Slot starten - schützt die Betriebslast, unabhängig von der Größe jeder Gruppe.',
    maxCoversSlotLabel: 'Max. Plätze / Slot',
    maxCoversInfo:
      'Limit für die Gesamtgäste, die in denselben Slot starten - die Summe aller Gruppengröße. Schützt die Sitzplatzkapazität.',
    leaveBlankStricter:
      'Leer lassen für keine Beschränkung. Strenger als die Grundlinie → gewinnt in diesem Fenster.',
    pacingSimple: 'Pacing (pro 15 Minuten)',
    concurrentSimple: 'Gleichzeitig (gleichzeitig aktiv)',
    partySizePacing:
      'Pacing-Buckets pro Gruppengröße werden unverändert beibehalten - hier gibt es noch keine UI für sie.',
    deleteShift: 'Schicht löschen',
    deleteShiftConfirm: (label) => `Schicht "${label}" löschen?`,
    shiftSaved: 'Schicht gespeichert',
    failedSaveShift: 'Fehler beim Speichern der Schicht',
    failedDeleteShift: 'Fehler beim Löschen der Schicht',
    nameRequired: 'Name ist erforderlich',
    timesMustBeHHmm: 'Uhrzeiten müssen HH:mm sein',
    startBeforeEnd: 'Start muss vor Ende sein',
    pickAtLeastOneDay: 'Wählen Sie mindestens einen Tag',
    capsPositiveWhole:
      'Limits müssen positive ganze Zahlen sein (oder leer für keine Beschränkung)',
    tables: 'Tische',
    tableManagement: 'Tischverwaltung',
    noZones: 'Noch keine Zonen. Fügen Sie zuerst eine Zone hinzu, dann fügen Sie Tische hinzu.',
    addAZone: 'Zone hinzufügen',
    noTablesYet: 'Noch keine Tische',
    addTablesLink: '+ Tische hinzufügen',
    seatTables: (seats) => `${seats}-Platz-Tische`,
    seatsTotal: (seats, count) => `Insgesamt ${seats * count} Plätze`,
    tablesCount: (count) => `${count} Tische`,
    addZone: '+ Zone hinzufügen',
    newZone: 'Neue Zone',
    zoneName: 'Zonenname',
    zoneNameExample: 'z.B. Main, Patio, Bar',
    zoneAdded: 'Zone hinzugefügt',
    renameZone: 'Zone umbenennen',
    zoneRenamed: 'Zone umbenannt',
    deleteZone: 'Zone löschen',
    addTableZone: (zone) => `Tische hinzufügen - ${zone}`,
    seatsPerTable: 'Plätze pro Tisch',
    numberOfTables: 'Anzahl der Tische',
    addedTables: (count) => `${count} Tische hinzugefügt`,
    editSeatTables: (seats, zone) => `${seats}-Platz-Tische - ${zone}`,
    setToDeactivateAll: 'Auf 0 setzen, um alle zu deaktivieren',
    tableUpdated: 'Tisch aktualisiert',
    removeAllTables: (count, seats, zone) =>
      `Alle ${count} × ${seats}-Platz-Tische von ${zone} entfernen?`,
    removeTables: 'Tische entfernen',
    tablePlan: 'Tischplan',
    advancedTables: 'Erweiterte Tische',
    simplesMode: 'Einfach',
    simpleModeTableDesc:
      'Verwalten Sie Tische nach Anzahl und Sitzgröße. Kein Grundriss erforderlich.',
    switchSimple: 'Zum einfachen Modus wechseln?',
    advancedModeTable: 'Erweitert',
    advancedModeTableDesc:
      'Platzieren Sie Tische auf einem 2D-Grundriss für präzises Layout und automatische Zuweisung.',
    switchAdvanced: 'Zum erweiterten Modus wechseln?',
    tableModeColon: (mode) => `Tischmodus: ${mode}`,
    failedSwitchTableMode: 'Fehler beim Wechsel des Tischmodus',
    tablesFloorPlan: 'Tische & Grundriss',
    manageTables: 'Tische verwalten',
    batchAddTables: 'Tische stapelweise hinzufügen',
    labelPrefix: 'Etikett-Präfix',
    labelPrefixExample:
      'Tische werden T1, T2 … gekennzeichnet (fortgesetzt ab dem höchsten vorhandenen)',
    seatCategories: 'Sitzkategorien',
    seats: 'Plätze',
    qty: '× Menge',
    addSeatCategory: '+ Sitzkategorie hinzufügen',
    createdTables: (count) => `${count} Tische erstellt`,
    editTable: 'Tisch bearbeiten',
    labelOverride: 'Label überschreiben',
    useAutoGenerated: 'Leer lassen, um das automatisch generierte Label zu verwenden',
    active: 'Aktiv',
    countsForCapacity: 'Zählt zur Kapazität',
    bookableOnline: 'Online buchbar',
    tableGone: 'Dieser Tisch existiert nicht mehr.',
    decrease: 'Verringern',
    increase: 'Erhöhen',
    noTablesConfigured:
      'Noch keine Tische. Verwenden Sie "Stapelweise hinzufügen", um Tische zu erstellen.',
    floorPlan: 'Grundriss',
    dragDropEditor:
      'Der Drag-and-Drop-Editor für den Grundriss kommt als nächstes. Das Backend ist bereit - dieser Bildschirm wird einen Canvas rendern, auf dem Sie Tische platzieren, Größen ändern und drehen, Wände zeichnen und ein Hintergrundbild einstellen können.',
    floorPlanVersion: (version, placed, total) =>
      `Version ${version} · ${placed} von ${total} Tischen platziert.`,
    editorLargerScreen:
      'Der Grundriss-Editor benötigt einen größeren Bildschirm mit einer Maus - öffnen Sie das Dashboard auf einem Desktop zum Bearbeiten. Hier ist eine schreibgeschützte Zusammenfassung:',
    placed: (count) => `Platziert (${count})`,
    noTablesPlaced: 'Noch keine Tische wurden auf dem Canvas platziert.',
    notPlaced: (count) => `Nicht platziert (${count})`,
    zones: 'Zonen',
    noZonesYet:
      'Noch keine Zonen. Zonen gruppieren Tische, die sich physisch in der Nähe befinden - sie begrenzen, welche Tische für eine Reservierung zusammengeführt werden können.',
    deleteZoneConfirm: (label) =>
      `Zone "${label}" löschen? Tische bleiben erhalten, werden aber zonenfrei.`,
    failedCreateZone: 'Fehler beim Erstellen der Zone',
    failedDeleteZone: 'Fehler beim Löschen der Zone',
    zoneNamePrompt: 'Zonenname (z.B. "Terrasse", "Innenbereich")',
    largePartyMessagePrompt:
      'Angezeigt für Gäste, deren Gruppe über dem Maximum liegt (leer lassen zum Ausblenden)',
    tablesToPlace: (count, plural) => `${count} Tische${plural} zum Platzieren`,
    autoPlace: 'Automatisch platzieren',
    removeTable: 'Tisch entfernen',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    fitToTables: 'An Tische anpassen',
    fitToPlan: 'An Plan anpassen',
    seater: (seats) => `${seats}-Platz`,
    seatersCount: (count) => `· ${count}`,
    // --- AdvancedTablesPage (page-specific copy) ---
    noZoneLabel: 'Keine Zone',
    inactiveBadge: 'Inaktiv',
    noCapacityBadge: 'Zählt nicht zur Kapazität',
    notOnlineBadge: 'Nicht online buchbar',
    seatsCount: (n) => `${n} Plätze`,
    deleteTablesTitle: 'Tische löschen',
    deleteTablesConfirm: (count, plural) =>
      `${count} ${plural === '' ? 'Tisch' : 'Tische'} löschen? Dies kann nicht rückgängig gemacht werden.`,
    tablesDeleted: (count) => `${count} Tische gelöscht`,
    deleteCount: (count) => `Löschen (${count})`,
    addCount: (count) => `Hinzufügen (${count})`,
    floorPlanSaved: 'Grundriss gespeichert',
    failedSaveFloorPlan: 'Fehler beim Speichern',
    failedBatchCreate: 'Fehlgeschlagen',
    done: 'Fertig',
    aboutMode: (mode) => `Über den ${mode}-Modus`,
    noPacingLimit: 'Keine Pacing-Grenze - Ankünfte sind nicht ratenlimitiert.',
    coversPaceTrips: (max, parties, covers) =>
      `Covers-Pacing (${max}) beginnt zuerst: ${parties} Gruppen = ${covers} Gäste starten in 15 Minuten, die nächste wird später verschoben.`,
    partyPaceTrips: (max, covers) =>
      `Gruppen-Pacing (${max}) beginnt zuerst: nur ${max} Buchungen können pro 15 Minuten starten (${covers} Gäste bisher).`,
    bothPacingHit: (parties, covers) =>
      `Beide Pacing-Limits erreicht - ${parties} Gruppen / ${covers} Gäste in 15 Minuten.`,
    noConcurrentLimit: 'Keine Gleichzeitigkeitsgrenze - nur durch Ihre Tische begrenzt.',
    concurrentCoversTrips: (max, covers) =>
      `Gleichzeitige Plätze (${max}) beginnen zuerst: ${covers} Gäste sind zum Spitzenzeitpunkt aktiv.`,
    concurrentPartiesTrips: (max, covers) =>
      `Gleichzeitige Gruppen (${max}) beginnen zuerst: ${max} Buchungen gleichzeitig aktiv (${covers} Gäste).`,
    bothConcurrentHit: (parties, covers) =>
      `Beide Gleichzeitigkeitsgrenzen erreicht - ${parties} Gruppen / ${covers} Gäste auf einmal.`,
    slotFitsTypical: 'Ein typisches Gemisch passt - der Slot bleibt für weitere Buchungen offen.',
    coversCapsFirst: (max, parties, covers, size) =>
      `Platzobergrenze (${max}) wird zuerst erreicht: ${parties} Gruppen = ${covers} Gäste, und die nächste Gruppe von ${size} würde sie überschreiten.`,
    reservationsCapsFirst: (max, parties, covers) =>
      `Reservierungsobergrenze (${max}) wird zuerst erreicht: der Slot ist bei ${parties} Buchungen voll, unabhängig von der Gruppengröße (${covers} Gäste bisher).`,
    bothCapsHit: (parties, covers) =>
      `Beide Obergrenzen werden gleichzeitig erreicht - ${parties} Gruppen / ${covers} Gäste.`,
    slotClosesWhenHit: 'Ein Slot schließt sich, sobald eines der Limits erreicht ist.',
    noLimitsSlot:
      'Keine Limits - der Slot füllt sich nie von selbst (andere Schichten gelten immer noch).',
    onlyOneSlot: 'Ein 60-Minuten-Slot · ankommende Gruppen',
    typicalOverlapFits:
      'Eine typische Überlappung passt - keine Soft-Grenze erreicht unter Ihren Tischen.',
    turnedAway: (size) => `${size} abgelehnt`,
    weeklyCompileCoverage: 'Wöchentliche Abdeckung',
    noLimitation: 'keine Beschränkung',
    resSlot: (count) => `${count} Reservierungen/Slot`,
    coversSlot: (count) => `${count} Plätze/Slot`,
    pacingCovers: (count) => `${count} Pacing-Plätze`,
    advCapCompact: (pacing, concurrent) => `${pacing} · ${concurrent}`,
    advCap: (pacing, concurrent) => `${pacing}/15' · ${concurrent} gleichzeitig`,
    // --- ReservationSetupPage (page-specific copy) ---
    bookingForm: 'Buchungsformular',
    bookingFormFooter:
      'Optionale Felder, die Gäste bei der Buchung ausfüllen können - Anlass und Sitzplatzwunsch.',
    enableBookings: 'Buchungen aktivieren',
    enableBookingsAria: 'Über das Aktivieren von Buchungen',
    enableBookingsTooltip:
      'Wenn deaktiviert, ist die Buchungsseite für Gäste ausgeblendet und neue Online-Reservierungen werden abgelehnt.',
    autoConfirmBookings: 'Buchungen automatisch bestätigen',
    autoConfirmAria: 'Über die Bestätigung',
    autoConfirmTooltip:
      'Aktiviert bestätigt eine Anfrage sofort. Deaktiviert hält sie als ausstehend, bis das Personal sie prüft und annimmt.',
    bookingsAutoConfirmedToast: 'Buchungen werden automatisch bestätigt',
    bookingsNeedReview: 'Buchungen erfordern manuelle Prüfung',
    pauseToday: 'Neue Buchungen heute pausieren',
    pauseTodayAria: 'Über das Pausieren neuer Buchungen',
    pauseTodayTooltip:
      'Stoppt neue Online-Buchungen nur für den Rest des heutigen Tages - künftige Tage bleiben offen.',
    bookingsPausedToday: 'Neue Buchungen für heute pausiert',
    bookingsResumed: 'Buchungen fortgesetzt',
    occasionField: 'Anlass-Feld',
    occasionFieldAria: 'Über das Anlass-Feld',
    occasionFieldTooltip: 'Den Auswahlpunkt „Anlass“ im Buchungsformular ein- oder ausblenden.',
    occasionFieldShown: 'Anlass-Feld eingeblendet',
    occasionFieldHidden: 'Anlass-Feld ausgeblendet',
    seatingAccessField: 'Sitzplatz- & Zugangs-Feld',
    seatingAccessAria: 'Über das Sitzplatz- & Zugangs-Feld',
    seatingAccessTooltip:
      'Den Auswahlpunkt „Sitzplatz & Zugang“ (Sitzplatz + Barrierefreiheit, z. B. Kinderstuhl) im Buchungsformular ein- oder ausblenden.',
    seatingAccessShown: 'Sitzplatz- & Zugangs-Feld eingeblendet',
    seatingAccessHidden: 'Sitzplatz- & Zugangs-Feld ausgeblendet',
    largestPartyAria: 'Über die größte Gruppe',
    largestPartyTooltip: 'Maximale Anzahl der Gäste pro Online-Buchung.',
    largePartyMessageAria: 'Über die Nachricht für große Gruppen',
    largePartyMessageTooltip:
      'Wird statt des Buchungsformulars für Gruppen oberhalb der größten Gruppengröße angezeigt.',
    bookingHorizonAria: 'Über den Buchungshorizont',
    bookingHorizonTooltip: 'Wie viele Tage im Voraus der Buchungskalender öffnet.',
    lastMinuteCutoffMinutes: 'Last-Minute-Grenze (Minuten)',
    lastMinuteCutoffAria: 'Über die Last-Minute-Grenze',
    lastMinuteCutoffMsg:
      'Minuten vor dem Slot, ab denen keine Buchungen mehr angenommen werden (0 = bis zum Beginn)',
    lastMinuteCutoffTooltip:
      'Minuten vor einem Slot, ab denen keine Buchungen mehr angenommen werden (0 = bis zum Beginn).',
    minBefore: (minutes) => `${minutes} Min. vorher`,
    slotSpacingAria: 'Über den Slot-Abstand',
    slotSpacingTooltip: 'Minuten zwischen den buchbaren Zeiten, die Gäste wählen können.',
    lastBookingBeforeCloseAria: 'Über die letzte Buchung vor Schließung',
    lastBookingBeforeCloseTooltip:
      'Wie lange vor Ende jedes Service keine Buchungszeiten mehr angeboten werden. Das Team kann weiterhin über die Schließzeit hinaus arbeiten – dies regelt nur, wie spät Gäste online buchen dürfen. Beispiel: 60 Min. bedeutet bei Schließung um 22:00 Uhr ist 21:00 Uhr die letzte Zeit.',
    everyMinShort: (minutes) => `Alle ${minutes} Min.`,
    defaultTableTimeMsg: 'Wie lange ein Tisch pro Buchung reserviert bleibt, in Minuten (min. 15)',
    defaultTableTimeAria: 'Über die Standard-Tischzeit',
    defaultTableTimeTooltip:
      'Wie lange ein Tisch pro Buchung standardmäßig reserviert bleibt. Eine Übersteuerung pro Schicht befindet sich unter Kapazität.',
    shareBookingLink: 'Buchungslink teilen',
    shareBookingLinkAria: 'Über das Teilen des Buchungslinks',
    shareBookingLinkTooltip:
      'Kopiere deinen öffentlichen Buchungslink, um ihn mit Gästen zu teilen.',
    copy: 'Kopieren',
    noShowGracePeriodMsg: 'Minuten nach der Buchungszeit, bevor ein Gast als No-Show zählt',
    noShowGracePeriodAria: 'Über die No-Show-Kulanzzeit',
    noShowGracePeriodTooltip:
      'Minuten, die eine Buchung überfällig sein kann, bevor das Personal eine No-Show-Benachrichtigung erhält.',
    minCount: (minutes) => `${minutes} Min.`,
    fmtNone: 'Keine',
    fmtHoursMinutes: (hours, minutes) => `${hours} Std. ${minutes} Min.`,
    fmtHours: (hours) => `${hours} Std.`,
    fmtMinutes: (minutes) => `${minutes} Min.`,
    bookingLinkCopied: 'Buchungslink kopiert',
    bookingLink: 'Buchungslink',
    // --- Zones/Tables/Floor-plan pages (simple mode) ---
    add: 'Hinzufügen',
    failed: 'Fehlgeschlagen',
    rename: 'Umbenennen',
    zonesFooter:
      'Tische verweisen über ihre ID auf eine Zone - beim Löschen einer Zone werden diese Tische zonenfrei.',
    deleteZoneNoZoneConfirm: (label) =>
      `"${label}" löschen? Die Tische werden nicht gelöscht - sie wechseln zu "Keine Zone" und bleiben buchbar.`,
    orphanTablesNote:
      'Diese Tische gehörten zu einer gelöschten Zone. Sie sind weiterhin aktiv und buchbar. Weisen Sie sie einer Zone zu, indem Sie jeden Tisch bearbeiten.',
    floorPlanAriaLabel: 'Restaurant-Grundriss',
  },

  reservationsFeature: {
    edit: {
      title: 'Reservierung bearbeiten',
      updated: 'Reservierung aktualisiert',
      updateFailed: 'Reservierung konnte nicht aktualisiert werden.',
      guestNamePlaceholder: 'Gastname',
      durationPlaceholder: '60',
      notesPlaceholder: 'Notizen des Personals…',
    },
    actions: {
      confirmReservation: 'Reservierung bestätigen',
      declineReservation: 'Reservierung ablehnen',
      cancelReservation: 'Reservierung stornieren',
      markArrived: 'Als angekommen markieren',
      markNoShow: 'Als nicht erschienen markieren',
      markCompleted: 'Als abgeschlossen markieren',
    },
    card: {
      guestLabel: (_count) => 'Gast',
      guestLabelPlural: 'Gäste',
      swipeAccept: 'Akzeptieren',
      swipeDecline: 'Ablehnen',
    },
    inspector: {
      closeButton: 'Schließen',
      noReservationTitle: 'Keine Reservierung ausgewählt',
      noReservationDesc:
        'Wählen Sie eine Reservierung aus der Liste aus, um die Details hier anzuzeigen.',
      notFoundTitle: 'Reservierung nicht gefunden',
      durationUnit: 'Min',
      callGuest: 'Anrufen',
      messageGuest: 'Nachricht',
      emailGuest: 'E-Mail',
      editGuest: 'Bearbeiten',
      statusLabel: 'Status',
      specialRequests: 'Spezielle Anfragen',
      occasion: 'Anlass',
      seating: 'Sitzplatz',
      notes: 'Notizen',
      guestInfo: 'Gastinformationen',
      phone: 'Telefon',
      source: 'Quelle',
      internalNote: 'Interne Notiz',
      cancellationReason: 'Absagegrund',
      timeline: 'Zeitliste',
      created: 'Erstellt',
      confirmed: 'Bestätigt',
      arrived: 'Angekommen',
      completed: 'Abgeschlossen',
      cancelled: 'Storniert',
      noShow: 'Nicht erschienen',
      markedArrived: 'Als angekommen markiert',
      markedCompleted: 'Als abgeschlossen markiert',
      markedNoShow: 'Als nicht erschienen markiert',
    },
    summary: {
      total: 'Gesamt',
      pending: 'Ausstehend',
      confirmed: 'Bestätigt',
      arrived: 'Angekommen',
      completed: 'Abgeschlossen',
      noShow: 'Nicht erschienen',
    },
    create: {
      title: 'Neue Reservierung',
      guestSection: 'Gast',
      nameLabel: 'Vollständiger Name',
      namePlaceholder: 'z.B. Hans Müller',
      phoneLabel: 'Telefon',
      phonePlaceholder: '+49 30 12345678',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'john@example.com',
      existingGuests: 'Bestehende Gäste - tippen zum Wiederverwenden',
      bookingSection: 'Buchung',
      dateLabel: 'Datum',
      timeLabel: 'Zeit',
      partySizeLabel: 'Personenzahl',
      sourceSection: 'Quelle',
      sourcePhone: 'Telefon',
      sourceWalkIn: 'Laufkundschaft',
      notesSection: 'Notizen',
      notesLabel: 'Interne Notiz',
      notesPlaceholder: 'Nur für Personal...',
      button: 'Reservierung erstellen',
      success: 'Reservierung erstellt',
      nameRequired: 'Gastname erforderlich.',
      emailRequired: 'Gast-E-Mail erforderlich.',
      phoneRequired: 'Gasttelefon erforderlich.',
      noRestaurant: 'Kein Restaurant ausgewählt.',
      error: 'Reservierung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    },
    pending: {
      title: 'Ausstehend',
      confirmed: 'Reservierung bestätigt',
      confirmFailed: 'Reservierung konnte nicht bestätigt werden.',
      rejectPrompt: 'Grund für Ablehnung:',
      rejectTitle: 'Reservierung ablehnen',
      rejected: 'Reservierung abgelehnt',
      rejectFailed: 'Reservierung konnte nicht abgelehnt werden.',
      empty: 'Alle erledigt!',
      emptyDesc: 'Keine ausstehenden Reservierungen zu überprüfen.',
    },
    detail: {
      title: 'Reservierung',
    },
    list: {
      emptyError: 'Fehler beim Laden von Reservierungen',
      emptyRetry: 'Bitte versuchen Sie es erneut.',
      noReservations: 'Keine Reservierungen',
      noReservationsDesc: 'Keine Reservierungen für dieses Datum.',
      today: 'Heute',
      countLabel: (_count) => 'Reservierung',
      countLabelPlural: 'Reservierungen',
      cancelConfirm: 'Diese Reservierung stornieren?',
      cancelTitle: 'Reservierung stornieren',
      cancelled: 'Reservierung storniert',
      cancelFailed: 'Reservierung konnte nicht storniert werden.',
    },
    plan: {
      noZone: 'Keine Zone',
      seatSingular: 'Platz',
      seatPlural: 'Plätze',
      tableAriaLabel: (name, seats) =>
        `Tisch ${name}, ${seats} ${seats === 1 ? 'Platz' : 'Plätze'}`,
      empty: 'Noch keine Tische',
      emptyDesc:
        'Fügen Sie Tische in Einstellungen → Reservierungseinrichtung hinzu, um den Grundriss anzuzeigen.',
    },
    timeline: {
      unassignedCount: (count) => `${count} Buchung${count === 1 ? '' : 'en'}`,
      empty: 'Noch nichts anzuzeigen',
      emptyDesc:
        'Fügen Sie Tische in der Kapazitätseinrichtung hinzu und Buchungen werden hier als Balken angezeigt.',
      seatTopLabel: (seats) => `${seats}-er Tisch`,
    },
    calendar: {
      error: 'Fehler beim Laden von Reservierungen',
      errorRetry: 'Bitte versuchen Sie es erneut.',
    },
  },

  restaurantSetupFeature: {
    branding: {
      title: 'Storefront-Erscheinungsbild',
      storefrontTheme: 'Storefront-Design',
      storefrontThemeDescription:
        'Wählen Sie das Design Ihres öffentlichen Storefronts. Jede Vorschau verwendet die exakten Farben und Formen, die Ihre Kunden sehen werden.',
      orderButtonPreview: 'Bestellung',
      themeSavedMessage:
        'Design gespeichert - Ihr Storefront wird beim nächsten Laden aktualisiert',
      couldNotSaveTheme: 'Design konnte nicht gespeichert werden.',
      saveTheme: 'Design speichern',
      brandingImages: 'Markenbilder',
      brandingImagesDescription:
        'Logo und Titelbild für Ihre öffentliche Storefront. Das Titelbild erscheint auch, wenn Ihr Link in Chat-Apps geteilt wird.',
      logoLabel: 'Logo',
      logoHint:
        'Quadratisches Bild, wird neben dem Restaurantnamen angezeigt. Datei zum Hochladen hierher ziehen.',
      coverLabel: 'Titelbild',
      coverHint:
        'Breites Bild, empfohlen 1200×630 - erscheint oben auf Ihrer Seite und in Link-Vorschauen. Datei zum Hochladen hierher ziehen.',
      uploadImage: 'Hochladen',
      replaceImage: 'Ersetzen',
      removeImage: 'Entfernen',
      imageSavedMessage: 'Bild gespeichert - Ihr Storefront wird beim nächsten Laden aktualisiert',
      imageRemovedMessage: 'Bild entfernt',
      imageUploadFailed: 'Bild konnte nicht hochgeladen werden.',
      imageTooLarge: 'Bild ist zu groß (max. 10 MB).',
      imageWrongType: 'Nicht unterstütztes Format. Verwenden Sie JPG, PNG oder WebP.',
      galleryLabel: 'Fotogalerie',
      galleryHint:
        'Bis zu 9 Fotos, als Raster auf Ihrer Storefront-Seite angezeigt. Quadratisch (1:1) wirkt am besten. Zum Sortieren ziehen.',
      addPhotos: 'Fotos hinzufügen',
      dropFilesHint: 'oder Dateien hierher ziehen',
      galleryFull: 'Die Galerie fasst höchstens 9 Fotos.',
    },
  },

  profile: {
    title: 'Mein Profil',
    personalInfo: 'Persönliche Informationen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    notAvailableYet: 'Noch nicht verfügbar',
    contactAdminNote:
      'Um Ihren Namen oder Ihre persönlichen Daten zu aktualisieren, wenden Sie sich bitte an Ihren Administrator - eine Bearbeitung ist hier noch nicht möglich.',
    currentRestaurantRole: 'Aktuelle Restaurant-Rolle',
    nameInRestaurant: 'Name im Restaurant',
    restaurant: 'Restaurant',
    role: 'Rolle',
  },

  settingsHealth: {
    title: 'Einrichtung abschließen',
    location: {
      title: 'Standort des Restaurants festlegen',
      description:
        'Die Lieferung kann die Entfernung erst berechnen, wenn Sie die Kartennadel setzen.',
    },
    openingHours: {
      title: 'Öffnungszeiten hinzufügen',
      description: 'Ihr Storefront gilt als geschlossen, bis Sie sie festlegen.',
    },
    deliveryPricing: {
      title: 'Lieferpreise einrichten',
      description:
        'Fügen Sie eine Lieferzone hinzu, sonst wird jede Adresse als außerhalb des Liefergebiets abgelehnt.',
    },
    deliveryTime: {
      title: 'Lieferzeiten festlegen',
      description:
        'Ein Liefergebiet ohne Zeit nennt Gästen eine Ankunftszeit, die die Fahrt nicht enthält.',
    },
    paymentMethod: {
      title: 'Zahlungsart aktivieren',
      description: 'Gäste können bestellen, aber nicht abschließen.',
    },
    menu: {
      title: 'Artikel zur Speisekarte hinzufügen',
      description: 'Ohne Produkte auf der Speisekarte kann die Online-Bestellung nichts anzeigen.',
    },
    menuNotLive: {
      title: 'Speisekarte für Online-Bestellungen aktivieren',
      description:
        'Für Abholung oder Lieferung ist keine Speisekarte aktiv, Gäste sehen „nimmt derzeit keine Online-Bestellungen an".',
    },
  },

  settingsFeature: {
    features: 'Funktionen',
    privacy: 'Datenschutz',
    shareUsageData: 'Nutzungsdaten teilen',
    shareUsageDataHint:
      'Hilft uns zu sehen, welche Funktionen Sie wirklich nutzen. Enthält nie Gast- oder Bestelldaten.',
    assistant: 'Assistent',
    aiAssistant: 'KI-Assistent',
    notifications: 'Benachrichtigungen',
    inbox: 'Posteingang',
    inboxNewCount: (count) => `${count} neu`,
    reports: 'Berichte',
    salesOverview: 'Verkaufsübersicht',
    dayEnd: 'Tagesabschluss',
    topItems: 'Meistverkaufte Artikel',
    paymentReconciliation: 'Zahlungsabstimmung',
    reservationSetup: 'Reservierungseinrichtung',
    onlineOrders: 'Online-Bestellungen',
    orderSetup: 'Bestelleinrichtung',
    orderShifts: 'Bestellkapazität',
    labels: 'Labels',
    tidyUp: 'Listen aufräumen',
    promotions: 'Werbeaktionen',
    loyalty: 'Treueprogramm',
    giftCards: 'Geschenkgutscheine',
    staff: 'Personal',
    tableOrdering: 'Bestellung am Tisch',
    dineInSetup: 'Einrichtung für Vor-Ort-Service',
    printing: 'Druck',
    printers: 'Drucker',
    customers: 'Kunden',
    allCustomers: 'Alle Kunden',
    branding: 'Storefront-Erscheinungsbild',
    storefrontLink: 'Storefront-Link',
    openingHours: 'Öffnungszeiten',
    holidays: 'Feiertage & Schließungen',
    reservationHours: 'Reservierungszeiten',
    orderHours: 'Bestellzeiten',
    pickupHours: 'Abholzeiten',
    deliveryHours: 'Lieferzeiten',
    orderHistory: 'Bestellverlauf',
    payments: 'Zahlungen',
    myProfile: 'Mein Profil',
  },

  storefrontLink: {
    title: 'Storefront-Link',
    language: 'Sprache',
    default: 'Standard',
    linkLabel: 'Link',
    linksTitle: 'Links',
    homepage: 'Startseite',
    reservation: 'Reservierung',
    onlineOrder: 'Online-Bestellung',
    linkUnavailable: 'Link nicht verfügbar',
    copy: 'Kopieren',
    copied: 'Kopiert',
    open: 'Öffnen',
    linkCopied: 'Storefront-Link kopiert',
    okButton: 'OK',
  },

  settingHistory: {
    title: 'Änderungsverlauf',
    navTitle: 'Einstellungsprotokoll',
    empty: 'Noch keine Einstellungsänderungen erfasst.',
    columnActor: 'Geändert von',
    columnWhen: 'Wann',
    columnWhat: 'Was geändert wurde',
    columnAction: 'Aktion',
    details: 'Details',
    detailsTitle: 'Änderungsdetails',
    totalEntries: (total: number) => `${total} Einträge`,
    actions: {
      CREATED: 'Hinzugefügt',
      UPDATED: 'Bearbeitet',
      DELETED: 'Gelöscht',
    },
    valueHidden: 'geändert (Wert nicht gespeichert)',
    on: 'Ein',
    off: 'Aus',
    unitMinutes: (n: string) => `${n} Minuten`,
    unitHours: (n: string) => `${n} Stunden`,
    unitDays: (n: string) => `${n} Tage`,
    unitPeople: (n: string) => `${n} Personen`,
    unitKm: (n: string) => `${n} km`,
    photoCount: (n: number) => (n === 1 ? '1 Foto' : `${n} Fotos`),
    partySizePacingRule: (minPartySize: number, maxParties: number) =>
      `ab ${minPartySize} Gästen: max. ${maxParties} Gruppen`,
    ruleFields: {
      slotMinutes: 'Slotlänge',
      maxReservationsPerSlot: 'Max. Reservierungen / Slot',
      maxCoversPerSlot: 'Max. Plätze / Slot',
      pacingMaxCovers: 'Pacing, max. Plätze',
      pacingMaxParties: 'Pacing, max. Gruppen',
      maxConcurrentCovers: 'Gleichzeitig, max. Plätze',
      maxConcurrentParties: 'Gleichzeitig, max. Gruppen',
      partySizePacing: 'Pacing nach Gruppengröße',
      maxOrdersPerSlot: 'Bestellungen pro Slot',
      capacityWindowMinutes: 'Kapazitätsfenster',
    },
    detailBefore: 'Vorher',
    detailAfter: 'Nachher',
    showRaw: 'Rohdaten anzeigen',
    hideRaw: 'Rohdaten ausblenden',
    tableAttributes: {
      WINDOW: 'Fensterplatz',
      BOOTH: 'Nische',
      OUTDOOR: 'Draußen',
      BAR: 'Bar',
      HIGH_TOP: 'Stehtisch',
      PRIVATE_ROOM: 'Separee',
      QUIET: 'Ruhige Ecke',
      WHEELCHAIR: 'Rollstuhlgerecht',
      NEAR_FIREPLACE: 'Am Kamin',
      KIDS_FRIENDLY: 'Kinderfreundlich',
    },
    fields: {
      name: 'Name',
      address: 'Adresse',
      city: 'Stadt',
      postalCode: 'Postleitzahl',
      phone: 'Telefon',
      email: 'E-Mail',
      timezone: 'Zeitzone',
      latitude: 'Breitengrad',
      longitude: 'Längengrad',
      isActive: 'Aktiv',
      slug: 'Web-Adresse',
      websiteUrl: 'Website',
      facebookUrl: 'Facebook',
      instagramUrl: 'Instagram',
      tiktokUrl: 'TikTok',
      logoKey: 'Logo',
      coverImageKey: 'Titelbild',
      galleryKeys: 'Fotogalerie',
      themeId: 'Design',
      shifts: 'Öffnungszeiten',
      dayOfWeek: 'Wochentag',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      type: 'Art',
      services: 'Gilt für',
      reason: 'Grund',
      label: 'Bezeichnung',
      sortOrder: 'Reihenfolge',
      zoneId: 'Bereich',
      seats: 'Sitzplätze',
      attributes: 'Merkmale',
      customTags: 'Tags',
      countsForCapacity: 'Zählt zur Kapazität',
      isBookableOnline: 'Online buchbar',
      isMergeable: 'Kombinierbar',
      tableMode: 'Tischverwaltung',
      enabled: 'Online-Reservierungen',
      occasionEnabled: 'Nach Anlass fragen',
      seatingPreferenceEnabled: 'Nach Sitzplatzwunsch fragen',
      duration: 'Aufenthaltsdauer',
      bufferTime: 'Puffer zwischen Buchungen',
      autoConfirmMode: 'Bestätigung',
      maxPartySize: 'Maximale Gruppengröße',
      largePartyMsg: 'Hinweis für große Gruppen',
      advanceWindow: 'Vorlaufzeit für Buchungen',
      cutoffTime: 'Buchungsschluss vor dem Termin',
      slotInterval: 'Zeitfenster-Intervall',
      closingBufferMinutes: 'Letzte Buchung vor Schließung',
      gracePeriod: 'Karenzzeit bei Nichterscheinen',
      pausedUntil: 'Buchungen pausiert bis',
      shiftMode: 'Kapazitätsverwaltung',
      scope: 'Gilt für',
      startTime: 'Startzeit',
      endTime: 'Endzeit',
      daysOfWeek: 'Tage',
      defaultDurationMinutes: 'Standarddauer',
      mode: 'Modus',
      rules: 'Kapazitätsregeln',
      minOrderCents: 'Mindestbestellwert',
      cashEnabled: 'Barzahlung',
      onlineEnabled: 'Online-Zahlung',
      cardOnHandoffEnabled: 'Kartenzahlung bei Übergabe',
      autoConfirmHandoff: 'Diese Bestellungen automatisch annehmen',
      deliveryPriceMode: 'Liefergebühren-Modell',
      distanceCalculation: 'Distanzberechnung',
      deliveryBufferMinutes: 'Lieferpuffer',
      autoCompleteEnabled: 'Automatischer Abschluss',
      completeStaleAfterMinutesFromReadyAt: 'Bestellungen automatisch abschließen nach',
      cancelPendingAfterHours: 'Nicht angenommene Bestellungen stornieren nach',
      expireUnpaidAfterMinutes: 'Unbezahlte Bestellungen stornieren nach',
      prepTimeMinutes: 'Zubereitungszeit',
      schedulingLeadMinutes: 'Vorlaufzeit für Vorbestellungen',
      openingBufferMinutes: 'Frühester Slot nach Öffnung',
      credentials: 'API-Zugangsdaten',
      instructions: 'Zahlungshinweise',
      defaultLanguage: 'Sprache des Lokals',
      feeCents: 'Liefergebühr',
      maxDistanceKm: 'Maximale Entfernung',
      deliveryMinutes: 'Lieferzeit',
      polygon: 'Liefergebiet',
      displayOrder: 'Reihenfolge',
      accountFields: 'Kontodaten',
      qrImageBlobKey: 'QR-Bild',
      color: 'Farbe',
      connection: 'Verbindung',
      isDefault: 'Standarddrucker',
      printOnlineOrders: 'Online-Bestellungen drucken',
      printReservations: 'Reservierungen drucken',
      textSize: 'Schriftgröße',
      splitKitchenTickets: 'Küchenbons aufteilen',
      printExpoTicket: 'Expo-Bon drucken',
      printItemCategory: 'Kategorie auf Bon anzeigen',
      dateTimeFormat: 'Datumsformat auf dem Bon',
      ownerNotifyEnabled: 'Bestellbenachrichtigungen',
      ownerNotifyCashEnabled: 'Benachrichtigungen bei Barzahlung',
      ownerNotifyManualEnabled: 'Benachrichtigungen bei Überweisung',
      ownerNotifyOnlineEnabled: 'Benachrichtigungen bei Online-Zahlung',
      ownerNotifyCancellationEnabled: 'Benachrichtigungen bei Stornierung',
      ownerNotifyNoShowEnabled: 'Benachrichtigungen bei Nichterscheinen',
      prepReminderEnabled: 'Erinnerung Zubereitungsstart',
      customerEmailEnabled: 'E-Mails an Gäste',
      customerEmailCashEnabled: 'Gast-E-Mails bei Barzahlung',
      customerEmailManualEnabled: 'Gast-E-Mails bei Überweisung',
      customerEmailOnlineEnabled: 'Gast-E-Mails bei Online-Zahlung',
      ownerEmailEnabled: 'E-Mails an den Inhaber',
      reminderEnabled: 'Erinnerungs-E-Mails',
      reminderOffsetsMinutes: 'Erinnerungszeitpunkt',
    } as Record<string, string>,
    values: {
      STRAIGHT_LINE: 'Entfernungsstufe',
      POLYGON: 'Gezeichnetes Gebiet',
      ROUTE_DISTANCE: 'Fahrstrecke',
      AUTO: 'Automatisch',
      MANUAL: 'Manuell',
      SIMPLE: 'Einfach',
      ADVANCED: 'Erweitert',
      BASELINE: 'Standardzeiten',
      WINDOW: 'Zeitfenster',
      CLOSED: 'Geschlossen',
      MODIFIED: 'Geänderte Zeiten',
      DISTANCE: 'Nach Entfernung',
      ZONE: 'Nach Zone',
      DIRECT: 'Luftlinie',
      ROUTE: 'Fahrstrecke',
      MEDIUM: 'Mittel',
      LARGE: 'Groß',
      DMY_SLASH: 'DD/MM/YYYY',
      DMY_DOT: 'DD.MM.YYYY',
      YMD_DASH: 'YYYY-MM-DD',
      MDY_SLASH: 'MM/DD/YYYY',
      PICKUP: 'Abholung',
      DELIVERY: 'Lieferung',
      DINE_IN: 'Vor Ort',
    } as Record<string, string>,
  },

  staff: {
    title: 'Personal',
    inviteTitle: 'Teammitglied einladen',
    nameLabel: 'Name',
    namePlaceholder: 'Jane Smith',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'jane@example.com',
    roleLabel: 'Rolle',
    roles: {
      MANAGER: 'Manager',
      STAFF: 'Kellner',
      KITCHEN: 'Küche',
      CASHIER: 'Kasse',
    },
    inviting: 'Wird eingeladen…',
    sendInvite: 'Einladung senden',
    couldNotLoadTitle: 'Personal konnte nicht geladen werden',
    noStaffTitle: 'Noch keine Mitarbeiter',
    noStaffDescription:
      'Laden Sie Ihr Team ein - Kellner, Küche, Kasse - und legen Sie fest, was jeder tun kann. Tippen Sie +.',
    inactive: 'Inaktiv',
    roleAriaLabel: (name) => `Rolle für ${name}`,
    remove: 'Entfernen',
    validation: {
      nameAndEmail: 'Geben Sie einen Namen und eine E-Mail-Adresse ein.',
    },
    toast: {
      invitationSent: 'Einladung versendet',
      couldNotInvite: 'Diese Person konnte nicht eingeladen werden.',
      couldNotChangeRole: 'Rolle konnte nicht geändert werden.',
      couldNotUpdate: 'Konnte nicht aktualisiert werden.',
      removed: (name) => `${name} entfernt`,
      couldNotRemove: 'Konnte nicht entfernt werden.',
    },
    removeConfirm: (name) => `${name} aus diesem Restaurant entfernen?`,
    removeConfirmTitle: 'Mitarbeiter entfernen',
  },

  tableOrdering: {
    attachReservation: {
      title: 'Reservierung verbinden',
      noAttachable: 'Keine Reservierungen zum Verbinden vorhanden.',
      confirmAttach: (name: string) =>
        `Reservierung von ${name} verbinden und als angekommen markieren?`,
      partyOf: (n: number) => `Gruppe von ${n}`,
      onThisTable: ' · an diesem Tisch',
    },
    inspector: {
      selectTable: 'Wählen Sie einen Tisch',
      selectTableDesc:
        'Wählen Sie einen Tisch auf dem Grundriss, um die Rechnung zu sehen, Bestellungen aufzunehmen und zu bezahlen.',
      addRound: 'Runde hinzufügen',
      bill: 'Rechnung',
      attach: 'Verbinden',
      guest: 'Gast',
      addGuest: 'Gast hinzufügen',
      activity: 'Aktivität',
      needsAttention: 'Benötigt Aufmerksamkeit',
      guestCalledServer: 'Gast hat den Kellner gerufen',
      guestRequestedBill: 'Gast hat die Rechnung angefordert',
      resolve: 'Beheben',
      rounds: 'Runden',
      noRounds: 'Noch keine Runden - "Runde hinzufügen", um die Bestellung aufzunehmen.',
      total: 'Summe',
      paid: 'Bezahlt',
      billRequestedStatus: 'Rechnung angefordert',
      openStatus: 'Offen',
      closedStatus: 'Geschlossen',
      walkIn: 'Laufkunde',
      openedTime: 'geöffnet',
      visit: 'Besuch',
      visits: 'Besuche',
      visitsCount: (n: number) => `${n} ${n === 1 ? 'Besuch' : 'Besuche'}`,
      roundStatus: {
        placed: 'Wartet auf Bestätigung',
        fired: 'In der Küche',
        ready: 'Bereit',
        served: 'Serviert',
        cancelled: 'Storniert',
      },
      roundNum: (seq: number) => `Runde ${seq}`,
      roundFired: (seq: number) => `Runde ${seq} an die Küche gesendet`,
      roundAccepted: (seq: number) => `Runde ${seq} akzeptiert`,
      roundReadyToast: (seq: number) => `Runde ${seq} bereit`,
      roundServedToast: (seq: number) => `Runde ${seq} serviert`,
      roundReopened: (seq: number) => `Runde ${seq} zurück in die Küche`,
      cancelRoundPrompt: 'Grund für die Stornierung dieser Runde',
      roundCancelledToast: (seq: number) => `Runde ${seq} storniert`,
      voidItemPrompt: (name: string) => `"${name}" stornieren? Grund hinzufügen (optional)`,
      voidItemTitle: 'Artikel stornieren',
      restoreAria: (name: string) => `${name} wiederherstellen`,
      voidAria: (name: string) => `${name} stornieren`,
    },
    roundActions: {
      acceptFire: 'Bestätigen & Feuer',
      cancelRound: 'Runde stornieren',
      markReady: 'Als bereit markieren',
      markServed: 'Als serviert markieren',
      sendBackKitchen: 'Zurück in die Küche',
    },
    zonePicker: {
      open: 'offen',
      noOpenTabs: 'Keine offenen Rechnungen',
      openCount: (n: number) => `${n} offen`,
    },
    assignCustomer: {
      title: 'Gast zuordnen',
      change: 'Gast ändern',
      currentGuest: 'Aktueller Gast',
      unlinkGuest: 'Gast trennen',
      findAddGuest: 'Einen Gast suchen oder hinzufügen',
      linkDifferent: 'Einen anderen Gast verbinden',
      nameLabel: 'Name',
      guestNamePlaceholder: 'Gastname',
      phoneLabel: 'Telefon',
      phoneNumberPlaceholder: 'Telefonnummer',
      existingGuests: 'Vorhandene Gäste - tippen zum Verbinden',
      linkNewGuest: 'Neuen Gast verbinden',
      linkGuest: 'Gast verbinden',
      guestLinked: 'Gast verbunden',
      guestUnlinked: 'Gast getrennt',
      enterNamePhone: 'Geben Sie einen Namen und eine Telefonnummer ein.',
      linkedName: (name: string) => `${name} verbunden`,
      visitsFooter: (n: number) => `${n} Besuch${n === 1 ? '' : 'e'}`,
    },
    floorPlan: {
      noFloorPlanAdvanced:
        'Noch kein Grundriss gezeichnet - Tische werden nach Zonen gruppiert angezeigt. Zeichnen Sie einen Grundriss unter Einstellungen → Tische (Erweitert) und er wird hier angezeigt.',
      simpleMode:
        'Tische sind im einfachen Modus - werden nach Zonen gruppiert angezeigt. Wechseln Sie zu "Erweitert" unter Einstellungen → Grundriss, um einen Grundriss zu erstellen.',
    },
    tableGrid: {
      couldntLoadTables: 'Tabellen konnten nicht geladen werden',
      noTables: 'Keine Tische',
      noTablesDesc:
        'Fügen Sie Tische unter Einstellungen → Tische hinzu, um mit der Aufnahme von Bestellungen zu beginnen.',
      noTablesZone: 'Keine Tische in dieser Zone',
      noTablesZoneDesc:
        'Wählen Sie eine andere Zone oder fügen Sie Tische unter Einstellungen → Tische hinzu.',
      other: 'Sonstige',
      reserved: 'Reserviert',
      free: 'Frei',
      openTab: 'Offene Rechnung',
      tryAgain: 'Bitte versuchen Sie es erneut.',
      zoneCount: (label: string, n: number) => `${label} · ${n}`,
      occupiedSub: (rounds: number, money: string, calls: number) =>
        `${rounds} Runde${rounds === 1 ? '' : 'n'} · ${money}${calls > 0 ? ` · ${calls} Ruf` : ''}`,
      reservedAt: (time: string) => `Reserviert · ${time}`,
      seatsCount: (n: number) => `${n} Plätze`,
      roundsAbbrev: (n: number) => `${n}R`,
    },
    billCollect: {
      collectPayments: 'Zahlungen einziehen',
      noSplit: 'Noch keine Aufteilung',
      noSplitDesc:
        'Richten Sie zunächst eine Aufteilung ein - dann wird jedes Anteil hier zum Einziehen angezeigt.',
      splitBill: 'Rechnung aufteilen',
      collectedFull: 'Vollständig eingezogen',
      shares: 'Anteile',
      awaiting: 'Ausstehend · tippen zum Einziehen',
      done: 'Fertig',
      tapNote:
        'Tippen Sie auf jedes ausstehende Anteil, um die Zahlung einzuziehen. Die Rechnung schließt sich selbst, wenn das letzte Anteil eingezogen wird.',
      collectedCountOf: (count: number, total: number) => `${count} von ${total} eingezogen`,
      shareNum: (i: number) => `Anteil ${i}`,
      methodTipFooter: (method: string, tip: string) => `${method} · +${tip} Trinkgeld`,
      methodCollectedFooter: (method: string) => `${method} · eingezogen`,
    },
    addRound: {
      title: 'Runde hinzufügen',
      send: 'Senden',
      menu: 'Menü',
      order: 'Bestellung',
      searchMenu: 'Im Menü suchen',
      noMenu: 'Kein aktives Menü vorhanden. Veröffentlichen Sie zunächst ein Menü.',
      chooseOptions: 'Optionen wählen',
      noItems:
        'Noch keine Artikel - wechseln Sie zum Menü und tippen Sie auf Gerichte, um die Runde zu erstellen.',
      roundSentKitchen: 'Runde an Küche gesendet',
      failedSend: 'Fehler beim Senden der Runde',
      assignTo: 'Diesen Artikel zuweisen an',
      shared: 'Gemeinsam',
      addSeat: '+ Platz hinzufügen',
      seatAdded: 'Platz hinzugefügt',
      edit: 'Bearbeiten',
      noteName: 'Notiz für die Küche (optional)',
      orderTab: (count: number) => `Bestellung${count > 0 ? ` · ${count}` : ''}`,
      seatOrdinal: (n: number) => `Platz ${n}`,
      addedItem: (name: string) => `${name} hinzugefügt`,
      tapDishes: 'Tippen Sie auf Gerichte, um die Runde zu erstellen.',
      summaryLine: (count: number, total: string) =>
        `${count} Artikel · ${total} - „Senden“, um die Runde zu feuern`,
    },
    configureItem: {
      title: 'Konfigurieren',
      dishUnavailable: 'Gericht nicht verfügbar',
      dishUnavailableDesc:
        'Dieses Gericht ist nicht mehr im Menü. Gehen Sie zurück und wählen Sie ein anderes.',
      updateItem: (money: string) => `Aktualisieren · ${money}`,
      addItem: (money: string) => `Hinzufügen · ${money}`,
      chooseOne: 'Wählen Sie 1',
      chooseAny: 'Beliebig wählen',
      chooseExact: (n: number, picked: number) => `Wählen Sie ${n} · ${picked}/${n}`,
      upTo: (n: number, picked: number) => `Bis zu ${n} · ${picked}/${n}`,
      chooseRange: (min: number, max: number, picked: number) =>
        `Wählen Sie ${min}-${max} · ${picked}/${max}`,
      atLeast: (n: number, picked: number) => `Mindestens ${n} · ${picked}`,
      pickMore: (count: number, name: string) => `Noch ${count} bei ${name} wählen`,
      maxReached: (max: number) =>
        `Maximum von ${max} erreicht - entfernen Sie eine Auswahl, um zu ändern`,
      optionShortage: (name: string, available: number, total: number, min: number) =>
        `${name}: nur ${available} von ${total} verfügbar, ${min} nötig`,
      temporarilyUnavailable: 'Vorübergehend nicht verfügbar',
      required: 'Erforderlich',
      optional: 'Optional',
    },
    settings: {
      title: 'Tischbestellung',
      dineInOrdering: 'Speisen im Restaurant bestellen',
      enabled: 'Aktiviert',
      tableOrderingOn: 'Tischbestellung aktiviert',
      tableOrderingOff: 'Tischbestellung deaktiviert',
      friendlyMessage:
        'Wenn deaktiviert, wird beim Scannen eines Tisch-QR-Codes eine freundliche Meldung "Fragen Sie das Personal" angezeigt und kein Menü.',
      howItWorks: 'Wie es funktioniert',
      orderingMode: 'Bestellmodus',
      modeGuest: 'Gast',
      modeStaff: 'Personal',
      modeHybrid: 'Hybrid',
      roundHandling: 'Rundenbehandlung',
      autoPrintKitchen: 'Automatischer Druck der Küchenscheine',
      charges: 'Gebühren',
      serviceCharge: 'Serviceggebühr',
      tipSuggestions: 'Trinkgeldvorschläge',
      tableQRCodes: 'Tisch-QR-Codes',
      printableQR: 'Druckbarer QR-Code-Bogen',
      printQRDesc:
        'Ein QR-Code pro Tisch. Drucken, schneiden und auf den Tischen platzieren - Gäste scannen, um ihre Rechnung zu öffnen.',
      whoPlacesOrders: 'Wer gibt Bestellungen auf?',
      guestOrderThemselves: 'Gäste bestellen selbst',
      staffTakeOrders: 'Personal nimmt alle Bestellungen auf',
      guestOrderStaffConfirm: 'Gäste bestellen, Personal bestätigt erste Runde',
      orderingModeUpdated: 'Bestellmodus aktualisiert',
      whenRoundPlaced: 'Wenn eine Runde platziert wird',
      sendKitchenImmediately: 'Sofort an die Küche senden',
      holdStaffAccept: 'Halten, bis das Personal akzeptiert',
      roundHandlingUpdated: 'Rundenbehandlung aktualisiert',
      serviceChargePrompt:
        'Serviceggebühr wird zu jeder Rechnung hinzugefügt (Prozent, z.B. 12,5). 0 zum Deaktivieren.',
      enter0100: 'Geben Sie 0–100 ein',
      serviceChargeUpdated: 'Serviceggebühr aktualisiert',
      tipPresetsPrompt:
        'Vorgeschlagene Trinkgeld-Tasten werden Gästen angezeigt - Prozente, durch Komma getrennt (z.B. 5, 10, 15). Leer für keine.',
      tipPresetsUpdated: 'Trinkgeldvorschläge aktualisiert',
      firingAuto: 'Auto',
      firingConfirm: 'Bestätigen',
      kitchenTicketUpdated: 'Küchenscheinen-Einstellung aktualisiert',
      chargeOff: 'Aus',
      tipsNone: 'Keine',
    },
    billSplit: {
      title: 'Rechnung aufteilen',
      billTotal: 'Gesamtrechnung',
      even: 'Gleichmäßig',
      byAmount: 'Nach Betrag',
      bySeat: 'Nach Platz',
      noSeats:
        'Noch keine Plätze. Fügen Sie Plätze hinzu (oder kennzeichnen Sie Gerichte einem Platz auf dem Bestellblock), dann zahlt jeder Platz für seinen eigenen - gemeinsame Gerichte werden gleichmäßig aufgeteilt.',
      noItems: 'Noch keine Artikel',
      nothingShared: 'Nichts geteilt',
      moveItem: 'Artikel verschieben zu',
      seatAdded: 'Platz hinzugefügt',
      atLeastOneSeat: 'Fügen Sie zuerst mindestens einen Platz hinzu',
      atleastTwoAmounts: 'Geben Sie mindestens zwei Beträge ein',
      splitCreated: 'Aufteilung erstellt',
      createSplit: 'Aufteilung erstellen',
      seatFallback: (ordinal: number) => `Platz ${ordinal}`,
      movedToSeat: (label: string) => `Verschoben zu ${label}`,
      splitNote: (n: number) =>
        `Tippen Sie auf einen Artikel, um ihn zu verschieben. Gemeinsame Gerichte werden gleichmäßig auf ${n} Platz${n === 1 ? '' : 'plätze'} aufgeteilt.`,
      perPersonWays: (ways: number) => `pro Person · ${ways} Wege`,
      partyLabel: (n: number) => `Gruppe ${n}`,
      addParty: 'Gruppe hinzufügen',
    },
    history: {
      title: 'Verlauf',
      couldntLoadHistory: 'Verlauf konnte nicht geladen werden',
      noClosedTabs: 'Keine geschlossenen Rechnungen',
      noClosedTabsDesc:
        'Rechnungen, die an diesem Tag beglichen werden, werden hier angezeigt. Wählen Sie oben einen anderen Tag.',
      splitEven: 'Aufteilung · gleichmäßig',
      splitByAmount: 'Aufteilung · nach Betrag',
      splitBySeat: 'Aufteilung · nach Platz',
      single: 'Einfach',
      forceClosed: 'Zwangsgeschlossen',
      tryAgain: 'Bitte versuchen Sie es erneut.',
      tabsSummary: (n: number, money: string) =>
        `${n} Rechnung${n === 1 ? '' : 'en'} · ${money} eingezogen`,
      closedAt: (time: string) => `Geschlossen ${time}`,
      roundsCount: (n: number) => `${n} Runde${n === 1 ? '' : 'n'}`,
      mixed: 'Gemischt',
      card: 'Karte',
      giftCard: 'Geschenkkarte',
    },
    bill: {
      title: 'Rechnung',
      paidInFull: 'Vollständig bezahlt',
      balanceDue: 'Ausstehender Saldo',
      subtotal: 'Zwischensumme',
      serviceCharge: 'Serviceggebühr',
      finishMeal: 'Beenden Sie die Mahlzeit vor der Rechnungsstellung',
      backToTab: 'Zurück zur Rechnung',
      settle: 'Begleichen',
      collectPayments: 'Zahlungen einziehen',
      takePayment: 'Eine Zahlung entgegennehmen',
      splitBill: 'Rechnung aufteilen',
      splitOptions: 'Gleichmäßig, nach Betrag oder nach Platz',
      takeFullPayment: 'Vollständige Zahlung entgegennehmen',
      paymentsTaken: 'Gezahlte Zahlungen',
      manage: 'Rechnung verwalten',
      viewActivity: 'Aktivität anzeigen',
      markBillRequested: 'Als angefordert markieren',
      moveTabAnother: 'Rechnung zu einen anderen Tisch verschieben',
      mergeAnother: 'Andere Rechnung zusammenführen',
      forceCloseWalkout: 'Erzwingen Sie die Schließung (Flucht / Complimentär)…',
      tabClosed: 'Rechnung geschlossen',
      tabClosedDesc:
        'Diese Rechnung ist beglichen und geschlossen. Die obige Zusammenfassung ist schreibgeschützt.',
      closeConfirm: 'Diese vollständig bezahlte Rechnung schließen?',
      closeTitle: 'Rechnung schließen',
      forceClosePrompt: 'Grund (Flucht, Complimentär, Fehler…) - in der Chronologie vermerkt',
      forceCloseTitle: 'Rechnung zwangsweise schließen',
      forceCloseDone: 'Rechnung zwangsweise geschlossen',
      noFreeTable: 'Kein freier Tisch zum Verschieben',
      moveTitle: 'Rechnung verschieben zu',
      noOtherTab: 'Keine andere offene Rechnung zum Zusammenführen',
      mergeTitle: 'Andere Rechnung in diesen zusammenführen',
      mergeDesc:
        'Die Runden des anderen Tabs werden hierher verschoben; es schließt als zusammengefügt.',
      markedBillRequested: 'Als angefordert markiert',
      roundsNotServed: (count: number, seqs: string) =>
        `Runde${count !== 1 ? 'n' : ''} ${seqs} ${count !== 1 ? 'sind' : 'ist'} noch nicht serviert`,
      finishMealDesc: (roundsText: string) =>
        `${roundsText}. Servieren oder stornieren Sie jede Runde auf der Rechnung und kommen Sie dann zurück, um zu begleichen.`,
      collectPaymentsFooter: (collected: number, total: number, amount: string) =>
        `${collected} von ${total} eingezogen · ${amount} übrig`,
      takePaymentFooter: (amount: string) => `${amount} ausstehend · bar oder Karte`,
      guestSuggested: (mode: string) => `Gast vorgeschlagen: ${mode}`,
      bySeatFooter: (n: number) => `Nach Platz (${n}), gleichmäßig oder nach Betrag`,
      takeFullPaymentFooter: (amount: string) => `${amount} · eine Zahlung`,
      paymentTipFooter: (status: string, tip: string) => `${status} · +${tip} Trinkgeld`,
      payStatus: {
        pendingCollection: 'Zahlung ausstehend',
        awaitingProof: 'Nachweis ausstehend',
        proofSubmitted: 'Nachweis eingereicht',
        processing: 'Wird verarbeitet',
        paid: 'Bezahlt',
        rejected: 'Abgelehnt',
        void: 'Storniert',
        refunded: 'Erstattet',
        partiallyRefunded: 'Teilw. erstattet',
      },
      movedTo: (label: string) => `Verschoben zu ${label}`,
      mergedWith: (label: string) => `${label} zusammengeführt`,
      billTitleFor: (label: string) => `Rechnung · ${label}`,
    },
    payment: {
      collect: 'Eine Anteil einziehen',
      takePayment: 'Eine Zahlung entgegennehmen',
      method: 'Methode',
      cash: 'Bargeld',
      cardTerminal: 'Karte / Terminal',
      amount: 'Betrag',
      tip: 'Trinkgeld',
      enterAmount: 'Geben Sie einen Zahlungsbetrag ein',
      shareCollected: 'Anteil eingezogen',
      paymentRecorded: 'Zahlung erfasst',
      shareOf: (i: number, total: number) => `Anteil ${i} von ${total}`,
      collectAmount: (amount: string) => `${amount} einziehen`,
      recordAmountPayment: (amount: string) => `Zahlung über ${amount} erfassen`,
    },
    workspace: {
      tables: 'Tische',
      floor: 'Grundriss',
      list: 'Liste',
      openTabTitle: 'Rechnung öffnen',
      noZone: 'Keine Zone',
      zoneFallback: 'Zone',
      openTabConfirm: (label: string) => `Neue Rechnung für ${label} öffnen?`,
      tabOpened: (label: string) => `Rechnung geöffnet · ${label}`,
      tabFallback: 'Tisch',
    },
    qrSheet: {
      title: 'QR-Code-Blatt',
      print: 'Drucken',
      noQR: 'Keine Tisch-QR-Codes',
      noQRDesc:
        'Fügen Sie Tische unter Einstellungen → Tische hinzu; jeder erhält automatisch einen QR-Code.',
      hint: 'Drucken Sie diese Seite aus, schneiden Sie entlang der Karten und platzieren Sie jeweils eine auf den Tischen.',
      noQRYet: 'Noch kein QR-Code:',
      reseeding:
        'Diese Tische benötigen einen QR-Token - Neuinitialisierung oder Speichern des Tisches weist einen zu.',
      tryAgain: 'Bitte versuchen Sie es erneut.',
      qrAlt: (label: string) => `QR für ${label}`,
    },
    timeline: {
      activity: 'Aktivität',
      noActivity: 'Noch keine Aktivität',
      noActivityDesc:
        'Jede Aktion auf dieser Rechnung - Bestellungen, Küche, Zahlungen - wird hier angezeigt.',
      tabOpened: 'Rechnung geöffnet',
      roundPlaced: 'Runde platziert',
      sentKitchen: 'An die Küche gesendet',
      roundReady: 'Runde bereit',
      roundServed: 'Runde serviert',
      roundCancelled: 'Runde storniert',
      itemVoided: 'Artikel storniert',
      itemRestored: 'Artikel wiederhergestellt',
      reservationAttached: 'Reservierung verbunden',
      serviceRequested: 'Service angefordert',
      serviceResolved: 'Service behoben',
      billRequested: 'Rechnung angefordert',
      paymentTaken: 'Zahlung erhalten',
      forceClosedTimeline: 'Zwangsgeschlossen',
      movedTable: 'Tisch verschoben',
      mergedAnother: 'In eine andere Rechnung zusammengefügt',
      tabClosed3: 'Rechnung geschlossen',
      seatedReservation: 'Von Reservierung platziert',
      guest: 'Gast',
      staff: 'Personal',
      system: 'System',
    },
    arrivals: {
      title: 'Erwartete Ankünfte',
      noArrivals: 'Keine erwarteten Ankünfte',
      noArrivalsDesc:
        'Die heutigen bevorstehenden Buchungen werden hier angezeigt, um sie mit einem Tippen zu platzieren.',
      overdue: 'Überfällig',
      seatTitle: 'Gast platzieren',
      seatConfirm: (name: string, n: number) => `${name} platzieren (Gruppe von ${n})?`,
      seatedToast: (name: string) => `${name} platziert`,
    },
  },

  waitlist: {
    title: 'Warteliste',
    partyOf: (partySize) => `Gruppe von ${partySize}`,
    addForm: {
      title: 'Laufkundschaft hinzufügen',
      partySize: 'Anzahl der Personen',
      guestName: 'Gast Name',
      guestNamePlaceholder: 'z.B. Sarah',
      phone: 'Telefon (optional)',
      phonePlaceholder: 'Um sie anzurufen, wenn ein Tisch frei ist',
      adding: 'Wird hinzugefügt…',
      addButton: 'Zur Warteliste hinzufügen',
    },
    validation: {
      nameRequired: 'Bitte geben Sie den Namen des Gastes ein.',
    },
    toasts: {
      added: (guestName, quotedWaitMinutes) =>
        `${guestName} hinzugefügt - geschätzte Wartezeit ${quotedWaitMinutes} Minuten`,
      marked_notified: (guestName) => `${guestName} wurde benachrichtigt`,
      could_not_update: 'Aktualisierung fehlgeschlagen.',
      no_free_tables: 'Derzeit keine freien Tische.',
      seated: (guestName) => `${guestName} platziert`,
      could_not_seat: 'Diese Gruppe konnte nicht platziert werden.',
      removed: (guestName) => `${guestName} entfernt`,
      could_not_remove: 'Entfernen fehlgeschlagen.',
      marked_noshow: (guestName) => `${guestName} als Nichterscheinung markiert`,
      could_not_add: 'Diese Gruppe konnte nicht hinzugefügt werden.',
    },
    actions: {
      seat: {
        label: (guestName, partySize) => `${guestName} platzieren (${partySize} Gäste)`,
        tableOption: (tableLabel, zoneLabelFormatted, seats) =>
          `${tableLabel}${zoneLabelFormatted} - ${seats} Plätze`,
      },
      seatButton: 'Platzieren',
      cancel: {
        confirm: (guestName) => `${guestName} von der Warteliste entfernen?`,
        title: 'Gruppe entfernen',
      },
      noShow: {
        confirm: (guestName) => `${guestName} als Nichterscheinung markieren?`,
        title: 'Nichterscheinung',
      },
      notify: 'Benachrichtigen',
      noshow: 'Nichterscheinung',
      remove: 'Entfernen',
    },
    error: {
      loading: 'Warteliste konnte nicht geladen werden',
    },
    empty: {
      title: 'Niemand wartet',
      description:
        'Wenn eine Gruppe reinkommt und kein Tisch frei ist, fügen Sie sie hier hinzu und nennen Sie die Wartezeit. Drücken Sie +.',
    },
    status: {
      notified: 'Benachrichtigt',
    },
  },

  shared: {
    restaurantNotFound: 'Dieses Restaurant existiert nicht mehr - wählen Sie ein anderes aus.',
    failedLoadRestaurantConfig: 'Fehler beim Laden der Restaurantkonfiguration.',
    unableToConnect: 'Verbindung nicht möglich. Bitte überprüfen Sie Ihre Verbindung.',
    retry: 'Erneut versuchen',
    chooseAnotherRestaurant: 'Wählen Sie ein anderes Restaurant',
    language: 'Sprache',
    empty: 'leer',
    noRestaurantsAvailable: 'Keine Restaurants verfügbar.',
    restaurant: 'Restaurant',
  },

  forms: {
    required: 'Dieses Feld ist erforderlich.',
    tooLong: (max) => `Höchstens ${max} Zeichen.`,
    invalidEmail: 'Gültige E-Mail wie hallo@restaurant.de eingeben.',
    invalid: 'Bitte diesen Wert prüfen.',
    invalidUrl: 'Gültige Webadresse eingeben.',
  },

  // Order label settings (create / rename / recolor the triage tag set).
  purge: {
    history: {
      pageTitle: 'Ausblende-Verlauf',
      couldntLoad: 'Verlauf konnte nicht geladen werden',
      empty: 'Noch nichts aufgeräumt',
      emptyWhy: 'Sobald etwas ausgeblendet wird — von Ihnen oder nachts — erscheint es hier.',
      footer: 'Aufbewahrt, damit Sie immer sehen, was ausgeblendet wurde und warum.',
      hidSummary: (what: string) => `${what} ausgeblendet`,
      orders: (n: number) => `${n.toLocaleString()} ${n === 1 ? 'Bestellung' : 'Bestellungen'}`,
      reservations: (n: number) =>
        `${n.toLocaleString()} ${n === 1 ? 'Reservierung' : 'Reservierungen'}`,
      statusLabel: {
        RUNNING: 'Läuft',
        COMPLETED: 'Fertig',
        PARTIAL: 'Nur teilweise',
        FAILED: 'Nicht beendet',
      },
      sourceLabel: {
        SCHEDULED: 'Nachts',
        MANUAL_RULE: 'Von Hand',
        MANUAL_CRITERIA: 'Von Hand',
        MANUAL_SELECTION: 'Von Hand',
      },
      detailTitle: 'Details zur Aufräumaktion',
      when: 'Wann',
      outcome: 'Ergebnis',
      hiddenCount: 'Ausgeblendete Einträge',
      startedBy: 'Gestartet',
      criteriaTitle: 'Wonach gesucht wurde',
      whatKind: 'Art',
      fromRule: 'Regel',
      olderThan: 'Älter als',
      tags: 'Tags',
      pickedByHand: 'Von Hand gewählt',
      criteriaFrozen: 'So gespeichert, wie es damals war — ein späteres Umbenennen ändert das nie.',
      skippedTitle: 'Unberührt gelassen',
      skippedFooter: 'Diese passten, waren aber geschützt. Nichts davon wurde ausgeblendet.',
      skipReason: {
        STILL_LIVE: 'Noch aktiv',
        CARRIES_MONEY: 'Betrifft Zahlungen',
        CONCURRENT_CHANGE: 'Während des Laufs geändert',
        CAP_REACHED: 'Zu viele auf einmal',
      },
      errorTitle: 'Was schiefging',
    },
    cleanupTitle: 'Jetzt aufräumen',
    cleanupIntro:
      'Blenden Sie viele alte, abgeschlossene Einträge auf einmal aus. Nichts wird gelöscht, aber ausgeblendete Bestellungen zählen nicht mehr in Ihren Umsatzberichten.',
    cleanupTagsTitle: 'Auf Tags beschränken',
    pickATagToCount: 'Wählen Sie mindestens ein Tag, um zu sehen, wie viele ausgeblendet würden.',
    cleanupSomeTags: 'Nur Einträge mit einem der obigen Tags werden einbezogen.',
    cleanupReassurance:
      'Nur abgeschlossene und stornierte Bestellungen kommen infrage. Eine Bestellung wird einbezogen, wenn keine Zahlung vorliegt, die Zahlung abgelehnt oder storniert wurde, sie abgeschlossen und bar bezahlt wurde, oder sie storniert und vollständig erstattet wurde.',
    working: 'Wird ausgeführt…',
    confirmTitle: 'Diese ausblenden?',
    zeroDayAutoTitle: 'Ab heute aufräumen?',
    zeroDayAutoBody:
      'Mit „Vor heute" und aktiver Automatik wird bei jedem geplanten Lauf jeder passende Eintrag älter als Mitternacht entfernt, auch von heute. Das lässt sich nicht rückgängig machen. Fortfahren?',
    autoTitle: 'Automatisch ausblenden',
    autoOnFooter:
      'Läuft nach dem Zeitplan in den erweiterten Einstellungen. Du kannst weiterhin jederzeit von Hand aufräumen.',
    pageTitle: 'Listen aufräumen',
    intro:
      'Alte abgeschlossene Einträge werden aus deinen Listen ausgeblendet, nicht gelöscht. Ausgeblendete Bestellungen zählen nicht mehr in deinen Umsatzberichten, und jedes Aufräumen, das du startest, steht im Ausblende-Verlauf.',
    couldntLoad: 'Aufräum-Einstellungen konnten nicht geladen werden',
    noAccess: 'Du hast keinen Zugriff auf diese Seite',
    couldNotSave: 'Konnte nicht gespeichert werden. Bitte erneut versuchen.',
    noLabels: 'Noch keine Tags angelegt.',
    pickATagFirst: 'Wähle mindestens ein Tag, bevor du dies einschaltest.',
    dayRequired: 'Mindestens ein Tag muss ausgewählt bleiben.',
    counting: 'Wird gezählt…',
    couldntCount: 'Zählen gerade nicht möglich. Verbindung prüfen und erneut versuchen.',
    seeThem: 'Anzeigen',
    close: 'Schließen',
    loadMore: 'Mehr laden',
    nothingToShow: 'Nichts anzuzeigen.',
    showingOf: (a: number, b: number) => `${a} von ${b.toLocaleString()} werden angezeigt.`,
    olderThanOption: (days: number) =>
      days === 0
        ? 'Vor heute'
        : days === 1
          ? '1 Tag'
          : days === 30
            ? '1 Monat'
            : days === 90
              ? '3 Monate'
              : days === 180
                ? '6 Monate'
                : '1 Jahr',
    advancedTitle: 'Erweiterte Einstellungen',
    advancedFooter:
      'Feineinstellung, wie das Alter gemessen wird und wann das nächtliche Aufräumen läuft.',
    advanced: {
      ageBasisLabel: 'Alter gezählt ab',
      ageBasisCreated: 'Erstellungszeitpunkt',
      ageBasisService: 'Servicezeit',
      matchLabel: 'Muss tragen',
      matchAny: 'Eines dieser Tags',
      matchAll: 'Alle diese Tags',
      kindLabel: 'Läuft',
      kindDaily: 'Täglich',
      kindWeekly: 'Wöchentlich',
      kindMonthly: 'Monatlich',
      weekdayLabel: 'Am',
      monthDayLabel: 'Am Tag',
      hourLabel: 'Um',
      hourOption: (h: number) => `${String(h).padStart(2, '0')}:00`,
      scheduleFooter:
        'Das nächtliche Aufräumen läuft zu dieser Zeit, in der lokalen Zeit deines Restaurants.',
    },
    managedInAdvanced: 'Von eigenen Regeln verwaltet',
    managedInAdvancedFooter: (n: number) =>
      `Für diese Liste ${n === 1 ? 'gibt es 1 eigene Regel' : `gibt es ${n} eigene Regeln`}, die nicht auf diesem Bildschirm erstellt ${n === 1 ? 'wurde' : 'wurden'}. Die Bedienelemente sind ausgeblendet, damit nicht unbemerkt nur eine davon geändert wird.`,
    orders: {
      confirmBody: (n: number) =>
        `${n.toLocaleString()} ${n === 1 ? 'Bestellung wird' : 'Bestellungen werden'} aus dieser Liste ausgeblendet und nicht mehr in Ihren Umsatzberichten gezählt.`,
      hideAction: (n: number) =>
        `${n.toLocaleString()} ${n === 1 ? 'Bestellung' : 'Bestellungen'} ausblenden`,
      hidden: (done: number, asked: number) =>
        done === asked
          ? `${done.toLocaleString()} ${done === 1 ? 'Bestellung' : 'Bestellungen'} ausgeblendet.`
          : `${done.toLocaleString()} von ${asked.toLocaleString()} ausgeblendet. Der Rest hat sich während der Auswahl geändert.`,
      title: 'Bestellungen',
      previewTitle: 'Bestellungen, die ausgeblendet würden',
      switchTitle: 'Bestellliste automatisch aufräumen',
      olderThanLabel: 'Abgeschlossene & stornierte Bestellungen ausblenden, älter als',
      wouldHide: (n: number) =>
        n === 0
          ? 'Aktuell nichts auszublenden.'
          : `Aktuell würden ${n.toLocaleString()} ${n === 1 ? 'Bestellung' : 'Bestellungen'} ausgeblendet.`,
    },
    reservations: {
      confirmBody: (n: number) =>
        `${n.toLocaleString()} ${n === 1 ? 'Reservierung wird' : 'Reservierungen werden'} aus dieser Liste ausgeblendet. Ihre Berichte ändern sich nicht.`,
      hideAction: (n: number) =>
        `${n.toLocaleString()} ${n === 1 ? 'Reservierung' : 'Reservierungen'} ausblenden`,
      hidden: (done: number, asked: number) =>
        done === asked
          ? `${done.toLocaleString()} ${done === 1 ? 'Reservierung' : 'Reservierungen'} ausgeblendet.`
          : `${done.toLocaleString()} von ${asked.toLocaleString()} ausgeblendet. Der Rest hat sich während der Auswahl geändert.`,
      title: 'Reservierungen',
      previewTitle: 'Reservierungen, die ausgeblendet würden',
      switchTitle: 'Reservierungsliste automatisch aufräumen',
      olderThanLabel: 'Abgeschlossene Reservierungen ausblenden, älter als',
      wouldHide: (n: number) =>
        n === 0
          ? 'Aktuell nichts auszublenden.'
          : `Aktuell würden ${n.toLocaleString()} ${n === 1 ? 'Reservierung' : 'Reservierungen'} ausgeblendet.`,
    },
  },
  labels: {
    none: 'Noch keine Labels.',
    setUp: 'Labels einrichten',
    couldNotAssign: 'Labels konnten nicht gespeichert werden. Bitte erneut versuchen.',
    more: (n: number) => `+${n}`,
    systemOwnedNote:
      'Dies ist ein integriertes Label. Du kannst es umbenennen oder umfärben, aber nicht löschen.',
    pageTitle: 'Labels',
    addLabel: 'Neues Label',
    editLabel: 'Label bearbeiten',
    nameLabel: 'Name',
    namePlaceholder: 'z. B. VIP',
    nameRequired: 'Bitte einen Label-Namen eingeben.',
    colorLabel: 'Farbe',
    customColor: 'Eigene Farbe',
    preview: 'Vorschau',
    labelAdded: 'Label hinzugefügt',
    labelUpdated: 'Label aktualisiert',
    labelDeleted: 'Label gelöscht',
    deleteTitle: 'Label löschen',
    deleteConfirmation: (name: string) =>
      `„${name}“ löschen? Es wird von allen Bestellungen entfernt.`,
    couldNotSave: 'Label konnte nicht gespeichert werden.',
    couldNotDelete: 'Label konnte nicht gelöscht werden.',
    couldntLoadLabels: 'Labels konnten nicht geladen werden',
    noLabelsTitle: 'Noch keine Labels',
    noLabelsDescription:
      'Lege Labels wie „VIP“ oder „Reklamation“ an und tippe sie auf eine Bestellung, um das Team zu informieren.',
    listFooter:
      'Mitarbeitende können diese auf jede Online-Bestellung tippen. Beim Löschen wird das Label von allen Bestellungen entfernt.',
    cancel: 'Abbrechen',
  },
  suspension: {
    heading: 'Dieses Restaurant wurde gesperrt',
    body: 'Der Zugang zur App ist vorübergehend gesperrt. Bitte wenden Sie sich an den Support, um ihn wiederherzustellen.',
    reasonLabel: 'Grund',
    contactLabel: 'Support',
    whatsApp: 'Per WhatsApp schreiben',
    checkAgain: 'Erneut prüfen',
  },
  voiceInput: {
    start: 'Diktieren',
    stop: 'Diktat beenden',
    recordingOnly: 'Aufnahme läuft – der Text erscheint, sobald Sie stoppen.',
    permissionDenied:
      'Der Mikrofonzugriff ist aus. Erlauben Sie ihn in den Geräte- oder Browsereinstellungen, um zu diktieren.',
    noMicrophone: 'Auf diesem Gerät wurde kein Mikrofon gefunden.',
    unsupported: 'Diktieren ist auf diesem Gerät nicht verfügbar.',
    failed: 'Ihre Sprache konnte nicht in Text umgewandelt werden. Bitte erneut versuchen.',
  },
};
